// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/images/bg-1.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/images/repeat_background_horizontal.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#simple-line-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.green-text {
  color: #94BA2E !important;
}
.hidden {
  display: none;
}
.error-text {
  color: #e53935;
}
.error-text ul li {
  margin-left: 1.2em;
  list-style-type: initial;
}
body {
  letter-spacing: 0.015em;
  -webkit-font-smoothing: antialiased;
}
em {
  color: #d4d2d5;
}
th {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.54);
}
td,
th {
  padding: 18px;
}
.section-header {
  margin-top: 0;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
}
.item-icon {
  position: relative;
}
.item-icon > i {
  position: absolute;
  top: 0;
}
.item-icon > div,
.item-icon > div.row {
  margin-left: 35px;
}
.item-icon > div > label,
.item-icon > div.row > label {
  display: block;
  font-size: inherit;
}
body,
#react-root {
  overflow: hidden;
}
.mainSubWrapper {
  display: flex;
}
.mainSubWrapper > div {
  flex-grow: 1;
}
.mainSubWrapper > aside {
  flex-shrink: 0;
}
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.app > header {
  display: flex;
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: white;
  color: #3C4144;
}
.app > header a.logo {
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  background: #3B2269;
}
.app > header form[role="search"] {
  flex: 1;
  margin: 17px 25px 0;
}
.app > header form[role="search"] .icon.input i.icon {
  opacity: 1;
  color: #788188;
}
.app > header form[role="search"] .ui.input input {
  line-height: normal;
}
.app nav.ui.vertical.menu {
  width: 60px;
  top: 60px;
  height: 100%;
}
.app nav.ui.vertical.menu .item {
  padding-left: 0;
  padding-right: 0;
  height: 60px;
  font-size: 20px;
  text-align: center;
  transition: opacity 0.3s;
}
.app nav.ui.vertical.menu .item:not(.active) {
  opacity: 0.5;
}
.app nav.ui.vertical.menu .item:hover {
  opacity: 1;
}
.app nav.ui.vertical.menu .item > .submenu-icon {
  font-size: 12px;
  position: absolute;
  right: 0;
  line-height: 40px;
  top: 15%;
}
.app nav.ui.vertical.menu .item.support {
  position: fixed;
  bottom: 0;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.07);
}
.app nav.ui.vertical.menu .item.dropdown:not(.hover) > .menu {
  display: none;
}
.app nav.ui.vertical.menu .item.dropdown:hover > .menu {
  display: block;
}
.app nav.ui.vertical.menu .item.dropdown > .menu {
  background: transparent;
  position: absolute;
  transition: transform 0.15s 0.7s ease, opacity 0.15s 0.7s ease, -webkit-transform 0.15s 0.7s ease;
  padding-left: 6px;
  z-index: 1901;
}
.app nav.ui.vertical.menu .dropdown-menu {
  background: black;
  padding: 0.833em 1em;
}
.app nav.ui.vertical.menu .dropdown-menu--item {
  font-size: 1rem;
  margin: 0;
  height: auto;
  text-align: initial;
  padding: 10px 0;
}
.app > .contentContainer > div {
  flex: 1;
  display: flex;
  margin: 60px 0 0 60px;
}
.app main,
.app main > div,
.app aside {
  height: calc(100vh -  60px);
}
.app main > div {
  max-width: calc(100vw -  60px);
  flex: 1;
  width: 100%;
}
.app main > div div.padding {
  padding: 30px;
}
.app main > div div.centered {
  text-align: center;
  color: red;
}
.app main > div div.container {
  width: auto;
  padding: 0 30px 30px;
}
.app main > div,
.app aside {
  overflow: auto;
}
.app main > div .content,
.app aside .content {
  min-height: calc(100% -  60px + 1px);
}
.app main > div .content.ui.segment,
.app aside .content.ui.segment {
  margin-bottom: 0;
}
.app main > div > footer,
.app aside > footer {
  height: 60px;
}
.app main > div > footer.ui.segment,
.app aside > footer.ui.segment {
  margin-top: 0;
  box-shadow: none;
  margin-bottom: 0;
}
.app main > div > footer > div:first-child,
.app aside > footer > div:first-child,
.app main > div > footer > div:last-child,
.app aside > footer > div:last-child {
  flex-basis: 30%;
  white-space: nowrap;
}
.app main {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.app main .btn-floating.add {
  position: absolute;
  right: 40px;
  top: 20px;
  background-color: #483074;
}
.app main ul.dropdown-content {
  width: 200px !important;
}
.app main ul.dropdown-content a {
  color: #3FA2F7;
  font-size: 14px;
  font-weight: 500;
}
.app main ul.dropdown-content a i {
  position: relative;
  top: 6px;
  margin-right: 0.5em;
  color: #cccccc;
}
.app main footer.ui.segment {
  height: 61px;
  border-top: 1px solid #F2F4F8;
  background-color: #f9fafc;
}
.app main footer .ui.basic.button,
.app main footer .ui.basic.button:hover,
.app main footer .ui.basic.button:focus {
  box-shadow: none !important;
}
.app main > div {
  height: calc(100vh -  60px);
}
.app main > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
.app main + aside {
  padding-bottom: 60px;
}
.app main > div > footer.ui.segment,
.app main.ShipmentRequest footer.ui.segment,
.app main + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
.app main + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
.app main footer,
.app aside footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0;
}
.app main footer .button,
.app aside footer .button {
  margin-left: 10px;
  line-height: 10px;
}
.app main footer .button.basic,
.app aside footer .button.basic {
  color: rgba(0, 0, 0, 0.4) !important;
}
.app main footer .button.basic:hover,
.app aside footer .button.basic:hover {
  color: rgba(0, 0, 0, 0.5) !important;
  background: transparent !important;
}
.app main footer .button.basic:active,
.app aside footer .button.basic:active {
  box-shadow: none;
}
.app main footer .status,
.app aside footer .status {
  text-align: right;
  margin: 0 10px 0 0;
  font-size: 12px;
  color: rgba(60, 65, 68, 0.6);
}
.app aside {
  width: 0;
  -webkit-font-smoothing: antialiased;
  background-color: #E9EDF4;
}
.app aside.expanded {
  min-width: 360px;
  width: 25vw;
}
.app aside.minimized {
  width: 60px;
  min-width: 0;
  transition: width 600ms ease-out;
}
.app aside h1 {
  margin-bottom: 0.5rem;
  font-size: 20px;
}
.app aside h4 {
  margin: 0 0 5px;
  font-size: 16px;
}
.app aside h4 + .sub {
  font-size: 13px;
}
.app aside h5 {
  margin: 2.85em 0 1.12em;
  font-size: inherit;
  opacity: 0.4;
  font-weight: 600;
}
.app aside h5:first-child {
  margin-top: 0;
}
.app aside > .ui.very.padded.segment {
  padding: 60px;
}
.app aside .meta {
  opacity: 0.5;
}
.app aside .item-icon {
  margin: 2rem 0;
  line-height: 1.8;
}
.app aside .item-icon i {
  top: 1px;
}
.app aside .item-icon div {
  margin-left: 40px;
}
.app aside .item-icon + .item-icon {
  margin-top: 2.5rem;
}
.app aside footer {
  justify-content: flex-end;
}
.app aside footer.ui.segment {
  background-color: #f4f6fa;
}
@media all and (max-height: 799px) {
  .app main,
  .app main > .contentContainer,
  .app aside {
    overflow: visible;
    height: auto;
    min-height: calc(100vh -  60px);
  }
  .app > .contentContainer {
    overflow: auto;
    height: 100vh;
  }
  .app aside > .content > div {
    min-height: calc(100% -  60px);
  }
}
.pusher > .ui.sidebar {
  background-color: #E9EDF4;
}
.pushable > .ui.sidebar {
  background-color: #E9EDF4;
}
.register.container {
  display: flex;
  justify-content: stretch;
  height: 100%;
}
.register.container main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #483074;
  padding: 60px;
  color: white;
}
@media (min-width: 701px) and (max-width: 850px) {
  .register.container main {
    width: 70%;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .register.container main {
    width: 60%;
  }
}
@media (min-width: 1001px) and (max-width: 1200px) {
  .register.container main {
    width: 50%;
  }
}
@media (min-width: 1201px) {
  .register.container main {
    width: 40%;
  }
}
.register.container main > * {
  flex: 1 0 auto;
  max-width: 400px;
}
.register.container main .ui.image.logo {
  width: 250px;
  margin-bottom: 30px;
  margin-left: -15px;
}
.register.container aside {
  flex: 1 0 auto;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}
.register.container .ui.form .field label {
  text-transform: uppercase;
  color: white;
}
.register.container .ui.form .field input {
  background: rgba(255, 255, 255, 0.2);
  border-color: transparent;
  color: black;
}
.register.container .ui.form .fields label {
  text-transform: uppercase;
  color: white;
}
.register.container .ui.form .fields .field .checkbox label {
  text-transform: none;
}
.main-fixed-footer > div {
  height: calc(100vh -  60px);
}
.main-fixed-footer > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
.main-fixed-footer + aside {
  padding-bottom: 60px;
}
.main-fixed-footer > div > footer.ui.segment,
.main-fixed-footer.ShipmentRequest footer.ui.segment,
.main-fixed-footer + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
.main-fixed-footer + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
.main-fixed-footer-and-toolbar > div > div {
  height: calc(100% -  60px + 60px);
  min-height: calc(100% -  60px + 60px);
}
@media all and (max-height: 799px) {
  .aside-autohide-footer + aside footer.ui.segment {
    display: none;
  }
}
main .form h1.ui.header {
  color: #788188;
}
main .form .icon-header {
  display: flex;
}
main .form .icon-header .circle.icon {
  margin-right: 10px;
}
main .form .icon-header svg {
  flex: 1;
}
.semantic-select .ui.dropdown {
  height: 48px;
}
.ui.dropdown.dropdown .menu > .input {
  width: auto !important;
}
/*
* Font Face
*/
@font-face {
  font-family: 'simple-line-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
/*
 Use the following code if you want to have a class per icon.
 Instead of a list of all class selectors, you can use the generic [class*="icon-"] selector,
 but it's slower.
*/
.icon-user,
.icon-people,
.icon-user-female,
.icon-user-follow,
.icon-user-following,
.icon-user-unfollow,
.icon-login,
.icon-logout,
.icon-emotsmile,
.icon-phone,
.icon-call-end,
.icon-call-in,
.icon-call-out,
.icon-map,
.icon-location-pin,
.icon-direction,
.icon-directions,
.icon-compass,
.icon-layers,
.icon-menu,
.icon-list,
.icon-options-vertical,
.icon-options,
.icon-arrow-down,
.icon-arrow-left,
.icon-arrow-right,
.icon-arrow-up,
.icon-arrow-up-circle,
.icon-arrow-left-circle,
.icon-arrow-right-circle,
.icon-arrow-down-circle,
.icon-check,
.icon-clock,
.icon-plus,
.icon-minus,
.icon-close,
.icon-event,
.icon-exclamation,
.icon-organization,
.icon-trophy,
.icon-screen-smartphone,
.icon-screen-desktop,
.icon-plane,
.icon-notebook,
.icon-mustache,
.icon-mouse,
.icon-magnet,
.icon-energy,
.icon-disc,
.icon-cursor,
.icon-cursor-move,
.icon-crop,
.icon-chemistry,
.icon-speedometer,
.icon-shield,
.icon-screen-tablet,
.icon-magic-wand,
.icon-hourglass,
.icon-graduation,
.icon-ghost,
.icon-game-controller,
.icon-fire,
.icon-eyeglass,
.icon-envelope-open,
.icon-envelope-letter,
.icon-bell,
.icon-badge,
.icon-anchor,
.icon-wallet,
.icon-vector,
.icon-speech,
.icon-puzzle,
.icon-printer,
.icon-present,
.icon-playlist,
.icon-pin,
.icon-picture,
.icon-handbag,
.icon-globe-alt,
.icon-globe,
.icon-folder-alt,
.icon-folder,
.icon-film,
.icon-feed,
.icon-drop,
.icon-drawer,
.icon-docs,
.icon-doc,
.icon-diamond,
.icon-cup,
.icon-calculator,
.icon-bubbles,
.icon-briefcase,
.icon-book-open,
.icon-basket-loaded,
.icon-basket,
.icon-bag,
.icon-action-undo,
.icon-action-redo,
.icon-wrench,
.icon-umbrella,
.icon-trash,
.icon-tag,
.icon-support,
.icon-frame,
.icon-size-fullscreen,
.icon-size-actual,
.icon-shuffle,
.icon-share-alt,
.icon-share,
.icon-rocket,
.icon-question,
.icon-pie-chart,
.icon-pencil,
.icon-note,
.icon-loop,
.icon-home,
.icon-grid,
.icon-graph,
.icon-microphone,
.icon-music-tone-alt,
.icon-music-tone,
.icon-earphones-alt,
.icon-earphones,
.icon-equalizer,
.icon-like,
.icon-dislike,
.icon-control-start,
.icon-control-rewind,
.icon-control-play,
.icon-control-pause,
.icon-control-forward,
.icon-control-end,
.icon-volume-1,
.icon-volume-2,
.icon-volume-off,
.icon-calendar,
.icon-bulb,
.icon-chart,
.icon-ban,
.icon-bubble,
.icon-camrecorder,
.icon-camera,
.icon-cloud-download,
.icon-cloud-upload,
.icon-envelope,
.icon-eye,
.icon-flag,
.icon-heart,
.icon-info,
.icon-key,
.icon-link,
.icon-lock,
.icon-lock-open,
.icon-magnifier,
.icon-magnifier-add,
.icon-magnifier-remove,
.icon-paper-clip,
.icon-paper-plane,
.icon-power,
.icon-refresh,
.icon-reload,
.icon-settings,
.icon-star,
.icon-symbol-female,
.icon-symbol-male,
.icon-target,
.icon-credit-card,
.icon-paypal,
.icon-social-tumblr,
.icon-social-twitter,
.icon-social-facebook,
.icon-social-instagram,
.icon-social-linkedin,
.icon-social-pinterest,
.icon-social-github,
.icon-social-google,
.icon-social-reddit,
.icon-social-skype,
.icon-social-dribbble,
.icon-social-behance,
.icon-social-foursqare,
.icon-social-soundcloud,
.icon-social-spotify,
.icon-social-stumbleupon,
.icon-social-youtube,
.icon-social-dropbox,
.icon-social-vkontakte,
.icon-social-steam {
  font-family: 'simple-line-icons';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-user:before {
  content: "\\e005";
}
.icon-people:before {
  content: "\\e001";
}
.icon-user-female:before {
  content: "\\e000";
}
.icon-user-follow:before {
  content: "\\e002";
}
.icon-user-following:before {
  content: "\\e003";
}
.icon-user-unfollow:before {
  content: "\\e004";
}
.icon-login:before {
  content: "\\e066";
}
.icon-logout:before {
  content: "\\e065";
}
.icon-emotsmile:before {
  content: "\\e021";
}
.icon-phone:before {
  content: "\\e600";
}
.icon-call-end:before {
  content: "\\e048";
}
.icon-call-in:before {
  content: "\\e047";
}
.icon-call-out:before {
  content: "\\e046";
}
.icon-map:before {
  content: "\\e033";
}
.icon-location-pin:before {
  content: "\\e096";
}
.icon-direction:before {
  content: "\\e042";
}
.icon-directions:before {
  content: "\\e041";
}
.icon-compass:before {
  content: "\\e045";
}
.icon-layers:before {
  content: "\\e034";
}
.icon-menu:before {
  content: "\\e601";
}
.icon-list:before {
  content: "\\e067";
}
.icon-options-vertical:before {
  content: "\\e602";
}
.icon-options:before {
  content: "\\e603";
}
.icon-arrow-down:before {
  content: "\\e604";
}
.icon-arrow-left:before {
  content: "\\e605";
}
.icon-arrow-right:before {
  content: "\\e606";
}
.icon-arrow-up:before {
  content: "\\e607";
}
.icon-arrow-up-circle:before {
  content: "\\e078";
}
.icon-arrow-left-circle:before {
  content: "\\e07a";
}
.icon-arrow-right-circle:before {
  content: "\\e079";
}
.icon-arrow-down-circle:before {
  content: "\\e07b";
}
.icon-check:before {
  content: "\\e080";
}
.icon-clock:before {
  content: "\\e081";
}
.icon-plus:before {
  content: "\\e095";
}
.icon-minus:before {
  content: "\\e615";
}
.icon-close:before {
  content: "\\e082";
}
.icon-event:before {
  content: "\\e619";
}
.icon-exclamation:before {
  content: "\\e617";
}
.icon-organization:before {
  content: "\\e616";
}
.icon-trophy:before {
  content: "\\e006";
}
.icon-screen-smartphone:before {
  content: "\\e010";
}
.icon-screen-desktop:before {
  content: "\\e011";
}
.icon-plane:before {
  content: "\\e012";
}
.icon-notebook:before {
  content: "\\e013";
}
.icon-mustache:before {
  content: "\\e014";
}
.icon-mouse:before {
  content: "\\e015";
}
.icon-magnet:before {
  content: "\\e016";
}
.icon-energy:before {
  content: "\\e020";
}
.icon-disc:before {
  content: "\\e022";
}
.icon-cursor:before {
  content: "\\e06e";
}
.icon-cursor-move:before {
  content: "\\e023";
}
.icon-crop:before {
  content: "\\e024";
}
.icon-chemistry:before {
  content: "\\e026";
}
.icon-speedometer:before {
  content: "\\e007";
}
.icon-shield:before {
  content: "\\e00e";
}
.icon-screen-tablet:before {
  content: "\\e00f";
}
.icon-magic-wand:before {
  content: "\\e017";
}
.icon-hourglass:before {
  content: "\\e018";
}
.icon-graduation:before {
  content: "\\e019";
}
.icon-ghost:before {
  content: "\\e01a";
}
.icon-game-controller:before {
  content: "\\e01b";
}
.icon-fire:before {
  content: "\\e01c";
}
.icon-eyeglass:before {
  content: "\\e01d";
}
.icon-envelope-open:before {
  content: "\\e01e";
}
.icon-envelope-letter:before {
  content: "\\e01f";
}
.icon-bell:before {
  content: "\\e027";
}
.icon-badge:before {
  content: "\\e028";
}
.icon-anchor:before {
  content: "\\e029";
}
.icon-wallet:before {
  content: "\\e02a";
}
.icon-vector:before {
  content: "\\e02b";
}
.icon-speech:before {
  content: "\\e02c";
}
.icon-puzzle:before {
  content: "\\e02d";
}
.icon-printer:before {
  content: "\\e02e";
}
.icon-present:before {
  content: "\\e02f";
}
.icon-playlist:before {
  content: "\\e030";
}
.icon-pin:before {
  content: "\\e031";
}
.icon-picture:before {
  content: "\\e032";
}
.icon-handbag:before {
  content: "\\e035";
}
.icon-globe-alt:before {
  content: "\\e036";
}
.icon-globe:before {
  content: "\\e037";
}
.icon-folder-alt:before {
  content: "\\e039";
}
.icon-folder:before {
  content: "\\e089";
}
.icon-film:before {
  content: "\\e03a";
}
.icon-feed:before {
  content: "\\e03b";
}
.icon-drop:before {
  content: "\\e03e";
}
.icon-drawer:before {
  content: "\\e03f";
}
.icon-docs:before {
  content: "\\e040";
}
.icon-doc:before {
  content: "\\e085";
}
.icon-diamond:before {
  content: "\\e043";
}
.icon-cup:before {
  content: "\\e044";
}
.icon-calculator:before {
  content: "\\e049";
}
.icon-bubbles:before {
  content: "\\e04a";
}
.icon-briefcase:before {
  content: "\\e04b";
}
.icon-book-open:before {
  content: "\\e04c";
}
.icon-basket-loaded:before {
  content: "\\e04d";
}
.icon-basket:before {
  content: "\\e04e";
}
.icon-bag:before {
  content: "\\e04f";
}
.icon-action-undo:before {
  content: "\\e050";
}
.icon-action-redo:before {
  content: "\\e051";
}
.icon-wrench:before {
  content: "\\e052";
}
.icon-umbrella:before {
  content: "\\e053";
}
.icon-trash:before {
  content: "\\e054";
}
.icon-tag:before {
  content: "\\e055";
}
.icon-support:before {
  content: "\\e056";
}
.icon-frame:before {
  content: "\\e038";
}
.icon-size-fullscreen:before {
  content: "\\e057";
}
.icon-size-actual:before {
  content: "\\e058";
}
.icon-shuffle:before {
  content: "\\e059";
}
.icon-share-alt:before {
  content: "\\e05a";
}
.icon-share:before {
  content: "\\e05b";
}
.icon-rocket:before {
  content: "\\e05c";
}
.icon-question:before {
  content: "\\e05d";
}
.icon-pie-chart:before {
  content: "\\e05e";
}
.icon-pencil:before {
  content: "\\e05f";
}
.icon-note:before {
  content: "\\e060";
}
.icon-loop:before {
  content: "\\e064";
}
.icon-home:before {
  content: "\\e069";
}
.icon-grid:before {
  content: "\\e06a";
}
.icon-graph:before {
  content: "\\e06b";
}
.icon-microphone:before {
  content: "\\e063";
}
.icon-music-tone-alt:before {
  content: "\\e061";
}
.icon-music-tone:before {
  content: "\\e062";
}
.icon-earphones-alt:before {
  content: "\\e03c";
}
.icon-earphones:before {
  content: "\\e03d";
}
.icon-equalizer:before {
  content: "\\e06c";
}
.icon-like:before {
  content: "\\e068";
}
.icon-dislike:before {
  content: "\\e06d";
}
.icon-control-start:before {
  content: "\\e06f";
}
.icon-control-rewind:before {
  content: "\\e070";
}
.icon-control-play:before {
  content: "\\e071";
}
.icon-control-pause:before {
  content: "\\e072";
}
.icon-control-forward:before {
  content: "\\e073";
}
.icon-control-end:before {
  content: "\\e074";
}
.icon-volume-1:before {
  content: "\\e09f";
}
.icon-volume-2:before {
  content: "\\e0a0";
}
.icon-volume-off:before {
  content: "\\e0a1";
}
.icon-calendar:before {
  content: "\\e075";
}
.icon-bulb:before {
  content: "\\e076";
}
.icon-chart:before {
  content: "\\e077";
}
.icon-ban:before {
  content: "\\e07c";
}
.icon-bubble:before {
  content: "\\e07d";
}
.icon-camrecorder:before {
  content: "\\e07e";
}
.icon-camera:before {
  content: "\\e07f";
}
.icon-cloud-download:before {
  content: "\\e083";
}
.icon-cloud-upload:before {
  content: "\\e084";
}
.icon-envelope:before {
  content: "\\e086";
}
.icon-eye:before {
  content: "\\e087";
}
.icon-flag:before {
  content: "\\e088";
}
.icon-heart:before {
  content: "\\e08a";
}
.icon-info:before {
  content: "\\e08b";
}
.icon-key:before {
  content: "\\e08c";
}
.icon-link:before {
  content: "\\e08d";
}
.icon-lock:before {
  content: "\\e08e";
}
.icon-lock-open:before {
  content: "\\e08f";
}
.icon-magnifier:before {
  content: "\\e090";
}
.icon-magnifier-add:before {
  content: "\\e091";
}
.icon-magnifier-remove:before {
  content: "\\e092";
}
.icon-paper-clip:before {
  content: "\\e093";
}
.icon-paper-plane:before {
  content: "\\e094";
}
.icon-power:before {
  content: "\\e097";
}
.icon-refresh:before {
  content: "\\e098";
}
.icon-reload:before {
  content: "\\e099";
}
.icon-settings:before {
  content: "\\e09a";
}
.icon-star:before {
  content: "\\e09b";
}
.icon-symbol-female:before {
  content: "\\e09c";
}
.icon-symbol-male:before {
  content: "\\e09d";
}
.icon-target:before {
  content: "\\e09e";
}
.icon-credit-card:before {
  content: "\\e025";
}
.icon-paypal:before {
  content: "\\e608";
}
.icon-social-tumblr:before {
  content: "\\e00a";
}
.icon-social-twitter:before {
  content: "\\e009";
}
.icon-social-facebook:before {
  content: "\\e00b";
}
.icon-social-instagram:before {
  content: "\\e609";
}
.icon-social-linkedin:before {
  content: "\\e60a";
}
.icon-social-pinterest:before {
  content: "\\e60b";
}
.icon-social-github:before {
  content: "\\e60c";
}
.icon-social-google:before {
  content: "\\e60d";
}
.icon-social-reddit:before {
  content: "\\e60e";
}
.icon-social-skype:before {
  content: "\\e60f";
}
.icon-social-dribbble:before {
  content: "\\e00d";
}
.icon-social-behance:before {
  content: "\\e610";
}
.icon-social-foursqare:before {
  content: "\\e611";
}
.icon-social-soundcloud:before {
  content: "\\e612";
}
.icon-social-spotify:before {
  content: "\\e613";
}
.icon-social-stumbleupon:before {
  content: "\\e614";
}
.icon-social-youtube:before {
  content: "\\e008";
}
.icon-social-dropbox:before {
  content: "\\e00c";
}
.icon-social-vkontakte:before {
  content: "\\e618";
}
.icon-social-steam:before {
  content: "\\e620";
}
.icon-sections section.basic {
  margin: 0;
}
.icon-sections section.ui.segment {
  border-radius: 2px;
}
.icon-sections section em,
.icon-sections section .empty {
  margin: 1em 0 1.5em;
}
.icon-sections section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
.icon-sections section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
.icon-sections section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
.icon-sections section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
.icon-sections section > .list > .item > .content {
  width: 100%;
}
.icon-sections section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
table.dataTable {
  width: 100%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  border: none;
}
table.dataTable thead th {
  white-space: nowrap;
}
table.dataTable thead th.sorting_asc,
table.dataTable thead th.sorting_desc {
  color: #6d7173;
}
table.dataTable tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
table.dataTable tbody tr:hover {
  background-color: #f7f8fa;
}
table.dataTable td .ui.circular.label {
  box-sizing: border-box;
}
table.dataTable.overview th:first-child,
table.dataTable.overview td:first-child {
  padding-left: 30px;
  padding-right: 30px;
}
table.dataTable.overview th:nth-child(n+2):nth-last-child(n+2),
table.dataTable.overview td:nth-child(n+2):nth-last-child(n+2) {
  padding-right: 30px;
}
table.dataTable.overview th:last-child,
table.dataTable.overview td:last-child {
  padding-left: 30px;
  padding-right: 30px;
}
/* Sorting styles */
/*
  thead {
    .sorting,
    .sorting_asc,
    .sorting_desc {
      &::after {
        position: relative;
        top: 1px;
        left: .6em;
        content: "\\f0d7";
        opacity: 0;
        transition: transform .25s,opacity .25s;

        font-family: Icons;
        display: inline-block;
        -webkit-font-smoothing: antialiased;
        backface-visibility: hidden;
      }
    }

    .sorting_asc,
    .sorting_desc {
      color: rgba( 0, 0, 0, .87 );

      &::after {
        opacity: 1;
      }
    }

    .sorting_desc::after {
      transform: rotate(180deg);
    }
  }*/
table.ui.table,
tabletable.dataTable {
  /*
  &.selectable {
    tbody tr {
      cursor: pointer;
    }
  }*/
}
table.ui.table.nowrap th,
table.ui.table.nowrap td,
tabletable.dataTable.nowrap th,
tabletable.dataTable.nowrap td {
  white-space: nowrap;
}
.app footer .dataTables_paginate .ui.pagination.menu {
  background: transparent;
  border: none;
  box-shadow: inset 0 0 0 1px #ddd;
}
.app footer .dataTables_paginate .ui.pagination.menu .item {
  font-size: 11px;
  line-height: 1;
  color: #3e8acc;
}
.app footer .dataTables_paginate .ui.pagination.menu .item.previous,
.app footer .dataTables_paginate .ui.pagination.menu .item.next {
  font-size: 13px;
}
.app footer .dataTables_paginate .ui.pagination.menu .active.item {
  background-color: #428bca;
  color: white;
}
span.details.tooltip {
  display: inline-block;
  cursor: pointer;
}
span.details.tooltip:after {
  min-width: 20em;
  white-space: pre-line;
}
span.details.tooltip[data-position="bottom center"]:before {
  margin-left: -8px;
}
.s-alert-box {
  z-index: 9999 !important;
}
.message.s-alert-box {
  position: fixed !important;
}
.message.s-alert-box {
  font: inherit;
  min-width: 200px;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.22) inset, 0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15);
  float: right;
  line-height: 1.4285em;
}
.s-alert-top-right {
  margin-right: 5px;
  margin-top: 10px;
  z-index: 9998 !important;
}
.starRating {
  width: 89px;
  float: left;
}
.ratingWrapper {
  width: 130px;
  padding-left: 10px;
}
.starRatingProfile {
  position: relative;
}
.starRatingProfile .ratingWrapper {
  position: absolute;
  right: 0;
  top: -60px;
}
.starRatingOverview > div {
  float: left;
  width: 50%;
}
.app header > a.button {
  font-size: 16px;
  margin: 18px 20px;
  color: #788188;
}
.app header.view {
  height: 60px;
  padding-left: 25px;
  padding-right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.app header.view.ui.segment {
  margin-bottom: 0;
}
.app header.view > .close {
  background: #F2F4F8;
}
header > .item {
  position: absolute;
  top: -1px;
  height: 60px;
  background: white;
  z-index: 1;
}
header > .menu .item::before {
  width: 0 !important;
}
header > .item {
  left: 60px;
  width: calc(100% -  60px);
  padding-left: 25px;
  font-size: 13px;
  letter-spacing: -0.0015em;
  display: flex;
  align-items: center;
  pointer-events: none;
  transition: opacity 0.4s;
}
header > .item > .main,
header > .item > .aside {
  display: flex;
}
header > .item > .main > div + div,
header > .item > .aside > div + div {
  margin-left: 25px;
}
header > .item > .main .meta,
header > .item > .aside .meta {
  margin-left: "5px";
  color: rgba(60, 65, 68, 0.6);
}
header > .item > .main .meta.right,
header > .item > .aside .meta.right {
  margin-left: auto;
  margin-right: 25px;
}
header > .item > .main .meta .important,
header > .item > .aside .meta .important {
  color: #3FA2F7;
}
header > .item > .main {
  flex: 1;
  padding-bottom: 2px;
}
header > .item > .aside {
  min-width: 360px;
  width: 25vw;
  padding: 0 25px;
}
header > .item + div,
header > .item + div + div {
  z-index: 1;
}
header:hover > .item,
header.searching > .item {
  opacity: 0;
}
.app > header .dropdown.notifications.unread {
  pointer-events: auto;
}
.app > header .dropdown.notifications.unread .icon.button {
  opacity: 0.5;
}
.app > header .dropdown.notifications .item.icon.counter {
  padding: 2px !important;
  background: white;
}
.app > header .dropdown.notifications .menu {
  max-width: 280px;
  min-width: 280px !important;
}
.app > header .dropdown.notifications .menu > div:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.app > header .dropdown.notifications .menu > div:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.app > header .dropdown.notifications .menu .notifications {
  max-height: 50vh;
  overflow: auto;
}
.app > header .dropdown.notifications .item.header {
  margin: 0;
  padding: 1.2rem 1.13333333rem 1rem !important;
  pointer-events: none;
  background: white;
  text-align: center;
  color: #696e71;
  text-transform: none;
  letter-spacing: -0.01em;
  font-size: 14px;
  border-bottom: 1px solid #dae2e7;
}
.app > header .dropdown.notifications .item {
  padding: 0.9rem 1.2rem !important;
  background: #e9eff2;
  cursor: pointer;
}
.app > header .dropdown.notifications .item.read {
  background: #f4f7f9;
}
.app > header .dropdown.notifications .item:hover {
  background: #eff3f5;
}
.app > header .dropdown.notifications .item:hover .remove {
  opacity: 0.5;
}
.app > header .dropdown.notifications .item:hover .remove:hover {
  opacity: 1;
}
.app > header .dropdown.notifications .item:hover .remove + .date {
  opacity: 0;
}
.app > header .dropdown.notifications .item .notification {
  position: relative;
  white-space: normal;
  color: rgba(60, 65, 68, 0.55);
  -webkit-font-smoothing: auto;
  font-size: 13px;
}
.app > header .dropdown.notifications .item .notification strong {
  color: rgba(60, 65, 68, 0.75);
}
.app > header .dropdown.notifications .item .notification .date {
  display: block;
  transition: opacity 0.2s;
  margin-top: 10px;
}
.app > header .dropdown.notifications .item .notification .remove {
  position: absolute;
  right: 0;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s;
}
.app > header .dropdown.notifications .item + .item {
  border-top: 1px solid #dae2e7;
}
.app > header .dropdown.notifications .item.read + .item.read {
  border-top: 1px solid #e0e8ed;
}
.initials-avatar {
  width: 2em;
  height: 2em;
  border-radius: 500rem;
  background-color: black;
  display: inline-block;
}
.initials-avatar div {
  color: green;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: inherit;
  font-weight: inherit;
}
body .input-address {
  position: relative;
  /* Display address as text next to input */
}
body .input-address .ui.icon.input > .icon {
  color: #2185d0;
  opacity: 1;
}
body .input-address:not(.selected) > .display-text {
  display: none;
}
body .input-address .display-text {
  width: 100%;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
body .input-address .options {
  position: absolute;
  width: calc(100% -  2 * 0.5em);
  margin-left: 30px / 2;
  margin-top: 37px;
  z-index: 10;
  /* 'inherited' from Materialize .input-field */
  border: 1px solid #EBEBEB;
  border-radius: 4px;
  background: white;
  /* Options list */
  display: none;
}
body .input-address .options.expanded {
  display: block;
}
body .input-address .options .group label,
body .input-address .options .option,
body .input-address .options .group .btn-basic {
  padding: 10px 15px;
}
body .input-address .options .group label {
  display: block;
  padding-top: 15px;
  padding-bottom: 5px;
  color: #cccccc;
  font-size: 14px;
}
body .input-address .options .group + .group {
  border-top: 1px solid #f6f5f8;
}
body .input-address .options .group .create-address,
body .input-address .options .group .create-address:hover {
  box-shadow: none !important;
}
body .input-address .options .option {
  cursor: pointer;
}
body .input-address .options .option .name {
  display: inline-block;
  min-width: 25%;
}
body .input-address .options .option:hover {
  background: #f6f6f6;
}
body .input-address .options .option.locode .name {
  display: inline;
}
body .input-address .options .option.locode .code {
  opacity: 0.3;
}
body .input-address .options .option.locode .code:before {
  content: "— ";
}
.app form footer {
  margin-top: 4em;
}
.app main .ui.secondary.pointing.menu.tabs {
  margin-bottom: 0;
  padding-left: 30px;
}
.app main .ui.secondary.pointing.menu.tabs > .header.item,
.app main .ui.secondary.pointing.menu.tabs .item:first-child {
  padding-left: 0;
  margin-left: 0;
}
.app main .ui.secondary.pointing.menu.tabs .item {
  margin-left: 1.7em;
  margin-right: 1.7em;
  padding-left: 0.05em;
  padding-right: 0.05em;
  height: 75px;
  font-size: 13px;
  letter-spacing: 0;
  color: rgba(60, 65, 68, 0.6);
  transition: color 0.3s;
}
.app main .ui.secondary.pointing.menu.tabs .item:hover {
  color: rgba(60, 65, 68, 0.8);
}
.app main .ui.secondary.pointing.menu.tabs .item.active {
  color: #2185d0;
  border-color: transparent;
}
#clockdiv {
  display: inline-block;
  white-space: nowrap;
  font-weight: 100;
  text-align: center;
  font-size: 30px;
}
#clockdiv > div {
  padding: 10px;
  border-radius: 3px;
  display: inline-block;
}
#clockdiv div > span {
  padding: 15px;
  border-radius: 3px;
  display: inline-block;
}
.smalltext {
  padding-top: 5px;
  font-size: 16px;
}
.milestones .milestone {
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  padding-left: 30px;
  padding-bottom: 3em;
  border-left: 1px solid #d9d9d9;
}
.milestones .milestone i {
  font-weight: bold;
  opacity: 0.5;
  letter-spacing: -0.02em;
}
.milestones .milestone > .icon {
  position: absolute;
  top: 0;
  left: -15px;
  background-color: white;
  opacity: 1;
  color: #b3b3b3;
}
.milestones .milestone.button,
.milestones .milestone.button .icon {
  color: #3FA2F7;
  cursor: pointer;
}
.milestones .milestone:last-of-type {
  border-left-color: transparent;
}
.react-tel-input .form-control {
  padding-left: 48px !important;
}
.stops.horizontal .item {
  text-align: center;
  position: relative;
  width: 90px;
  vertical-align: top;
}
.stops.horizontal .item:not(:last-child):after {
  position: absolute;
  content: "";
  right: -30%;
  top: 0%;
  width: 50%;
  height: 16px !important;
  border-bottom: 1px solid #d9d9d9 !important;
  visibility: visible !important;
}
.field.dateTime .isPlaceholder {
  opacity: 0.8;
}
.field.dateTime .isPlaceholder input {
  color: #d4d7db;
}
.footer_footerbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.register .form .two.column.grid {
  margin-top: 10px;
}
.register .form .two.column.grid .column:last-of-type {
  text-align: right;
}
.register .form small {
  display: block;
  margin-top: 2em;
}
.register .form small a {
  color: inherit;
  text-decoration: underline;
}
main.Portal .banner {
  color: grey;
  height: 150px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-color: #eee;
}
main.Portal .logo {
  float: left;
  color: grey;
  height: 150px;
  width: 250px;
  background-color: #fff;
  padding: 25px;
  position: relative;
}
main.Portal .logo img {
  width: 200px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.container-top-padding > div div.container {
  padding-top: 30px;
}
.app main.Settings > div {
  height: calc(100vh -  60px);
}
.app main.Settings > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
.app main.Settings + aside {
  padding-bottom: 60px;
}
.app main.Settings > div > footer.ui.segment,
.app main.Settings.ShipmentRequest footer.ui.segment,
.app main.Settings + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
.app main.Settings + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
.app main.Settings section.basic {
  margin: 0;
}
.app main.Settings section.ui.segment {
  border-radius: 2px;
}
.app main.Settings section em,
.app main.Settings section .empty {
  margin: 1em 0 1.5em;
}
.app main.Settings section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
.app main.Settings section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
.app main.Settings section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
.app main.Settings section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
.app main.Settings section > .list > .item > .content {
  width: 100%;
}
.app main.Settings section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
.app main.Settings > div div.container {
  padding-top: 30px;
}
.app main.Settings .logo {
  max-width: 300px;
}
.app main.Settings .ui.form.limit {
  max-width: 1200px;
}
.accountUpgrade .segment.leftShadow {
  box-shadow: inset 10px 0 0 0 #3FA2F7;
}
main.JobsAdmin .ui.container {
  padding-top: 30px;
}
main.JobsAdmin .progress .bar {
  transition: width 0.1s;
}
main.JobsAdmin .progress .label {
  font-size: 8pt;
}
main.JobsAdmin .failures.label[data-tooltip]:after {
  width: 500px;
  white-space: normal;
}
main.Dashboard section.basic {
  margin: 0;
}
main.Dashboard section.ui.segment {
  border-radius: 2px;
}
main.Dashboard section em,
main.Dashboard section .empty {
  margin: 1em 0 1.5em;
}
main.Dashboard section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Dashboard section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Dashboard section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Dashboard section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Dashboard section > .list > .item > .content {
  width: 100%;
}
main.Dashboard section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Dashboard section.big {
  height: 472px;
}
main.Dashboard section.big i {
  font-size: 45px;
  position: absolute;
  top: 0;
  right: 0;
  color: #3FA2F7;
}
main.Dashboard section .section-container {
  height: 100%;
  display: block;
  position: relative;
  color: #3C4144;
}
main.Dashboard section .section-content {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
}
main.Dashboard section .section-title {
  font-size: 45px;
  margin-bottom: 0;
  font-weight: normal;
}
main.Dashboard section .section-subtitle {
  margin-top: 0;
}
main.Dashboard .card i {
  font-size: 20px;
  color: #3FA2F7;
}
main.Dashboard .ui.icon.message.profile {
  background-color: #ffffff;
  color: #3c4144;
  margin-top: 0;
  border-bottom: 2px solid #e0e1e2;
}
main.Dashboard .profileprogress {
  margin-top: 15px;
  margin-bottom: 15px;
}
main.Dashboard .notopmargin {
  margin-top: 0;
}
main.Dashboard #limit {
  max-width: 1400px;
  overflow: initial;
}
main.Shipments > div {
  height: calc(100vh -  60px);
}
main.Shipments > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Shipments + aside {
  padding-bottom: 60px;
}
main.Shipments > div > footer.ui.segment,
main.Shipments.ShipmentRequest footer.ui.segment,
main.Shipments + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Shipments + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.Shipments > div > div {
  height: calc(100% -  60px + 60px);
  min-height: calc(100% -  60px + 60px);
}
main.Shipments tr {
  cursor: pointer;
}
main.Shipments td {
  white-space: nowrap;
}
main.Shipments a.tip {
  display: inline-block;
  line-height: 1.75em;
  color: #6d7173;
  border-bottom: 1px dashed #dadbdc;
}
main.Shipments header .ui.basic.button,
main.Shipments header .ui.basic.button:hover,
main.Shipments header .ui.basic.button:focus {
  box-shadow: none !important;
}
main.Shipments header .button {
  margin-left: 10px;
  line-height: 10px;
}
main.Shipments header .button.basic {
  color: rgba(0, 0, 0, 0.4) !important;
}
main.Shipments header .button.basic:hover {
  color: #3FA2F7 !important;
  background: transparent !important;
}
main.Shipments header .button.basic:active {
  box-shadow: none;
}
main.ShipmentsView > div {
  height: calc(100vh -  60px);
}
main.ShipmentsView > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.ShipmentsView + aside {
  padding-bottom: 60px;
}
main.ShipmentsView > div > footer.ui.segment,
main.ShipmentsView.ShipmentRequest footer.ui.segment,
main.ShipmentsView + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.ShipmentsView + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.ShipmentsView header.ui.segment {
  background: rgba(255, 255, 255, 0.5);
}
main.ShipmentsView header .ui.input {
  font-size: 13px;
}
main.ShipmentsView .ui.header {
  margin: 2em 0 1em;
  line-height: 2em;
}
main.ShipmentsView .ui.header.dividing {
  margin: 0 0 1.5em;
}
main.ShipmentsView .ui.header.group.shipment {
  display: none;
}
main.ShipmentsView .add-button {
  margin: 60px;
  text-align: center;
}
main.ShipmentsView .filter-input {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}
main.ShipmentsView .filter-input > .dropdown {
  height: 34px;
}
main.ShipmentsView .filter-input .dropdown.name {
  white-space: nowrap;
}
main.ShipmentsView .filter-input .dropdown.disabled {
  opacity: 1 !important;
}
main.ShipmentsView .filter-input .dropdown.fluid {
  height: 34px;
  padding-top: 0;
  padding-bottom: 0;
  margin-left: 0.25em;
  background: rgba(255, 255, 255, 0.5) !important;
}
main.ShipmentsView .filter-input .dropdown.fluid:hover {
  background: white !important;
}
main.ShipmentsView .filter-input .dropdown.fluid .text {
  line-height: 32px;
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
main.ShipmentsView .filter-input .dropdown.fluid .menu {
  width: 100%;
}
main.Shipment .mainSubWrapper > aside .statusaside {
  color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  height: 50px;
  font-size: 14px;
  background-color: #3FA2F7;
  border-radius: 25px;
  display: inline;
}
main.Shipment .mainSubWrapper > aside .tracklink {
  color: white;
  border-radius: 25px;
  white-space: nowrap;
}
main.Shipment .mainSubWrapper > aside .tracklink a {
  color: white;
  text-decoration: none;
}
main.Shipment .mainSubWrapper > aside .stop {
  position: relative;
  margin-left: 20px;
  padding-left: 30px;
  padding-bottom: 3em;
  border-left: 1px solid #d9d9d9;
}
main.Shipment .mainSubWrapper > aside .stop > .icon {
  position: absolute;
  top: 0;
  left: -15px;
  background-color: #E9EDF4;
  opacity: 1;
  color: #b3b3b3;
}
main.Shipment .mainSubWrapper > aside .stop .icon {
  color: #3FA2F7;
  cursor: pointer;
}
main.Shipment .mainSubWrapper > aside .stop:last-of-type {
  border-left-color: transparent;
}
main.Shipment .mainSubWrapper > aside .stop .relative {
  border: 1px solid transparent;
}
main.Shipment .mainSubWrapper > aside .stop .relative.editable:hover {
  border: 1px solid #EBEBEB;
}
main.Shipment .mainSubWrapper > aside .stop .relative.editable:hover .icon {
  visibility: visible !important;
  cursor: pointer;
}
* {
  scroll-margin-top: 48px;
}
main.Shipment > div {
  height: calc(100vh -  60px);
}
main.Shipment > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Shipment + aside {
  padding-bottom: 60px;
}
main.Shipment > div > footer.ui.segment,
main.Shipment.ShipmentRequest footer.ui.segment,
main.Shipment + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Shipment + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.Shipment > div > div {
  height: auto;
  overflow: initial;
}
main.Shipment > div div.container {
  padding-bottom: 90px;
}
main.Shipment aside {
  position: sticky;
  top: 0;
}
main.Shipment .map {
  padding: 0;
  margin-bottom: 40px;
}
main.Shipment .map > div {
  height: 300px;
  width: 100%;
}
main.Shipment .date i,
main.Shipment .date label {
  opacity: 0.5;
  color: #483074;
}
main.Shipment .partners .ui.cards {
  width: 100%;
}
main.Shipment .partners .ui.cards > .card {
  width: calc(33.3% - 14px);
}
main.Shipment .stages {
  margin-top: 3em;
}
main.Shipment .stages .stage h3 .status {
  margin-left: 2em;
  color: #3FA2F7;
}
main.Shipment .stages .stage.draft .column.pickup,
main.Shipment .stages .stage.draft .column.delivery,
main.Shipment .stages .stage.draft .column.partner .relative {
  border: 1px solid transparent;
}
main.Shipment .stages .stage.draft .column.pickup.editable:hover,
main.Shipment .stages .stage.draft .column.delivery.editable:hover,
main.Shipment .stages .stage.draft .column.partner .relative.editable:hover {
  border: 1px solid #EBEBEB;
}
main.Shipment .stages .stage.draft .column.pickup.editable:hover .icon,
main.Shipment .stages .stage.draft .column.delivery.editable:hover .icon,
main.Shipment .stages .stage.draft .column.partner .relative.editable:hover .icon {
  visibility: visible !important;
  cursor: pointer;
}
main.Shipment .stages .stage form {
  margin-top: 2em;
}
main.Shipment .stages .stage footer {
  margin: 0 -40px -30px;
  padding-left: 40px;
  background: rgba(63, 162, 247, 0.1);
  color: #3FA2F7;
}
main.Shipment .stage {
  box-shadow: inset 10px 0 0 0 #3FA2F7;
}
main.Shipment .stage.error {
  box-shadow: inset 10px 0 0 0 #e53935;
}
main.Shipment .stage .buttons i.right {
  opacity: 0.3;
  cursor: pointer;
  background: #e9edf4;
}
main.Shipment .stage .buttons i.menu {
  font-size: 40px;
  height: 43px;
}
main.Shipment section.basic {
  margin: 0;
}
main.Shipment section.ui.segment {
  border-radius: 2px;
}
main.Shipment section em,
main.Shipment section .empty {
  margin: 1em 0 1.5em;
}
main.Shipment section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Shipment section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Shipment section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Shipment section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Shipment section > .list > .item > .content {
  width: 100%;
}
main.Shipment section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Shipment section.documents .ui.list > .item > i.icon {
  padding-right: 0.5em;
  color: #3FA2F7;
}
main.Shipment section.carriers .costs tr.declined td {
  color: rgba(60, 65, 68, 0.3);
}
main.Shipment section.carriers .costs td.response .approved {
  color: #3FA2F7;
}
main.Shipment section.carriers .costs td.response .declined {
  color: #e53935;
}
.float.top.right {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  text-align: center;
  z-index: 1;
  transition: border-color 0.1s ease;
}
.scroll-up,
.shipment-navigation,
.shipment-conversation {
  cursor: pointer;
  outline: none;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 99px;
  color: rgba(34, 36, 38, 0.15);
  width: 50px;
  height: 50px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem !important;
  background-color: #E9EDF4;
  transition-duration: 100ms;
}
.scroll-up:hover,
.shipment-navigation:hover,
.shipment-conversation:hover {
  background-color: #3FA2F7;
  border: 0px;
  color: white;
}
.scroll-up > i,
.shipment-navigation > i,
.shipment-conversation > i {
  margin: 0 !important;
}
.navigation-dd {
  right: 0!important;
  left: auto !important;
  border-top-right-radius: 0 !important;
}
.navigation-dd button {
  width: 100%;
  font-weight: 600 !important;
}
.stages .table tr td {
  border-top: 0px !important;
}
.stages .table .fields {
  margin-bottom: 0 !important;
}
.modal.stage-split .input-field {
  margin-left: 0;
}
.form-date-picker-container {
  display: flex;
  justify-content: space-between;
}
.form-date-picker-container .field {
  margin-bottom: 0 !important;
}
.form-date-picker-container .field .fields {
  margin-bottom: 0 !important;
}
.form-date-picker-container > .field.dateTime {
  width: calc(100% - 30px);
}
.form-date-picker-container > .field.dateTime > .fields {
  align-items: center;
}
table.costDetail {
  border-collapse: collapse !important;
  border-left-width: 0 !important;
  border-top-width: 0 !important;
  border-bottom-width: 0 !important;
  border-right-width: 0 !important;
}
table.costDetail tr td {
  border-top: 0 !important;
  white-space: nowrap !important;
}
table.costDetail td.descriptionColumn {
  max-width: 250px !important;
  width: 250px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
table.costDetail td.actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
table.costDetail td.actions button {
  visibility: hidden;
}
table.costDetail tr:hover td.actions button {
  visibility: visible;
}
table.costDetail tr.declined {
  text-decoration-line: line-through;
  opacity: 0.5;
}
.cost-center-del-icon {
  display: block !important;
  margin: auto !important;
  margin-left: 5px !important;
}
.cost-carrier-rating .ratingWrapper {
  width: auto;
}
.cost-carrier-rating .ratingWrapper .starRating {
  width: auto;
}
.insight .stops .item {
  text-align: center;
  position: relative;
  width: 90px;
  vertical-align: top;
}
.insight .stops .item:not(:last-child):after {
  position: absolute;
  content: "";
  right: -30%;
  top: 0%;
  width: 50%;
  height: 16px !important;
  border-bottom: 1px solid #d9d9d9 !important;
  visibility: visible !important;
}
.sidebar .carrier-select {
  padding: 30px;
}
.sidebar .carrier-select section.price-list {
  cursor: pointer;
}
.sidebar .carrier-select .transportprice {
  color: #3FA2F7;
}
main.NewShipment > div {
  height: calc(100vh -  60px);
}
main.NewShipment > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.NewShipment + aside {
  padding-bottom: 60px;
}
main.NewShipment > div > footer.ui.segment,
main.NewShipment.ShipmentRequest footer.ui.segment,
main.NewShipment + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.NewShipment + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
.packShipment {
  display: block !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.ts-shipment-pick__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
}
.ts-shipment-pick__row h3 {
  margin-bottom: 0;
}
.ts-shipment-pick__heading {
  font-size: 40px;
}
.ts-shipment-pick__table.ui.table,
.ts-shipment-pick__tabletable.dataTable {
  font-size: 20px;
}
.ts-shipment-pick__table.ui.table thead th,
.ts-shipment-pick__tabletable.dataTable thead th,
.ts-shipment-pick__tablemain.PriceList .header.row .column {
  font-size: 18px;
}
.ts-shipment-pick__list.list .item {
  padding-top: 20px;
  padding-bottom: 20px;
}
.ts-shipment-pick__option-header {
  font-size: 20px;
}
.ts-shipment-pick__option-price {
  display: block;
  font-size: 16px;
  margin-top: 10px;
}
.ts-shipment-pick__container {
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  max-width: 100%!important;
  height: auto !important;
  overflow: hidden !important;
}
.ts-shipment-header__loc {
  display: flex;
  align-items: center;
}
.ts-shipment-header__loc .ui.button {
  margin-left: 10px;
}
.ts-manifest__col-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ts-manifest__col-row h1 {
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 0;
  color: #3c4144;
}
.ts-manifest__col-row .ui.button {
  margin-left: 15px;
}
.packShipmentManifest .ui.container {
  padding-top: 30px;
}
.ts-manifest-card.ui.blue.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #1e97ff, 0 1px 3px 0 #bcbdbd;
}
.pick-footer {
  width: 100% !important;
}
main.ShipmentProject section.basic {
  margin: 0;
}
main.ShipmentProject section.ui.segment {
  border-radius: 2px;
}
main.ShipmentProject section em,
main.ShipmentProject section .empty {
  margin: 1em 0 1.5em;
}
main.ShipmentProject section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.ShipmentProject section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.ShipmentProject section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.ShipmentProject section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.ShipmentProject section > .list > .item > .content {
  width: 100%;
}
main.ShipmentProject section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.ShipmentProject > div > div {
  display: flex;
  flex-direction: column;
}
main.ShipmentProject .ui.secondary.pointing.menu.tabs {
  flex-shrink: 0;
}
main.ShipmentProject .column.location .relative {
  border: 1px solid transparent;
}
main.ShipmentProject .column.location .relative.editable:hover {
  border: 1px solid #EBEBEB;
}
main.ShipmentProject .column.location .relative.editable:hover .icon {
  visibility: visible !important;
  cursor: pointer;
}
main.Track .row.fromto {
  background-color: #fff;
  border-radius: 5px;
}
main.Track .row.fromto .column > div {
  height: 140px;
  padding: 20px;
  text-align: center;
}
main.Track .row.fromto .column h5 {
  margin-bottom: 0;
  font-weight: bold;
}
main.Track .row.fromto .column .time {
  margin-top: 2em;
}
main.Track .row.fromto .column .time i {
  color: #483074;
}
main.Track .status h5 + div {
  margin-top: 2em;
}
main.Track .status .truck {
  margin-bottom: 0.75em;
  color: #3FA2F7;
  text-align: left;
}
main.Track .status .track,
main.Track .status .track .fill {
  height: 8px;
  background-color: #ccc;
  border-radius: 8px;
}
main.Track .status .track .fill {
  background-color: #3FA2F7;
}
main.Track .updates h4 {
  padding-bottom: 1em;
}
main.Track .updates .grid .column {
  padding-top: 0.5em;
  padding-bottom: 0;
  white-space: nowrap;
}
body > .track {
  background: white;
  padding: 50px;
  height: 260px;
}
.timeline {
  width: 100%;
  text-align: center;
}
.statusbox {
  height: 50px;
  width: 100%;
  text-align: center;
}
.track > .container {
  background: white;
  padding: 50px;
}
.track > .container header {
  padding-bottom: 50px;
}
.track > .container header .logo {
  width: 150px;
}
.track > .container header i {
  color: #ccc;
  font-size: 30px;
}
.track > .container h3 {
  font-size: 16px;
  font-weight: bold;
  color: #2185d0;
}
.track > .container h4 {
  font-size: 16px;
}
.track > .container h5 {
  font-size: inherit;
}
main.shipmentRequest footer.ui.segment {
  position: fixed;
  bottom: 0;
  left: 60px;
  width: calc(100% -  60px);
  z-index: 1;
  margin: auto !important;
}
.shipment-inbound-outbound_wrapper {
  overflow-x: scroll;
  flex-grow: 1;
}
.shipment-inbound-outbound_wrapper .loading-container {
  overflow-y: auto;
  height: 100%;
}
.shipment-inbound-outbound_wrapper::-webkit-scrollbar {
  display: none;
}
.capitalize {
  text-transform: capitalize;
}
.uppercase {
  text-transform: uppercase;
}
main.Import > div {
  height: calc(100vh -  60px);
}
main.Import > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Import + aside {
  padding-bottom: 60px;
}
main.Import > div > footer.ui.segment,
main.Import.ShipmentRequest footer.ui.segment,
main.Import + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Import + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.Import > div {
  height: calc( 100vh -  60px + 60px);
  overflow: auto;
}
main.Import .tabs + .container {
  min-height: 0;
}
main.Import .ui.secondary.pointing.menu.tabs .item.error {
  color: #e53935;
}
main.Import .ui.search.dropdown .menu {
  max-height: 55vh;
}
main.Import form.file {
  height: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
main.Import .samples {
  color: rgba(60, 65, 68, 0.7);
  font-size: 11px;
}
main.Import .samples .item {
  line-height: 1.1em;
}
main.Import .dataTable td:not([colspan]) {
  position: relative;
  padding-top: 1px;
  padding-bottom: 1px;
}
main.Import .dataTable td a.info {
  display: inline-block;
  max-width: 35vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-transform: lowercase;
  border-bottom: 1px solid;
}
main.Import .dataTable td a.info[details]:hover::after {
  content: attr(details);
  position: absolute;
  top: 45px;
  left: 30px;
  width: 30vw;
  padding: 15px;
  white-space: normal;
  background: white;
  text-transform: none;
  z-index: 1;
}
main.Import .dataTable td a.error {
  display: inline-block;
  max-width: 35vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e53935;
  text-transform: lowercase;
  border-bottom: 1px solid;
}
main.Import .dataTable td a.error[details]:hover::after {
  content: attr(details);
  position: absolute;
  top: 45px;
  left: 30px;
  width: 30vw;
  padding: 15px;
  white-space: normal;
  background: red;
  color: white;
  text-transform: none;
  z-index: 1;
}
aside ol.steps {
  list-style: none;
  padding: 0 0 0 18px;
  margin: 0;
}
aside ol.steps li {
  position: relative;
  padding-bottom: 10px;
  user-select: none;
}
aside ol.steps li:before {
  position: absolute;
  left: -1px / 2;
  content: "";
  z-index: -1;
  width: 1px;
}
aside ol.steps li:first-of-type:before {
  top: 0;
  height: 8.5px;
  display: none;
}
aside ol.steps li.active:first-of-type:before {
  top: 0;
  height: -1.5px;
}
aside ol.steps li.active:after {
  top: 26.5px;
}
aside ol.steps li:before {
  top: -28.5px;
  height: 37px;
}
aside ol.steps li.active:before,
aside ol.steps li.active + li:before {
  height: 27px;
}
aside ol.steps li.active + li:before {
  top: -18.5px;
}
aside ol.steps li.extra + li:before {
  top: -47.5px;
  height: 56px;
}
aside ol.steps li.extra.active + li:before,
aside ol.steps li.extra + li.active:before {
  height: 46px;
}
aside ol.steps li.extra.active + li:before {
  top: -37.5px;
}
aside ol.steps li label,
aside ol.steps li span {
  padding-left: 0;
  cursor: pointer;
}
aside ol.steps li label {
  display: block;
  font: 14px Roboto;
  font-weight: 600;
  color: rgba(60, 65, 68, 0.26);
}
aside ol.steps li label:before {
  content: "";
  position: absolute;
  top: 12.5px;
  left: 0;
  width: 0;
  height: 0;
  background-color: #483074;
  border-radius: 0;
}
aside ol.steps li span {
  display: none;
  font-size: 12px;
  color: rgba(60, 65, 68, 0.54);
}
aside ol.steps li.active label,
aside ol.steps li.done label {
  color: rgba(60, 65, 68, 0.87);
}
aside ol.steps li.active span,
aside ol.steps li.done span {
  display: block;
}
aside ol.steps li.done label:before,
aside ol.steps li.active label:before,
aside ol.steps li.active .percentage {
  top: 0;
  left: -20px;
  width: 46px;
  height: 46px;
  background-color: #E9EDF4;
  border-radius: 40px;
  line-height: 40px;
  text-align: center;
  border: 2px solid #E9EDF4;
}
aside ol.steps li.done label:before {
  content: "√";
  color: #483074;
  box-shadow: 0 0 0 9px #3FA2F7, 0 0 0 10px rgba(60, 65, 68, 0.54);
  box-shadow: inset 0 0 0 3px #483074;
}
aside ol.steps li.active {
  position: relative;
}
aside ol.steps li.active label:before {
  z-index: 1;
}
aside ol.steps li.active label.p-100:before {
  background-image: linear-gradient(90deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-100 .percentage:before {
  content: "100%";
}
aside ol.steps li.active label.p-99:before {
  background-image: linear-gradient(86.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-99 .percentage:before {
  content: "99%";
}
aside ol.steps li.active label.p-98:before {
  background-image: linear-gradient(82.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-98 .percentage:before {
  content: "98%";
}
aside ol.steps li.active label.p-97:before {
  background-image: linear-gradient(79.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-97 .percentage:before {
  content: "97%";
}
aside ol.steps li.active label.p-96:before {
  background-image: linear-gradient(75.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-96 .percentage:before {
  content: "96%";
}
aside ol.steps li.active label.p-95:before {
  background-image: linear-gradient(72deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-95 .percentage:before {
  content: "95%";
}
aside ol.steps li.active label.p-94:before {
  background-image: linear-gradient(68.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-94 .percentage:before {
  content: "94%";
}
aside ol.steps li.active label.p-93:before {
  background-image: linear-gradient(64.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-93 .percentage:before {
  content: "93%";
}
aside ol.steps li.active label.p-92:before {
  background-image: linear-gradient(61.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-92 .percentage:before {
  content: "92%";
}
aside ol.steps li.active label.p-91:before {
  background-image: linear-gradient(57.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-91 .percentage:before {
  content: "91%";
}
aside ol.steps li.active label.p-90:before {
  background-image: linear-gradient(54deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-90 .percentage:before {
  content: "90%";
}
aside ol.steps li.active label.p-89:before {
  background-image: linear-gradient(50.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-89 .percentage:before {
  content: "89%";
}
aside ol.steps li.active label.p-88:before {
  background-image: linear-gradient(46.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-88 .percentage:before {
  content: "88%";
}
aside ol.steps li.active label.p-87:before {
  background-image: linear-gradient(43.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-87 .percentage:before {
  content: "87%";
}
aside ol.steps li.active label.p-86:before {
  background-image: linear-gradient(39.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-86 .percentage:before {
  content: "86%";
}
aside ol.steps li.active label.p-85:before {
  background-image: linear-gradient(36deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-85 .percentage:before {
  content: "85%";
}
aside ol.steps li.active label.p-84:before {
  background-image: linear-gradient(32.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-84 .percentage:before {
  content: "84%";
}
aside ol.steps li.active label.p-83:before {
  background-image: linear-gradient(28.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-83 .percentage:before {
  content: "83%";
}
aside ol.steps li.active label.p-82:before {
  background-image: linear-gradient(25.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-82 .percentage:before {
  content: "82%";
}
aside ol.steps li.active label.p-81:before {
  background-image: linear-gradient(21.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-81 .percentage:before {
  content: "81%";
}
aside ol.steps li.active label.p-80:before {
  background-image: linear-gradient(18deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-80 .percentage:before {
  content: "80%";
}
aside ol.steps li.active label.p-79:before {
  background-image: linear-gradient(14.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-79 .percentage:before {
  content: "79%";
}
aside ol.steps li.active label.p-78:before {
  background-image: linear-gradient(10.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-78 .percentage:before {
  content: "78%";
}
aside ol.steps li.active label.p-77:before {
  background-image: linear-gradient(7.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-77 .percentage:before {
  content: "77%";
}
aside ol.steps li.active label.p-76:before {
  background-image: linear-gradient(3.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-76 .percentage:before {
  content: "76%";
}
aside ol.steps li.active label.p-75:before {
  background-image: linear-gradient(0deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-75 .percentage:before {
  content: "75%";
}
aside ol.steps li.active label.p-74:before {
  background-image: linear-gradient(-3.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-74 .percentage:before {
  content: "74%";
}
aside ol.steps li.active label.p-73:before {
  background-image: linear-gradient(-7.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-73 .percentage:before {
  content: "73%";
}
aside ol.steps li.active label.p-72:before {
  background-image: linear-gradient(-10.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-72 .percentage:before {
  content: "72%";
}
aside ol.steps li.active label.p-71:before {
  background-image: linear-gradient(-14.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-71 .percentage:before {
  content: "71%";
}
aside ol.steps li.active label.p-70:before {
  background-image: linear-gradient(-18deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-70 .percentage:before {
  content: "70%";
}
aside ol.steps li.active label.p-69:before {
  background-image: linear-gradient(-21.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-69 .percentage:before {
  content: "69%";
}
aside ol.steps li.active label.p-68:before {
  background-image: linear-gradient(-25.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-68 .percentage:before {
  content: "68%";
}
aside ol.steps li.active label.p-67:before {
  background-image: linear-gradient(-28.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-67 .percentage:before {
  content: "67%";
}
aside ol.steps li.active label.p-66:before {
  background-image: linear-gradient(-32.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-66 .percentage:before {
  content: "66%";
}
aside ol.steps li.active label.p-65:before {
  background-image: linear-gradient(-36deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-65 .percentage:before {
  content: "65%";
}
aside ol.steps li.active label.p-64:before {
  background-image: linear-gradient(-39.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-64 .percentage:before {
  content: "64%";
}
aside ol.steps li.active label.p-63:before {
  background-image: linear-gradient(-43.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-63 .percentage:before {
  content: "63%";
}
aside ol.steps li.active label.p-62:before {
  background-image: linear-gradient(-46.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-62 .percentage:before {
  content: "62%";
}
aside ol.steps li.active label.p-61:before {
  background-image: linear-gradient(-50.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-61 .percentage:before {
  content: "61%";
}
aside ol.steps li.active label.p-60:before {
  background-image: linear-gradient(-54deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-60 .percentage:before {
  content: "60%";
}
aside ol.steps li.active label.p-59:before {
  background-image: linear-gradient(-57.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-59 .percentage:before {
  content: "59%";
}
aside ol.steps li.active label.p-58:before {
  background-image: linear-gradient(-61.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-58 .percentage:before {
  content: "58%";
}
aside ol.steps li.active label.p-57:before {
  background-image: linear-gradient(-64.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-57 .percentage:before {
  content: "57%";
}
aside ol.steps li.active label.p-56:before {
  background-image: linear-gradient(-68.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-56 .percentage:before {
  content: "56%";
}
aside ol.steps li.active label.p-55:before {
  background-image: linear-gradient(-72deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-55 .percentage:before {
  content: "55%";
}
aside ol.steps li.active label.p-54:before {
  background-image: linear-gradient(-75.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-54 .percentage:before {
  content: "54%";
}
aside ol.steps li.active label.p-53:before {
  background-image: linear-gradient(-79.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-53 .percentage:before {
  content: "53%";
}
aside ol.steps li.active label.p-52:before {
  background-image: linear-gradient(-82.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-52 .percentage:before {
  content: "52%";
}
aside ol.steps li.active label.p-51:before {
  background-image: linear-gradient(-86.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-51 .percentage:before {
  content: "51%";
}
aside ol.steps li.active label.p-50:before {
  background-image: linear-gradient(-90deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-50 .percentage:before {
  content: "50%";
}
aside ol.steps li.active label.p-49:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(266.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-49 .percentage:before {
  content: "49%";
}
aside ol.steps li.active label.p-48:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(262.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-48 .percentage:before {
  content: "48%";
}
aside ol.steps li.active label.p-47:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(259.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-47 .percentage:before {
  content: "47%";
}
aside ol.steps li.active label.p-46:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(255.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-46 .percentage:before {
  content: "46%";
}
aside ol.steps li.active label.p-45:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(252deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-45 .percentage:before {
  content: "45%";
}
aside ol.steps li.active label.p-44:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(248.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-44 .percentage:before {
  content: "44%";
}
aside ol.steps li.active label.p-43:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(244.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-43 .percentage:before {
  content: "43%";
}
aside ol.steps li.active label.p-42:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(241.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-42 .percentage:before {
  content: "42%";
}
aside ol.steps li.active label.p-41:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(237.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-41 .percentage:before {
  content: "41%";
}
aside ol.steps li.active label.p-40:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(234deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-40 .percentage:before {
  content: "40%";
}
aside ol.steps li.active label.p-39:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(230.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-39 .percentage:before {
  content: "39%";
}
aside ol.steps li.active label.p-38:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(226.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-38 .percentage:before {
  content: "38%";
}
aside ol.steps li.active label.p-37:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(223.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-37 .percentage:before {
  content: "37%";
}
aside ol.steps li.active label.p-36:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(219.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-36 .percentage:before {
  content: "36%";
}
aside ol.steps li.active label.p-35:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(216deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-35 .percentage:before {
  content: "35%";
}
aside ol.steps li.active label.p-34:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(212.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-34 .percentage:before {
  content: "34%";
}
aside ol.steps li.active label.p-33:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(208.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-33 .percentage:before {
  content: "33%";
}
aside ol.steps li.active label.p-32:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(205.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-32 .percentage:before {
  content: "32%";
}
aside ol.steps li.active label.p-31:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(201.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-31 .percentage:before {
  content: "31%";
}
aside ol.steps li.active label.p-30:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(198deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-30 .percentage:before {
  content: "30%";
}
aside ol.steps li.active label.p-29:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(194.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-29 .percentage:before {
  content: "29%";
}
aside ol.steps li.active label.p-28:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(190.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-28 .percentage:before {
  content: "28%";
}
aside ol.steps li.active label.p-27:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(187.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-27 .percentage:before {
  content: "27%";
}
aside ol.steps li.active label.p-26:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(183.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-26 .percentage:before {
  content: "26%";
}
aside ol.steps li.active label.p-25:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(180deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-25 .percentage:before {
  content: "25%";
}
aside ol.steps li.active label.p-24:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(176.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-24 .percentage:before {
  content: "24%";
}
aside ol.steps li.active label.p-23:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(172.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-23 .percentage:before {
  content: "23%";
}
aside ol.steps li.active label.p-22:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(169.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-22 .percentage:before {
  content: "22%";
}
aside ol.steps li.active label.p-21:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(165.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-21 .percentage:before {
  content: "21%";
}
aside ol.steps li.active label.p-20:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(162deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-20 .percentage:before {
  content: "20%";
}
aside ol.steps li.active label.p-19:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(158.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-19 .percentage:before {
  content: "19%";
}
aside ol.steps li.active label.p-18:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(154.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-18 .percentage:before {
  content: "18%";
}
aside ol.steps li.active label.p-17:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(151.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-17 .percentage:before {
  content: "17%";
}
aside ol.steps li.active label.p-16:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(147.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-16 .percentage:before {
  content: "16%";
}
aside ol.steps li.active label.p-15:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(144deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-15 .percentage:before {
  content: "15%";
}
aside ol.steps li.active label.p-14:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(140.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-14 .percentage:before {
  content: "14%";
}
aside ol.steps li.active label.p-13:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(136.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-13 .percentage:before {
  content: "13%";
}
aside ol.steps li.active label.p-12:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(133.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-12 .percentage:before {
  content: "12%";
}
aside ol.steps li.active label.p-11:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(129.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-11 .percentage:before {
  content: "11%";
}
aside ol.steps li.active label.p-10:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(126deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-10 .percentage:before {
  content: "10%";
}
aside ol.steps li.active label.p-9:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(122.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-9 .percentage:before {
  content: "9%";
}
aside ol.steps li.active label.p-8:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(118.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-8 .percentage:before {
  content: "8%";
}
aside ol.steps li.active label.p-7:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(115.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-7 .percentage:before {
  content: "7%";
}
aside ol.steps li.active label.p-6:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(111.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-6 .percentage:before {
  content: "6%";
}
aside ol.steps li.active label.p-5:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(108deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-5 .percentage:before {
  content: "5%";
}
aside ol.steps li.active label.p-4:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(104.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-4 .percentage:before {
  content: "4%";
}
aside ol.steps li.active label.p-3:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(100.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-3 .percentage:before {
  content: "3%";
}
aside ol.steps li.active label.p-2:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(97.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-2 .percentage:before {
  content: "2%";
}
aside ol.steps li.active label.p-1:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(93.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-1 .percentage:before {
  content: "1%";
}
aside ol.steps li.active label.p-0:before {
  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(90deg, #483074 50%, #E9EDF4 50%, #E9EDF4);
}
aside ol.steps li.active label.p-0 .percentage:before {
  content: "0%";
}
aside ol.steps li.active .percentage {
  position: absolute;
  top: 5px;
  left: -15px;
  width: 36px;
  height: 36px;
  z-index: 2;
  background-color: #E9EDF4;
  color: #3C4144;
  font-weight: bold;
  font-size: 14px;
  line-height: 30px;
}
.DataImport > div {
  height: calc(100vh -  60px);
}
.DataImport > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
.DataImport + aside {
  padding-bottom: 60px;
}
.DataImport > div > footer.ui.segment,
.DataImport.ShipmentRequest footer.ui.segment,
.DataImport + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
.DataImport + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
.DataImport .dataTable td:not([colspan]) {
  position: relative;
  padding-top: 1px;
  padding-bottom: 1px;
}
.DataImport .dataTable td a.error {
  display: inline-block;
  max-width: 35vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e53935;
  text-transform: lowercase;
  border-bottom: 1px solid;
}
main.Partners > div {
  height: calc(100vh -  60px);
}
main.Partners > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Partners + aside {
  padding-bottom: 60px;
}
main.Partners > div > footer.ui.segment,
main.Partners.ShipmentRequest footer.ui.segment,
main.Partners + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Partners + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.Directory .ui.container {
  margin-top: 30px;
}
main.Directory .more {
  margin: 60px auto;
  text-align: center;
}
.directory-card + .attached {
  margin-top: -1em !important;
  padding-bottom: 0.1em !important;
}
.directory-card {
  display: block;
  margin-bottom: 1em;
}
.directory-card .basic.table {
  min-height: 90px;
  table-layout: fixed;
  transition: all 0.3s;
}
.directory-card .basic.table:hover {
  border-color: #3FA2F7;
}
.directory-card .basic.table .rating {
  margin-right: 0.8em;
}
.directory-card .basic.table td:nth-of-type(2) {
  cursor: pointer;
}
.directory-card .basic.table td:nth-of-type(2) div {
  display: flex;
  align-items: center;
}
.directory-card .basic.table td:nth-of-type(2) div > .image {
  margin: 0 1.4em 0 0.3em;
}
.directory-card .basic.table td:nth-of-type(2) div > .name {
  flex: 1;
  font-weight: bold;
}
.directory-card .basic.table td:nth-of-type(3) .description {
  margin-bottom: 0.3em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.directory-card .basic.table td:nth-of-type(3) .tags .ui.label {
  font-size: 10px;
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}
@media all and (max-height: 799px) {
  main.Partner + aside footer.ui.segment {
    display: none;
  }
}
main.Partner section.basic {
  margin: 0;
}
main.Partner section.ui.segment {
  border-radius: 2px;
}
main.Partner section em,
main.Partner section .empty {
  margin: 1em 0 1.5em;
}
main.Partner section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Partner section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Partner section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Partner section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Partner section > .list > .item > .content {
  width: 100%;
}
main.Partner section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Partner .banner {
  color: grey;
  height: 250px;
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-color: #eee;
}
main.Partner .logo {
  float: left;
  color: grey;
  height: 250px;
  width: 250px;
  background-color: #fff;
  padding: 25px;
  position: relative;
}
main.Partner .logo img {
  width: 200px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
main.Partner ul.distributed {
  -moz-column-count: 4;
  -moz-column-gap: 20px;
  -webkit-column-count: 4;
  -webkit-column-gap: 20px;
  column-count: 4;
  column-gap: 20px;
}
main.Partner ul.distributed li {
  list-style-type: none;
}
main.Partner section.score .ui.card.score {
  width: 120px;
}
main.PartnerInvoice section.basic {
  margin: 0;
}
main.PartnerInvoice section.ui.segment {
  border-radius: 2px;
}
main.PartnerInvoice section em,
main.PartnerInvoice section .empty {
  margin: 1em 0 1.5em;
}
main.PartnerInvoice section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.PartnerInvoice section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.PartnerInvoice section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.PartnerInvoice section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.PartnerInvoice section > .list > .item > .content {
  width: 100%;
}
main.PartnerInvoice section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.PartnerInvoice > div {
  height: calc(100vh -  60px);
}
main.PartnerInvoice > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.PartnerInvoice + aside {
  padding-bottom: 60px;
}
main.PartnerInvoice > div > footer.ui.segment,
main.PartnerInvoice.ShipmentRequest footer.ui.segment,
main.PartnerInvoice + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.PartnerInvoice + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.PartnerInvoice .column.seller,
main.PartnerInvoice .column.client,
main.PartnerInvoice .column.details {
  border: 1px solid transparent;
}
main.PartnerInvoice .column.editable:hover {
  border: 1px solid #EBEBEB;
}
main.PartnerInvoice .column.editable:hover .icon {
  visibility: visible !important;
  cursor: pointer;
}
main.PartnerInvoice .report {
  height: calc(100vh -  60px + 60px + 1px);
}
main.PartnerInvoice .report iframe {
  margin-top: 1px;
  border: none;
  height: 100%;
}
main.PartnerInvoice .report #powerbi-container {
  height: calc(100% - 1px);
}
main.Addresses > div {
  height: calc(100vh -  60px);
}
main.Addresses > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Addresses + aside {
  padding-bottom: 60px;
}
main.Addresses > div > footer.ui.segment,
main.Addresses.ShipmentRequest footer.ui.segment,
main.Addresses + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Addresses + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
@media all and (max-height: 799px) {
  main.Address + aside footer.ui.segment {
    display: none;
  }
}
main.Address section.basic {
  margin: 0;
}
main.Address section.ui.segment {
  border-radius: 2px;
}
main.Address section em,
main.Address section .empty {
  margin: 1em 0 1.5em;
}
main.Address section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Address section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Address section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Address section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Address section > .list > .item > .content {
  width: 100%;
}
main.Address section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Address .map {
  height: 300px;
  width: 100%;
}
main.PriceList > div {
  height: calc(100vh -  60px);
}
main.PriceList > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.PriceList + aside {
  padding-bottom: 60px;
}
main.PriceList > div > footer.ui.segment,
main.PriceList.ShipmentRequest footer.ui.segment,
main.PriceList + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.PriceList + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.PriceList #priceListModalContainer {
  text-align: right;
  padding-right: 27px;
  padding-bottom: 15px;
}
main.PriceList .ui.segment {
  box-shadow: none;
}
main.PriceList .header.row {
  padding-top: 0;
}
main.PriceList .legend {
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
}
main.PriceList .legend > div + div {
  margin-left: 30px;
}
main.PriceList .legend > div .label {
  margin-right: 0.5em;
}
main.PriceList .mainSubWrapper > aside img.partnerLogo {
  width: auto;
  height: auto;
  max-height: 85px;
  max-width: 240px;
  margin-top: -60px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
main.PriceList .mainSubWrapper > aside .ui.list li a {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
}
main.PriceList section > .list > .item > .icon {
  color: #3fa2f7;
  font-size: 18px;
  line-height: 14px;
}
.ui.list > .item > .icon + .content.full {
  /*display: inherit;*/
  width: 100%;
}
main.PriceList .segment.rates {
  height: calc(100vh -  60px + 60px + 75px + 30px + 1px);
}
main.PriceList .segment.rates .gridPlaceHolder {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: calc(100% - 2 * 45px);
  height: calc(100vh -  60px + 60px + 75px + 2 * 45px + 30px + 1px);
  justify-content: center;
  text-align: center;
}
main.PriceRequest section.basic {
  margin: 0;
}
main.PriceRequest section.ui.segment {
  border-radius: 2px;
}
main.PriceRequest section em,
main.PriceRequest section .empty {
  margin: 1em 0 1.5em;
}
main.PriceRequest section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.PriceRequest section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.PriceRequest section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.PriceRequest section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.PriceRequest section > .list > .item > .content {
  width: 100%;
}
main.PriceRequest section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.PriceRequest > div {
  height: calc(100vh -  60px);
}
main.PriceRequest > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.PriceRequest + aside {
  padding-bottom: 60px;
}
main.PriceRequest > div > footer.ui.segment,
main.PriceRequest.ShipmentRequest footer.ui.segment,
main.PriceRequest + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.PriceRequest + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.PriceRequest .analytics table.detail i {
  color: #3fa2f7;
}
main.PriceRequest .analytics table.detail span.supsub sup {
  position: relative;
  top: -0.5em;
}
main.PriceRequest .analytics table.detail span.supsub sub {
  position: relative;
  top: 0.5em;
  left: -1.5em;
  /* This will vary with font... */
}
main.PriceRequest .relative {
  border: 1px solid transparent;
}
main.PriceRequest .relative.editable:hover {
  border: 1px solid #EBEBEB;
  cursor: pointer;
}
main.PriceRequest .relative.editable:hover .icon {
  visibility: visible !important;
}
main.Analysis .cheaper,
.analysis-shipments-modal .cheaper {
  color: #3fa2f7;
}
main.Analysis .ui.steps {
  min-height: 60px;
}
main.Analysis .savings {
  text-align: right;
}
main.Analysis .savings > div {
  margin-bottom: 0.5em;
}
main.Analysis .savings > div .action.input > button {
  min-width: 200px;
  text-align: right;
}
main.Analysis .savings > div .action.input > input {
  width: 150px;
}
main.Analysis .savings strong {
  font-size: 0.8em;
}
main.Analysis .cost.details.tooltip:after {
  text-align: right;
  min-width: 17em;
}
main.Analysis .segment.report {
  height: calc(100vh -  60px + 120px + 30px + 1px);
  padding: 0;
}
main.Analysis .segment.data {
  min-height: calc(100vh -  60px + 120px + 30px + 60px + 1px);
}
main.Analysis .reportContainer {
  height: calc(100% -  75px);
}
main.Tender section.basic {
  margin: 0;
}
main.Tender section.ui.segment {
  border-radius: 2px;
}
main.Tender section em,
main.Tender section .empty {
  margin: 1em 0 1.5em;
}
main.Tender section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Tender section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Tender section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Tender section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Tender section > .list > .item > .content {
  width: 100%;
}
main.Tender section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Tender > div {
  height: calc(100vh -  60px);
}
main.Tender > div > div {
  height: calc(100% -  60px);
  overflow: auto;
}
main.Tender + aside {
  padding-bottom: 60px;
}
main.Tender > div > footer.ui.segment,
main.Tender.ShipmentRequest footer.ui.segment,
main.Tender + aside > footer.ui.segment {
  position: fixed;
  bottom: 0;
  width: calc(100% -  60px);
  z-index: 1;
}
main.Tender + aside > footer.ui.segment {
  min-width: 360px;
  width: 25vw;
}
main.Tender .item.horizontal {
  float: left;
  margin-right: 30px;
}
main.Tender .tabs + .container {
  height: calc(100% -  75px);
}
main.Tender section .ui.form .documents,
main.Tender section .requirement .documents,
main.Tender section .milestone .documents,
main.Tender .intro .documents,
main.Tender section .ui.form .button,
main.Tender section .requirement .button,
main.Tender section .milestone .button,
main.Tender .intro .button {
  margin: 1em 0;
}
main.Tender section .ui.form .clickable.card,
main.Tender section .requirement .clickable.card,
main.Tender section .milestone .clickable.card,
main.Tender .intro .clickable.card {
  cursor: pointer;
}
main.Tender .requirement,
main.Tender .milestone {
  cursor: pointer;
}
main.Tender .requirement i,
main.Tender .milestone i {
  font-weight: bold;
  opacity: 0.5;
  letter-spacing: -0.02em;
}
main.Tender .requirement {
  margin-bottom: 3em;
}
main.Tender .requirements button,
main.Tender .requirements h4 {
  margin: 2em 0;
}
main.Tender .requirements .response textarea,
main.Tender .requirements .response .dropdown {
  width: 300px;
}
main.Tender .requirements .ui.form,
main.Tender .milestones .ui.form {
  margin-top: 2em;
}
main.Tender .milestone {
  position: relative;
  margin-left: 20px;
  padding-left: 30px;
  padding-bottom: 3em;
  border-left: 1px solid #d9d9d9;
}
main.Tender .milestone > .icon {
  position: absolute;
  top: 0;
  left: -15px;
  background-color: white;
  opacity: 1;
  color: #b3b3b3;
}
main.Tender .milestone.button,
main.Tender .milestone.button .icon {
  color: #3FA2F7;
  cursor: pointer;
}
main.Tender .milestone:last-of-type {
  border-left-color: transparent;
}
main.Tender .partners button {
  margin-top: 2em;
}
main.Tender .profile .review-result {
  margin-left: 0.5em;
  color: #b3b3b3;
}
main.Tender .analysis {
  height: 100%;
}
main.Tender .analysis .powerbi {
  height: 100%;
}
main.Tender .analysis .powerbi iframe {
  border: none;
  height: 100%;
}
main.Reporting > div > div {
  height: 100%;
}
main.Reporting .ui.tabs.menu {
  margin-bottom: 0;
}
main.Reporting .reportContainer {
  height: calc(100% -  75px);
}
main.DataExport section.basic {
  margin: 0;
}
main.DataExport section.ui.segment {
  border-radius: 2px;
}
main.DataExport section em,
main.DataExport section .empty {
  margin: 1em 0 1.5em;
}
main.DataExport section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.DataExport section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.DataExport section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.DataExport section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.DataExport section > .list > .item > .content {
  width: 100%;
}
main.DataExport section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.ToolsOceanDistance section.basic {
  margin: 0;
}
main.ToolsOceanDistance section.ui.segment {
  border-radius: 2px;
}
main.ToolsOceanDistance section em,
main.ToolsOceanDistance section .empty {
  margin: 1em 0 1.5em;
}
main.ToolsOceanDistance section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.ToolsOceanDistance section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.ToolsOceanDistance section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.ToolsOceanDistance section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.ToolsOceanDistance section > .list > .item > .content {
  width: 100%;
}
main.ToolsOceanDistance section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.ToolsOceanDistance .map {
  height: 300px;
  width: 100%;
}
main.ToolsRouteInsight section.basic {
  margin: 0;
}
main.ToolsRouteInsight section.ui.segment {
  border-radius: 2px;
}
main.ToolsRouteInsight section em,
main.ToolsRouteInsight section .empty {
  margin: 1em 0 1.5em;
}
main.ToolsRouteInsight section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.ToolsRouteInsight section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.ToolsRouteInsight section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.ToolsRouteInsight section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.ToolsRouteInsight section > .list > .item > .content {
  width: 100%;
}
main.ToolsRouteInsight section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.ToolsPriceLookup section.basic {
  margin: 0;
}
main.ToolsPriceLookup section.ui.segment {
  border-radius: 2px;
}
main.ToolsPriceLookup section em,
main.ToolsPriceLookup section .empty {
  margin: 1em 0 1.5em;
}
main.ToolsPriceLookup section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.ToolsPriceLookup section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.ToolsPriceLookup section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.ToolsPriceLookup section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.ToolsPriceLookup section > .list > .item > .content {
  width: 100%;
}
main.ToolsPriceLookup section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Tenderify section.basic {
  margin: 0;
}
main.Tenderify section.ui.segment {
  border-radius: 2px;
}
main.Tenderify section em,
main.Tenderify section .empty {
  margin: 1em 0 1.5em;
}
main.Tenderify section .empty {
  cursor: pointer;
  color: #d4d2d5;
}
main.Tenderify section h3.section-header i {
  color: #ccc;
  margin-left: 0.5em;
  cursor: pointer;
}
main.Tenderify section h3.section-header:not(:first-of-type) {
  margin-top: 45px;
}
main.Tenderify section > .list > .item > .icon {
  color: #3FA2F7;
  font-size: 18px;
  line-height: 14px;
}
main.Tenderify section > .list > .item > .content {
  width: 100%;
}
main.Tenderify section label .delete.icon {
  cursor: pointer;
  color: #ccc;
}
main.Tenderify .segment.stretch {
  height: calc(100vh -  60px + 60px + 75px + 30px + 1px);
}
main.Tenderify div.relative.editable:hover .icon {
  visibility: visible !important;
  cursor: pointer;
}
main.Tenderify td .relative {
  padding: 0;
}
main.Tenderify td.noTopPadding {
  padding-top: 0 !important;
}
.sidebar .tenderify-bidControl {
  padding: 30px;
}
`, "",{"version":3,"sources":["webpack://./../imports/client/layouts/all.less","webpack://./startup/main.less","webpack://./../imports/client/layouts/app/app.less","webpack://./../imports/client/styles/footer.import.less","webpack://./../imports/client/layouts/register/register.less","webpack://./../imports/client/layouts/register/forms.less","webpack://./../imports/client/styles/forms.less","webpack://./node_modules/simple-line-icons/less/simple-line-icons.less","webpack://./../imports/client/styles/sections.import.less","webpack://./../imports/client/styles/tables.less","webpack://./../imports/client/styles/tooltips.less","webpack://./../imports/client/components/utilities/sAlert.less","webpack://./../imports/client/components/tags/partnerRating.less","webpack://./../imports/client/components/header/headers.less","webpack://./../imports/client/components/header/item.less","webpack://./../imports/client/components/header/notifications.less","webpack://./../imports/client/components/tags/Avatar.less","webpack://./../imports/client/components/forms/input/address.less","webpack://./../imports/client/components/forms/input/forms.less","webpack://./../imports/client/components/tabs/tabs.less","webpack://./../imports/client/components/countdown/countdown.less","webpack://./../imports/client/components/utilities/milestones.less","webpack://./../imports/client/components/forms/uniforms/phoneInput.less","webpack://./../imports/client/components/utilities/stops-horizontal.less","webpack://./../imports/client/components/forms/uniforms/dateInput.less","webpack://./../imports/client/components/footer/footer.less","webpack://./../imports/client/views/register/sign-up.less","webpack://./../imports/client/views/account/portal/portal.less","webpack://./../imports/client/styles/container.import.less","webpack://./../imports/client/views/settings/settings.less","webpack://./../imports/client/views/settings/components/upgrade.less","webpack://./../imports/client/views/admin/admin.less","webpack://./../imports/client/views/dashboard/dashboard.less","webpack://./../imports/client/views/shipments/shipments.less","webpack://./../imports/client/views/shipments/view/view.less","webpack://./../imports/client/views/shipment/aside.less","webpack://./../imports/client/views/shipment/shipment.less","webpack://./../imports/client/views/shipment/sections/stages/components/dateColumn.less","webpack://./../imports/client/views/shipment/sections/stages/modals/stage-split.less","webpack://./../imports/client/views/shipment/sections/stages/modals/StageConfirm.less","webpack://./../imports/client/views/shipment/sections/costs/tableV2/costs.less","webpack://./../imports/client/views/shipment/sections/costs/costs.less","webpack://./../imports/client/views/shipment/sidebar/insights.less","webpack://./../imports/client/views/shipment/sidebar/carriers.less","webpack://./../imports/client/views/shipment-new/shipmentForm.less","webpack://./../imports/client/views/shipment-picking/detail/styles.less","webpack://./../imports/client/views/shipment-project/shipmentProject.less","webpack://./../imports/client/views/shipment-track/track.less","webpack://./../imports/client/layouts/track/track.less","webpack://./../imports/client/views/shipment-request/shipmentRequest.less","webpack://./../imports/client/views/shipment-project/components/inbound-outbound-shipment-table.less","webpack://./../imports/client/views/shipment-import/import.less","webpack://./../imports/client/views/shipment-import/aside.less","webpack://./../imports/client/views/dataImport/import.less","webpack://./../imports/client/views/partner-overview/partners.less","webpack://./../imports/client/views/partner-directory/directory.less","webpack://./../imports/client/views/partner-directory/card.less","webpack://./../imports/client/views/partner/tabs/profile.less","webpack://./../imports/client/views/partner/tabs/review/section/rating.less","webpack://./../imports/client/views/invoice/invoice.less","webpack://./../imports/client/views/address-overview/addresses.less","webpack://./../imports/client/views/address/address.less","webpack://./../imports/client/views/price-list/price-list.less","webpack://./../imports/client/views/price-list/segments/grid.less","webpack://./../imports/client/views/price-request/price-request.less","webpack://./../imports/client/views/analysis/simulation/analysis.less","webpack://./../imports/client/views/tender/tender.less","webpack://./../imports/client/views/reporting/reporting.less","webpack://./../imports/client/views/reporting/export/export.less","webpack://./../imports/client/views/tools/ocean-distance/oceanDistance.less","webpack://./../imports/client/views/tools/route-insight/routeInsight.less","webpack://./../imports/client/views/tools/price-lookup/price-lookup.less","webpack://./../imports/client/views/tenderify/tenderify.less","webpack://./../imports/client/views/tenderify/tabs/sheet/sideBar/sideBar.less"],"names":[],"mappings":"AAKA;EACE,yBAAA;ACJF;ADOA;EACE,aAAA;ACLF;ADQA;EACE,cAAA;ACNF;ADKA;EAII,kBAAA;EACA,wBAAA;ACNJ;ADUA;EACE,uBAAA;EACA,mCAAA;ACRF;ADWA;EACE,cAAA;ACTF;ADYA;EACE,gBAAA;EACA,0BAAA;ACVF;ADaA;;EAEE,aAAA;ACXF;ADcA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;ACZF;ADeA;EACE,kBAAA;ACbF;ADYA;EAII,kBAAA;EACA,MAAA;ACbJ;ADQA;;EAUI,iBAAA;ACdJ;ADIA;;EAaM,cAAA;EACA,kBAAA;ACbN;AC5CA;;EAEE,gBAAA;AD8CF;AC3CA;EACE,aAAA;AD6CF;AC9CA;EAII,YAAA;AD6CJ;ACjDA;EAQI,cAAA;AD4CJ;ACxCA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;AD0CF;AC7CA;EAMI,aAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AD0CJ;ACxDA;EAiBM,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EAEA,mBAAA;ADyCN;AC/DA;EA0BM,OAAA;EACA,mBAAA;ADwCN;ACnEA;EA8BQ,UAAA;EACA,cAAA;ADwCR;ACvEA;EAmCQ,mBAAA;ADuCR;AC1EA;EAyCI,WAAA;EACA,SAAA;EACA,YAAA;ADoCJ;AC/EA;EA8CM,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAEA,wBAAA;ADmCN;ACjCM;EACE,YAAA;ADmCR;AChCM;EACE,UAAA;ADkCR;AC7FA;EA+DQ,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,QAAA;ADiCR;ACpGA;EAwEM,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;AD+BN;AC3GA;EAgFM,aAAA;AD8BN;AC9GA;EAoFM,cAAA;AD6BN;ACjHA;EAyFQ,uBAAA;EACA,kBAAA;EACA,iGAAA;EAEA,iBAAA;EAEA,aAAA;ADyBR;ACxHA;EAoGM,iBAAA;EACA,oBAAA;ADuBN;ACrBM;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;ADuBR;ACnIA;EAkHI,OAAA;EACA,aAAA;EACA,qBAAA;ADoBJ;ACxIA;;;EA0HI,2BAAA;ADmBJ;AC7IA;EA8HI,8BAAA;EACA,OAAA;EACA,WAAA;ADkBJ;AClJA;EAmIM,aAAA;ADkBN;ACrJA;EAuIM,kBAAA;EACA,UAAA;ADiBN;ACzJA;EA4IM,WAAA;EACA,oBAAA;ADgBN;AC7JA;;EAmJI,cAAA;ADcJ;ACjKA;;EAsJM,oCAAA;ADeN;ACbM;;EACE,gBAAA;ADgBR;ACzKA;;EA8JM,YAAA;ADeN;ACZM;;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;ADeR;ACnLA;;;;EAyKQ,eAAA;EACA,mBAAA;ADgBR;AC1LA;EAgLI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;ADaJ;AChMA;EAsLM,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;ADaN;ACtMA;EA6LM,uBAAA;ADYN;ACzMA;EAgMQ,cAAA;EACA,eAAA;EACA,gBAAA;ADYR;AC9MA;EAqMU,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;ADYV;ACNM;EAGE,YAAA;EACA,6BAAA;EAEA,yBAAA;ADKR;ACzNA;;;EA2NQ,2BAAA;ADGR;AC9NA;EChBI,2BAAA;AFiPJ;ACjOA;ECXI,0BAAA;EACA,cAAA;AF+OJ;ACrOA;ECJI,oBAAA;AF4OJ;ACxOA;;;ECMI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFuOJ;AChPA;ECaI,gBAAA;EACA,WAAA;AFsOJ;ACpPA;;EAuOM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;ADiBN;AC3PA;;EA6OQ,iBAAA;EAEA,iBAAA;ADiBR;ACfQ;;EACE,oCAAA;ADkBV;AChBU;;EACE,oCAAA;EACA,kCAAA;ADmBZ;AChBU;;EACE,gBAAA;ADmBZ;AC7QA;;EAgQQ,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;ADiBR;ACpRA;EAyQI,QAAA;EAEA,mCAAA;EACA,yBAAA;ADaJ;ACXI;EACE,gBAAA;EACA,WAAA;ADaN;ACXI;EACE,WAAA;EACA,YAAA;EACA,gCAAA;ADaN;AClSA;EAyRM,qBAAA;EACA,eAAA;ADYN;ACtSA;EA8RM,eAAA;EACA,eAAA;ADWN;AC1SA;EAkSQ,eAAA;ADWR;AC7SA;EAuSM,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ADSN;ACPM;EACE,aAAA;ADSR;ACtTA;EAkTM,aAAA;ADON;ACzTA;EAsTM,YAAA;ADMN;AC5TA;EA0TM,cAAA;EACA,gBAAA;ADKN;AChUA;EA8TQ,QAAA;ADKR;ACnUA;EAkUQ,iBAAA;ADIR;ACtUA;EAsUQ,kBAAA;ADGR;ACzUA;EA2UM,yBAAA;ADCN;ACCM;EACE,yBAAA;ADCR;ACME;EAAA;;;IAII,iBAAA;IACA,YAAA;IACA,+BAAA;EDJJ;ECFA;IAUI,cAAA;IACA,aAAA;EDLJ;ECNA;IAgBI,8BAAA;EDPJ;AACF;ACWA;EAEE,yBAAA;ADVF;ACaA;EAEE,yBAAA;ADZF;AGzXA;EACE,aAAA;EACA,wBAAA;EACA,YAAA;AH2XF;AG9XA;EAMI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AH2XJ;AGzXI;EAAA;IACE,UAAA;EH4XJ;AACF;AG3XI;EAAA;IACE,UAAA;EH8XJ;AACF;AG7XI;EAAA;IACE,UAAA;EHgYJ;AACF;AG/XI;EAAA;IACE,UAAA;EHkYJ;AACF;AG5ZA;EA6BM,cAAA;EACA,gBAAA;AHkYN;AGhaA;EAkCM,YAAA;EACA,mBAAA;EACA,kBAAA;AHiYN;AGraA;EAyCI,cAAA;EACA,mDAAA;EACA,sBAAA;EACA,2BAAA;AH+XJ;AI3aA;EAGG,yBAAA;EACA,YAAA;AJ2aH;AI/aA;EAOG,oCAAA;EACA,yBAAA;EACA,YAAA;AJ2aH;AIpbA;EAeG,yBAAA;EACA,YAAA;AJwaH;AIxbA;EAoBG,oBAAA;AJuaH;AE3bA;EAII,2BAAA;AF0bJ;AE9bA;EASI,0BAAA;EACA,cAAA;AFwbJ;AElcA;EAgBI,oBAAA;AFqbJ;AErcA;;;EA0BI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFgbJ;AE7cA;EAiCI,gBAAA;EACA,WAAA;AF+aJ;AE3aA;EAEI,iCAAA;EACA,qCAAA;AF4aJ;AEraI;EAAA;IAII,aAAA;EFqaN;AACF;AK3dA;EAEI,cAAA;AL4dJ;AK9dA;EAMI,aAAA;AL2dJ;AKjeA;EASM,kBAAA;AL2dN;AKpeA;EAYM,OAAA;AL2dN;AKtdA;EAEI,YAAA;ALudJ;AKldA;EACE,sBAAA;ALodF;AACA;;CAEC;AMzeD;EACM,gCAAA;EACA,4CAAA;EACA,4SAAA;EAKA,mBAAA;EACA,kBAAA;ANueN;AACA;;;;CAIC;AMleC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6LE,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;ENoeF,sCAAsC;EMjepC,mCAAA;EACA,kCAAA;ANmeJ;AM/dC;EACC,gBAAA;ANieF;AM9dC;EACC,gBAAA;ANgeF;AM7dC;EACC,gBAAA;AN+dF;AM5dC;EACC,gBAAA;AN8dF;AM3dC;EACC,gBAAA;AN6dF;AM1dC;EACC,gBAAA;AN4dF;AMzdC;EACC,gBAAA;AN2dF;AMxdC;EACC,gBAAA;AN0dF;AMvdC;EACC,gBAAA;ANydF;AMtdC;EACC,gBAAA;ANwdF;AMrdC;EACC,gBAAA;ANudF;AMpdC;EACC,gBAAA;ANsdF;AMndC;EACC,gBAAA;ANqdF;AMldC;EACC,gBAAA;ANodF;AMjdC;EACC,gBAAA;ANmdF;AMhdC;EACC,gBAAA;ANkdF;AM/cC;EACC,gBAAA;ANidF;AM9cC;EACC,gBAAA;ANgdF;AM7cC;EACC,gBAAA;AN+cF;AM5cC;EACC,gBAAA;AN8cF;AM3cC;EACC,gBAAA;AN6cF;AM1cC;EACC,gBAAA;AN4cF;AMzcC;EACC,gBAAA;AN2cF;AMxcC;EACC,gBAAA;AN0cF;AMvcC;EACC,gBAAA;ANycF;AMtcC;EACC,gBAAA;ANwcF;AMrcC;EACC,gBAAA;ANucF;AMpcC;EACC,gBAAA;ANscF;AMncC;EACC,gBAAA;ANqcF;AMlcC;EACC,gBAAA;ANocF;AMjcC;EACC,gBAAA;ANmcF;AMhcC;EACC,gBAAA;ANkcF;AM/bC;EACC,gBAAA;ANicF;AM9bC;EACC,gBAAA;ANgcF;AM7bC;EACC,gBAAA;AN+bF;AM5bC;EACC,gBAAA;AN8bF;AM3bC;EACC,gBAAA;AN6bF;AM1bC;EACC,gBAAA;AN4bF;AMzbC;EACC,gBAAA;AN2bF;AMxbC;EACC,gBAAA;AN0bF;AMvbC;EACC,gBAAA;ANybF;AMtbC;EACC,gBAAA;ANwbF;AMrbC;EACC,gBAAA;ANubF;AMpbC;EACC,gBAAA;ANsbF;AMnbC;EACC,gBAAA;ANqbF;AMlbC;EACC,gBAAA;ANobF;AMjbC;EACC,gBAAA;ANmbF;AMhbC;EACC,gBAAA;ANkbF;AM/aC;EACC,gBAAA;ANibF;AM9aC;EACC,gBAAA;ANgbF;AM7aC;EACC,gBAAA;AN+aF;AM5aC;EACC,gBAAA;AN8aF;AM3aC;EACC,gBAAA;AN6aF;AM1aC;EACC,gBAAA;AN4aF;AMzaC;EACC,gBAAA;AN2aF;AMxaC;EACC,gBAAA;AN0aF;AMvaC;EACC,gBAAA;ANyaF;AMtaC;EACC,gBAAA;ANwaF;AMraC;EACC,gBAAA;ANuaF;AMpaC;EACC,gBAAA;ANsaF;AMnaC;EACC,gBAAA;ANqaF;AMlaC;EACC,gBAAA;ANoaF;AMjaC;EACC,gBAAA;ANmaF;AMhaC;EACC,gBAAA;ANkaF;AM/ZC;EACC,gBAAA;ANiaF;AM9ZC;EACC,gBAAA;ANgaF;AM7ZC;EACC,gBAAA;AN+ZF;AM5ZC;EACC,gBAAA;AN8ZF;AM3ZC;EACC,gBAAA;AN6ZF;AM1ZC;EACC,gBAAA;AN4ZF;AMzZC;EACC,gBAAA;AN2ZF;AMxZC;EACC,gBAAA;AN0ZF;AMvZC;EACC,gBAAA;ANyZF;AMtZC;EACC,gBAAA;ANwZF;AMrZC;EACC,gBAAA;ANuZF;AMpZC;EACC,gBAAA;ANsZF;AMnZC;EACC,gBAAA;ANqZF;AMlZC;EACC,gBAAA;ANoZF;AMjZC;EACC,gBAAA;ANmZF;AMhZC;EACC,gBAAA;ANkZF;AM/YC;EACC,gBAAA;ANiZF;AM9YC;EACC,gBAAA;ANgZF;AM7YC;EACC,gBAAA;AN+YF;AM5YC;EACC,gBAAA;AN8YF;AM3YC;EACC,gBAAA;AN6YF;AM1YC;EACC,gBAAA;AN4YF;AMzYC;EACC,gBAAA;AN2YF;AMxYC;EACC,gBAAA;AN0YF;AMvYC;EACC,gBAAA;ANyYF;AMtYC;EACC,gBAAA;ANwYF;AMrYC;EACC,gBAAA;ANuYF;AMpYC;EACC,gBAAA;ANsYF;AMnYC;EACC,gBAAA;ANqYF;AMlYC;EACC,gBAAA;ANoYF;AMjYC;EACC,gBAAA;ANmYF;AMhYC;EACC,gBAAA;ANkYF;AM/XC;EACC,gBAAA;ANiYF;AM9XC;EACC,gBAAA;ANgYF;AM7XC;EACC,gBAAA;AN+XF;AM5XC;EACC,gBAAA;AN8XF;AM3XC;EACC,gBAAA;AN6XF;AM1XC;EACC,gBAAA;AN4XF;AMzXC;EACC,gBAAA;AN2XF;AMxXC;EACC,gBAAA;AN0XF;AMvXC;EACC,gBAAA;ANyXF;AMtXC;EACC,gBAAA;ANwXF;AMrXC;EACC,gBAAA;ANuXF;AMpXC;EACC,gBAAA;ANsXF;AMnXC;EACC,gBAAA;ANqXF;AMlXC;EACC,gBAAA;ANoXF;AMjXC;EACC,gBAAA;ANmXF;AMhXC;EACC,gBAAA;ANkXF;AM/WC;EACC,gBAAA;ANiXF;AM9WC;EACC,gBAAA;ANgXF;AM7WC;EACC,gBAAA;AN+WF;AM5WC;EACC,gBAAA;AN8WF;AM3WC;EACC,gBAAA;AN6WF;AM1WC;EACC,gBAAA;AN4WF;AMzWC;EACC,gBAAA;AN2WF;AMxWC;EACC,gBAAA;AN0WF;AMvWC;EACC,gBAAA;ANyWF;AMtWC;EACC,gBAAA;ANwWF;AMrWC;EACC,gBAAA;ANuWF;AMpWC;EACC,gBAAA;ANsWF;AMnWC;EACC,gBAAA;ANqWF;AMlWC;EACC,gBAAA;ANoWF;AMjWC;EACC,gBAAA;ANmWF;AMhWC;EACC,gBAAA;ANkWF;AM/VC;EACC,gBAAA;ANiWF;AM9VC;EACC,gBAAA;ANgWF;AM7VC;EACC,gBAAA;AN+VF;AM5VC;EACC,gBAAA;AN8VF;AM3VC;EACC,gBAAA;AN6VF;AM1VC;EACC,gBAAA;AN4VF;AMzVC;EACC,gBAAA;AN2VF;AMxVC;EACC,gBAAA;AN0VF;AMvVC;EACC,gBAAA;ANyVF;AMtVC;EACC,gBAAA;ANwVF;AMrVC;EACC,gBAAA;ANuVF;AMpVC;EACC,gBAAA;ANsVF;AMnVC;EACC,gBAAA;ANqVF;AMlVC;EACC,gBAAA;ANoVF;AMjVC;EACC,gBAAA;ANmVF;AMhVC;EACC,gBAAA;ANkVF;AM/UC;EACC,gBAAA;ANiVF;AM9UC;EACC,gBAAA;ANgVF;AM7UC;EACC,gBAAA;AN+UF;AM5UC;EACC,gBAAA;AN8UF;AM3UC;EACC,gBAAA;AN6UF;AM1UC;EACC,gBAAA;AN4UF;AMzUC;EACC,gBAAA;AN2UF;AMxUC;EACC,gBAAA;AN0UF;AMvUC;EACC,gBAAA;ANyUF;AMtUC;EACC,gBAAA;ANwUF;AMrUC;EACC,gBAAA;ANuUF;AMpUC;EACC,gBAAA;ANsUF;AMnUC;EACC,gBAAA;ANqUF;AMlUC;EACC,gBAAA;ANoUF;AMjUC;EACC,gBAAA;ANmUF;AMhUC;EACC,gBAAA;ANkUF;AM/TC;EACC,gBAAA;ANiUF;AM9TC;EACC,gBAAA;ANgUF;AM7TC;EACC,gBAAA;AN+TF;AM5TC;EACC,gBAAA;AN8TF;AM3TC;EACC,gBAAA;AN6TF;AM1TC;EACC,gBAAA;AN4TF;AMzTC;EACC,gBAAA;AN2TF;AMxTC;EACC,gBAAA;AN0TF;AMvTC;EACC,gBAAA;ANyTF;AMtTC;EACC,gBAAA;ANwTF;AMrTC;EACC,gBAAA;ANuTF;AMpTC;EACC,gBAAA;ANsTF;AMnTC;EACC,gBAAA;ANqTF;AMlTC;EACC,gBAAA;ANoTF;AMjTC;EACC,gBAAA;ANmTF;AMhTC;EACC,gBAAA;ANkTF;AM/SC;EACC,gBAAA;ANiTF;AM9SC;EACC,gBAAA;ANgTF;AM7SC;EACC,gBAAA;AN+SF;AM5SC;EACC,gBAAA;AN8SF;AM3SC;EACC,gBAAA;AN6SF;AM1SC;EACC,gBAAA;AN4SF;AMzSC;EACC,gBAAA;AN2SF;AMxSC;EACC,gBAAA;AN0SF;AMvSC;EACC,gBAAA;ANySF;AMtSC;EACC,gBAAA;ANwSF;AMrSC;EACC,gBAAA;ANuSF;AMpSC;EACC,gBAAA;ANsSF;AMnSC;EACC,gBAAA;ANqSF;AOrvCE;EACC,SAAA;APuvCH;AOpvCE;EACC,kBAAA;APsvCH;AO7vCA;;EAYG,mBAAA;APqvCH;AOjwCA;EAgBG,eAAA;EAEA,cAAA;APmvCH;AOrwCA;EAuBI,WAAA;EACA,kBAAA;EACA,eAAA;APivCJ;AO9uCG;EACC,gBAAA;APgvCJ;AO7wCA;EAmCI,cAAA;EACA,eAAA;EACA,iBAAA;AP6uCJ;AOlxCA;EAyCI,WAAA;AP4uCJ;AOrxCA;EA8CG,eAAA;EACA,WAAA;AP0uCH;AQzxCA;EAGE,WAAA;EACA,wBAAA;EACA,2BAAA;EACA,YAAA;ARyxCF;AQ/xCA;EAUM,mBAAA;ARwxCN;AQtxCM;;EAEE,cAAA;ARwxCR;AQtyCA;EAmBI,eAAA;EACA,iCAAA;ARsxCJ;AQpxCI;EACE,yBAAA;ARsxCN;AQ7yCA;EA4BM,sBAAA;ARoxCN;AQ7wCI;;EACE,kBAAA;EACA,mBAAA;ARgxCN;AQ9wCI;;EACE,mBAAA;ARixCN;AQ9wCI;;EACE,kBAAA;EACA,mBAAA;ARixCN;AACA,mBAAmB;AACnB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAgCI;AQ1wCJ;;ER6wCE;;;;;IAKE;AACJ;AQlxCE;;;;EAGI,mBAAA;ARqxCN;AQ1wCA;EAEI,uBAAA;EACA,YAAA;EACA,gCAAA;AR2wCJ;AQ/wCA;EAOM,eAAA;EACA,cAAA;EACA,cAAA;AR2wCN;AQ1wCM;;EAEE,eAAA;AR4wCR;AQxxCA;EAgBM,yBAAA;EACA,YAAA;AR2wCN;ASv4CA;EACC,qBAAA;EACA,eAAA;ATy4CD;ASv4CC;EACC,eAAA;EACA,qBAAA;ATy4CF;ASt4CC;EACC,iBAAA;ATw4CF;AUh5CA;EACE,wBAAA;AVk5CF;AU/4CA;EACE,0BAAA;AVi5CF;AU94CA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,2HAAA;EAEA,YAAA;EACA,qBAAA;AV+4CF;AU54CA;EACE,iBAAA;EACA,gBAAA;EACA,wBAAA;AV84CF;AWr6CA;EACC,WAAA;EACA,WAAA;AXu6CD;AWr6CA;EACC,YAAA;EACA,kBAAA;AXu6CD;AWr6CA;EACC,kBAAA;AXu6CD;AWr6CA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;AXu6CD;AWr6CA;EACE,WAAA;EACD,UAAA;AXu6CD;AYt7CA;EAEE,eAAA;EACA,iBAAA;EACA,cAAA;AZu7CF;AYp7CC;EACC,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AZs7CF;AYp7CE;EACC,gBAAA;AZs7CH;AY/7CC;EAaE,mBAAA;AZq7CH;Aaz8CA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;Ab28CF;Aax8CA;EAEE,mBAAA;Aby8CF;Aat8CA;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;Abw8CF;Aaj9CA;;EAaI,aAAA;Abw8CJ;Aar9CA;;EAgBM,iBAAA;Aby8CN;Aaz9CA;;EAoBM,kBAAA;EACA,4BAAA;Aby8CN;Aav8CM;;EACE,iBAAA;EACA,kBAAA;Ab08CR;Aan+CA;;EA6BQ,cAAA;Ab08CR;Aav+CA;EAmCI,OAAA;EACA,mBAAA;Abu8CJ;Aa3+CA;EAwCI,gBAAA;EACA,WAAA;EAEA,eAAA;Abq8CJ;Aah/CA;;EAiDI,UAAA;Abm8CJ;Aa/7CA;;EAGI,UAAA;Abg8CJ;Acl/CI;EACE,oBAAA;Ado/CN;Acr/CI;EAGI,YAAA;Adq/CR;AczgDA;EAwBM,uBAAA;EACA,iBAAA;Ado/CN;Ac7gDA;EA+BM,gBAAA;EACA,2BAAA;Adi/CN;AcjhDA;EAmCQ,2BAAA;EACA,4BAAA;Adi/CR;AcrhDA;EAuCQ,8BAAA;EACA,+BAAA;Adi/CR;AczhDA;EA4CQ,gBAAA;EACA,cAAA;Adg/CR;Ac7hDA;EAkDM,SAAA;EACA,6CAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;Ad8+CN;AcziDA;EAuEM,iCAAA;EACA,mBAAA;EACA,eAAA;Adq+CN;Acn+CM;EACE,mBAAA;Adq+CR;Acl+CM;EACE,mBAAA;Ado+CR;Acr+CM;EAII,YAAA;Ado+CV;Acl+CU;EACE,UAAA;Ado+CZ;Ac3+CM;EAWI,UAAA;Adm+CV;Ac7jDA;EA+FQ,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;Adi+CR;AcpkDA;EAsGU,6BAAA;Adi+CV;AcvkDA;EA0GU,cAAA;EACA,wBAAA;EACA,gBAAA;Adg+CV;Ac5kDA;EAgHU,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;Ad+9CV;Ac39CM;EACE,6BAAA;Ad69CR;Ac39CM;EACE,6BAAA;Ad69CR;Ae9lDA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;AfgmDF;AermDA;EAQI,YAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;Af+lDJ;AgBxmDA;EACE,kBAAA;EhB0mDA,0CAA0C;AAC5C;AgB5mDA;EAII,cAAA;EACA,UAAA;AhB2mDJ;AgBvmDE;EACE,aAAA;AhBymDJ;AgBnnDA;EAcI,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AhBwmDJ;AgB1nDA;EAsBI,kBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EhBumDF,8CAA8C;EgBpmD5C,yBAAA;EACA,kBAAA;EACA,iBAAA;EhBsmDF,iBAAiB;EgBnmDf,aAAA;AhBqmDJ;AgBpmDI;EACE,cAAA;AhBsmDN;AgB1oDA;;;EA0CM,kBAAA;AhBqmDN;AgB/oDA;EA+CQ,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AhBmmDR;AgBhmDM;EACE,6BAAA;AhBkmDR;AgBzpDA;;EA4DQ,2BAAA;AhBimDR;AgB7pDA;EAiEM,eAAA;AhB+lDN;AgBhqDA;EAoEQ,qBAAA;EACA,cAAA;AhB+lDR;AgB5lDM;EACE,mBAAA;AhB8lDR;AgB3lDM;EAEI,eAAA;AhB4lDV;AgB9lDM;EAMI,YAAA;AhB2lDV;AgBzlDU;EACE,aAAA;AhB2lDZ;AiBtrDA;EAEI,eAAA;AjBurDJ;AkBtrDA;EAEI,gBAAA;EACA,kBAAA;AlBurDJ;AkB1rDA;;EAOM,eAAA;EACA,cAAA;AlBurDN;AkB/rDA;EAYM,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,sBAAA;AlBsrDN;AkBprDM;EACE,4BAAA;AlBsrDR;AkBnrDM;EACE,cAAA;EACA,yBAAA;AlBqrDR;AmBptDA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AnBstDF;AmBntDA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AnBqtDF;AmBltDA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AnBotDF;AmBjtDA;EACE,gBAAA;EACA,eAAA;AnBmtDF;AoBzuDA;EAEI,eAAA;EAQA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,8BAAA;ApBkuDJ;AoBjvDA;EAKM,iBAAA;EACA,YAAA;EACA,uBAAA;ApB+uDN;AoBtvDA;EAkBM,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,uBAAA;EACA,UAAA;EACA,cAAA;ApBsuDN;AoBnuDI;;EAEE,cAAA;EACA,eAAA;ApBquDN;AoBluDI;EACE,8BAAA;ApBouDN;AqBtwDA;EACE,6BAAA;ArBwwDF;AsBzwDA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AtB2wDF;AsBxwDA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,uBAAA;EACA,2CAAA;EACA,8BAAA;AtB0wDF;AuBzxDA;EAEI,YAAA;AvB0xDJ;AuB5xDA;EAIM,cAAA;AvB2xDN;AwB/xDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AxBiyDF;AyBpyDA;EAGG,gBAAA;AzBoyDH;AyBvyDA;EAMI,iBAAA;AzBoyDJ;AyB1yDA;EAWG,cAAA;EACA,eAAA;AzBkyDH;AyB9yDA;EAeI,cAAA;EACA,0BAAA;AzBkyDJ;A0BlzDA;EAEI,WAAA;EACA,aAAA;EACA,WAAA;EACA,mDAAA;EACA,sBAAA;A1BmzDJ;A0BzzDA;EAUI,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;A1BkzDJ;A0Bl0DA;EAmBM,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;A1BkzDN;A2Bx0DA;EAEE,iBAAA;A3By0DF;A4Bt0DA;E1BEI,2BAAA;AFu0DJ;A4Bz0DA;E1BOI,0BAAA;EACA,cAAA;AFq0DJ;A4B70DA;E1BcI,oBAAA;AFk0DJ;A4Bh1DA;;;E1BwBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AF6zDJ;A4Bx1DA;E1B+BI,gBAAA;EACA,WAAA;AF4zDJ;AOz1DE;EACC,SAAA;AP21DH;AOx1DE;EACC,kBAAA;AP01DH;A4Bl2DA;;ErBaG,mBAAA;APy1DH;A4Bt2DA;ErBiBG,eAAA;EAEA,cAAA;APu1DH;A4B12DA;ErBwBI,WAAA;EACA,kBAAA;EACA,eAAA;APq1DJ;AOl1DG;EACC,gBAAA;APo1DJ;A4Bl3DA;ErBoCI,cAAA;EACA,eAAA;EACA,iBAAA;APi1DJ;A4Bv3DA;ErB0CI,WAAA;APg1DJ;A4B13DA;ErB+CG,eAAA;EACA,WAAA;AP80DH;A4B93DA;EDHE,iBAAA;A3Bo4DF;A4Bj4DA;EAKI,gBAAA;A5B+3DJ;A4Bp4DA;EAQI,iBAAA;A5B+3DJ;A6B14DA;EAEI,oCAAA;A7B24DJ;A8B74DA;EAEE,iBAAA;A9B84DF;A8Bh5DA;EAOG,sBAAA;A9B44DH;A8Bn5DA;EAUG,cAAA;A9B44DH;A8Bv4DE;EACC,YAAA;EACA,mBAAA;A9By4DH;AOp5DE;EACC,SAAA;APs5DH;AOn5DE;EACC,kBAAA;APq5DH;A+B95DA;;ExBcG,mBAAA;APo5DH;A+Bl6DA;ExBkBG,eAAA;EAEA,cAAA;APk5DH;A+Bt6DA;ExByBI,WAAA;EACA,kBAAA;EACA,eAAA;APg5DJ;AO74DG;EACC,gBAAA;AP+4DJ;A+B96DA;ExBqCI,cAAA;EACA,eAAA;EACA,iBAAA;AP44DJ;A+Bn7DA;ExB2CI,WAAA;AP24DJ;A+Bt7DA;ExBgDG,eAAA;EACA,WAAA;APy4DH;A+Bv7DI;EACE,aAAA;A/By7DN;A+B17DI;EAII,eAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,cAAA;A/By7DR;A+Bp8DA;EAgBM,YAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;A/Bu7DN;A+B18DA;EAuBM,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;A/Bs7DN;A+Bh9DA;EA8BM,eAAA;EACA,gBAAA;EACA,mBAAA;A/Bq7DN;A+Br9DA;EAmCM,aAAA;A/Bq7DN;A+Bx9DA;EAyCM,eAAA;EACA,cAAA;A/Bk7DN;A+B59DA;EA+CI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,gCAAA;A/Bg7DJ;A+Bl+DA;EAsDI,gBAAA;EACA,mBAAA;A/B+6DJ;A+Bt+DA;EA2DI,aAAA;A/B86DJ;A+Bz+DA;EA+DI,iBAAA;EACA,iBAAA;A/B66DJ;AgC7+DA;E9BGI,2BAAA;AF6+DJ;AgCh/DA;E9BQI,0BAAA;EACA,cAAA;AF2+DJ;AgCp/DA;E9BeI,oBAAA;AFw+DJ;AgCv/DA;;;E9ByBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFm+DJ;AgC//DA;E9BgCI,gBAAA;EACA,WAAA;AFk+DJ;AgCngEA;E9BuCI,iCAAA;EACA,qCAAA;AF+9DJ;AgCvgEA;EAKI,eAAA;AhCqgEJ;AgC1gEA;EASI,mBAAA;AhCogEJ;AgC7gEA;EAaI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,iCAAA;AhCmgEJ;AgCnhEA;;;EAwBM,2BAAA;AhCggEN;AgCxhEA;EA4BM,iBAAA;EAEA,iBAAA;AhC8/DN;AgC5/DM;EACE,oCAAA;AhC8/DR;AgC5/DQ;EACE,yBAAA;EACA,kCAAA;AhC8/DV;AgC3/DQ;EACE,gBAAA;AhC6/DV;AiCtiEA;E/BGI,2BAAA;AFsiEJ;AiCziEA;E/BQI,0BAAA;EACA,cAAA;AFoiEJ;AiC7iEA;E/BeI,oBAAA;AFiiEJ;AiChjEA;;;E/ByBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AF4hEJ;AiCxjEA;E/BgCI,gBAAA;EACA,WAAA;AF2hEJ;AiCxjEE;EACC,oCAAA;AjC0jEH;AiC/jEA;EASG,eAAA;AjCyjEH;AiClkEA;EAgBE,iBAAA;EACA,gBAAA;AjCqjEF;AiCnjEE;EACC,iBAAA;AjCqjEH;AiCljEE;EACC,aAAA;AjCojEH;AiC5kEA;EA6BE,YAAA;EACA,kBAAA;AjCkjEF;AiChlEA;EAkCE,aAAA;EACA,mBAAA;EACA,kBAAA;AjCijEF;AiCrlEA;EAuCG,YAAA;AjCijEH;AiCxlEA;EA2CG,mBAAA;AjCgjEH;AiC3lEA;EA+CG,qBAAA;AjC+iEH;AiC9lEA;EAmDG,YAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;AjC8iEH;AiC5iEG;EACC,4BAAA;AjC8iEJ;AiCxmEA;EA8DI,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AjC6iEJ;AiC/mEA;EAsEI,WAAA;AjC4iEJ;AkCpnEA;EAEI,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AlCqnEJ;AkChoEA;EAeI,YAAA;EACA,mBAAA;EACA,mBAAA;AlConEJ;AkCroEA;EAoBM,YAAA;EACA,qBAAA;AlConEN;AkCzoEA;EA0BI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,8BAAA;AlCinEJ;AkChpEA;EAkCM,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,yBAAA;EACA,UAAA;EACA,cAAA;AlCgnEN;AkCxpEA;EA4CM,cAAA;EACA,eAAA;AlC+mEN;AkC5mEI;EACE,8BAAA;AlC8mEN;AkC/pEA;EAqDM,6BAAA;AlC6mEN;AkC3mEM;EACE,yBAAA;AlC6mER;AkC9mEM;EAII,8BAAA;EACA,eAAA;AlC6mEV;AmCpqEA;EACE,uBAAA;AnCsqEF;AmClqEA;EjCLI,2BAAA;AF0qEJ;AmCrqEA;EjCAI,0BAAA;EACA,cAAA;AFwqEJ;AmCzqEA;EjCOI,oBAAA;AFqqEJ;AmC5qEA;;;EjCiBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFgqEJ;AmCprEA;EjCwBI,gBAAA;EACA,WAAA;AF+pEJ;AmCxrEA;EAKI,YAAA;EACA,iBAAA;AnCsrEJ;AmC5rEA;EAUI,oBAAA;AnCqrEJ;AmC/rEA;EAeI,gBAAA;EACA,MAAA;AnCmrEJ;AmCnsEA;EAoBI,UAAA;EACA,mBAAA;AnCkrEJ;AmCvsEA;EAwBM,aAAA;EACA,WAAA;AnCkrEN;AmC3sEA;;EA+BI,YAAA;EACA,cAAA;AnCgrEJ;AmChtEA;EAqCM,WAAA;AnC8qEN;AmCntEA;EAwCQ,yBAAA;AnC8qER;AmCttEA;EA8CI,eAAA;AnC2qEJ;AmCztEA;EAoDQ,gBAAA;EACA,cAAA;AnCwqER;AmCrqEM;;;EAKI,6BAAA;AnCqqEV;AmCnqEU;;;EACE,yBAAA;AnCuqEZ;AmCxqEU;;;EAII,8BAAA;EACA,eAAA;AnCyqEd;AmC7uEA;EA2EQ,eAAA;AnCqqER;AmChvEA;EA+EQ,qBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;AnCoqER;AmCtvEA;EAwFI,oCAAA;AnCiqEJ;AmC/pEI;EACE,oCAAA;AnCiqEN;AmC5vEA;EAgGQ,YAAA;EACA,eAAA;EACA,mBAAA;AnC+pER;AmCjwEA;EAsGQ,eAAA;EACA,YAAA;AnC8pER;AOzwEE;EACC,SAAA;AP2wEH;AOxwEE;EACC,kBAAA;AP0wEH;AmC3wEA;;E5BMG,mBAAA;APywEH;AmC/wEA;E5BUG,eAAA;EAEA,cAAA;APuwEH;AmCnxEA;E5BiBI,WAAA;EACA,kBAAA;EACA,eAAA;APqwEJ;AOlwEG;EACC,gBAAA;APowEJ;AmC3xEA;E5B6BI,cAAA;EACA,eAAA;EACA,iBAAA;APiwEJ;AmChyEA;E5BmCI,WAAA;APgwEJ;AmCnyEA;E5BwCG,eAAA;EACA,WAAA;AP8vEH;AmCvyEA;EAgHM,oBAAA;EACA,cAAA;AnC0rEN;AmC3yEA;EAyHU,4BAAA;AnCqrEV;AmC9yEA;EA+HU,cAAA;AnCkrEV;AmCjzEA;EAmIU,cAAA;AnCirEV;AmCxqEA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EAGA,UAAA;EACA,kCAAA;AnCwqEF;AmCrqEA;;;EAIE,eAAA;EAEA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,0BAAA;EAEA,yBAAA;EACA,0BAAA;AnCmqEF;AmCjqEE;;;EACE,yBAAA;EACA,WAAA;EACA,YAAA;AnCqqEJ;AmC9rEA;;;EA4BI,oBAAA;AnCuqEJ;AmCnqEA;EACE,kBAAA;EACA,qBAAA;EACA,qCAAA;AnCqqEF;AmCxqEA;EAMI,WAAA;EACA,2BAAA;AnCqqEJ;AoCj3EA;EAEI,0BAAA;ApCk3EJ;AoCp3EA;EAKI,2BAAA;ApCk3EJ;AqCv3EA;EAEE,cAAA;ArCw3EF;AsC13EA;EACE,aAAA;EACA,8BAAA;AtC43EF;AsC93EA;EAII,2BAAA;AtC63EJ;AsCj4EA;EAMM,2BAAA;AtC83EN;AsC13EI;EACE,wBAAA;AtC43EN;AsC73EI;EAGI,mBAAA;AtC63ER;AuC14EA;EACE,oCAAA;EACA,+BAAA;EACA,8BAAA;EACA,iCAAA;EACA,gCAAA;AvC44EF;AuCj5EA;EAQI,wBAAA;EACA,8BAAA;AvC44EJ;AuCr5EA;EAaI,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;AvC24EJ;AuC35EA;EAoBI,aAAA;EACA,mBAAA;EACA,8BAAA;AvC04EJ;AuCh6EA;EAyBM,kBAAA;AvC04EN;AuCn6EA;EA+BM,mBAAA;AvCu4EN;AuCt6EA;EAoCI,kCAAA;EACA,YAAA;AvCq4EJ;AwC16EA;EACE,yBAAA;EACA,uBAAA;EACA,2BAAA;AxC46EF;AwCx6EA;EAEI,WAAA;AxCy6EJ;AwC36EA;EAKM,WAAA;AxCy6EN;AyCr7EA;EAEI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AzCs7EJ;AyC37EA;EASI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,UAAA;EACA,uBAAA;EACA,2CAAA;EACA,8BAAA;AzCq7EJ;A0Cl8EA;EACC,aAAA;A1Co8ED;A0Cr8EA;EAIE,eAAA;A1Co8EF;A0Cx8EA;EAQE,cAAA;A1Cm8EF;A2C58EA;EzCKI,2BAAA;AF08EJ;A2C/8EA;EzCUI,0BAAA;EACA,cAAA;AFw8EJ;A2Cn9EA;EzCiBI,oBAAA;AFq8EJ;A2Ct9EA;;;EzC2BI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFg8EJ;A2C99EA;EzCkCI,gBAAA;EACA,WAAA;AF+7EJ;A4Cp+EA;EACE,yBAAA;EACA,6BAAA;EACA,2BAAA;A5Cs+EF;A4Cn+EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;A5Cq+EF;A4C1+EA;EAQI,gBAAA;A5Cq+EJ;A4Cj+EA;EACE,eAAA;A5Cm+EF;A4C/9EE;;EACE,eAAA;A5Ck+EJ;A4Cn+EE;;;EAII,eAAA;A5Co+EN;A4C/9EA;EAEI,iBAAA;EACA,oBAAA;A5Cg+EJ;A4C39EE;EACE,eAAA;A5C69EJ;A4C19EE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;A5C49EJ;A4Cx9EA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,2BAAA;A5C09EF;A4Cv9EA;EACE,aAAA;EACA,mBAAA;A5Cy9EF;A4C39EA;EAKI,iBAAA;A5Cy9EJ;A4Cr9EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;A5Cu9EF;A4C19EA;EAMI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A5Cu9EJ;A4Ch+EA;EAaI,iBAAA;A5Cs9EJ;A4Cl9EA;EAEI,iBAAA;A5Cm9EJ;A4C98EE;EACE,qEAAA;A5Cg9EJ;A4C58EA;EACE,sBAAA;A5C88EF;AOziFE;EACC,SAAA;AP2iFH;AOxiFE;EACC,kBAAA;AP0iFH;A6CljFA;;EtCaG,mBAAA;APyiFH;A6CtjFA;EtCiBG,eAAA;EAEA,cAAA;APuiFH;A6C1jFA;EtCwBI,WAAA;EACA,kBAAA;EACA,eAAA;APqiFJ;AOliFG;EACC,gBAAA;APoiFJ;A6ClkFA;EtCoCI,cAAA;EACA,eAAA;EACA,iBAAA;APiiFJ;A6CvkFA;EtC0CI,WAAA;APgiFJ;A6C1kFA;EtC+CG,eAAA;EACA,WAAA;AP8hFH;A6C9kFA;EAKI,aAAA;EACA,sBAAA;A7C4kFJ;A6CllFA;EAUI,cAAA;A7C2kFJ;A6CrlFA;EAcI,6BAAA;A7C0kFJ;A6CxkFI;EACE,yBAAA;A7C0kFN;A6C3kFI;EAII,8BAAA;EACA,eAAA;A7C0kFR;A8ClmFA;EAEI,sBAAA;EACA,kBAAA;A9CmmFJ;A8CtmFA;EAOQ,aAAA;EACA,aAAA;EACA,kBAAA;A9CkmFR;A8C3mFA;EAaQ,gBAAA;EACA,iBAAA;A9CimFR;A8C/mFA;EAkBQ,eAAA;A9CgmFR;A8ClnFA;EAqBU,cAAA;A9CgmFV;A8CrnFA;EA6BM,eAAA;A9C2lFN;A8CxnFA;EAiCM,qBAAA;EACA,cAAA;EACA,gBAAA;A9C0lFN;A8C7nFA;;EAwCM,WAAA;EACA,sBAAA;EACA,kBAAA;A9CylFN;A8CnoFA;EA8CM,yBAAA;A9CwlFN;A8CtoFA;EAoDM,mBAAA;A9CqlFN;A8CzoFA;EAwDM,kBAAA;EACA,iBAAA;EACA,mBAAA;A9ColFN;A8C/kFA;EACE,iBAAA;EACA,aAAA;EACA,aAAA;A9CilFF;A8C9kFA;EACE,WAAA;EACA,kBAAA;A9CglFF;A8C7kFA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;A9C+kFF;A+C5pFA;EACE,iBAAA;EACA,aAAA;A/C8pFF;A+ChqFA;EAKI,oBAAA;A/C8pFJ;A+CnqFA;EAOM,YAAA;A/C+pFN;A+CtqFA;EAWM,WAAA;EACA,eAAA;A/C8pFN;A+C1qFA;EAiBI,eAAA;EACA,iBAAA;EACA,cAAA;A/C4pFJ;A+C/qFA;EAsBI,eAAA;A/C4pFJ;A+ClrFA;EAyBI,kBAAA;A/C4pFJ;AgDrrFA;EAEI,eAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,uBAAA;AhDsrFJ;AiD/rFA;EACE,kBAAA;EACA,YAAA;AjDisFF;AiDnsFA;EAKI,gBAAA;EACA,YAAA;AjDisFJ;AiD7rFA;EACE,aAAA;AjD+rFF;AiD5rFA;EACE,0BAAA;AjD8rFF;AiD3rFA;EACE,yBAAA;AjD6rFF;AkD5sFA;EhDGI,2BAAA;AF4sFJ;AkD/sFA;EhDQI,0BAAA;EACA,cAAA;AF0sFJ;AkDntFA;EhDeI,oBAAA;AFusFJ;AkDttFA;;;EhDyBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFksFJ;AkD9tFA;EhDgCI,gBAAA;EACA,WAAA;AFisFJ;AkDluFA;EAII,mCAAA;EACA,cAAA;AlDiuFJ;AkDtuFA;EASI,aAAA;AlDguFJ;AkDzuFA;EAaI,cAAA;AlD+tFJ;AkD5uFA;EAiBI,gBAAA;AlD8tFJ;AkD/uFA;EAqBI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AlD6tFJ;AkDvvFA;EA8BI,4BAAA;EACA,eAAA;AlD4tFJ;AkD3vFA;EAkCM,kBAAA;AlD4tFN;AkD9vFA;EAuCI,kBAAA;EACA,gBAAA;EACA,mBAAA;AlD0tFJ;AkDnwFA;EA6CI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;AlDytFJ;AkDttFM;EACE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;AlDwtFR;AkDxxFA;EAsEI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;AlDqtFJ;AkDltFM;EACE,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AlDotFR;AmDlyFA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;AnDoyFF;AmDvyFA;EAMI,kBAAA;EACA,oBAAA;EACA,iBAAA;AnDoyFJ;AmDlyFI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AnDoyFN;AmDjyFI;EACE,MAAA;EACA,aAAA;EAEA,aAAA;AnDkyFN;AmD/xFI;EACE,MAAA;EACA,cAAA;AnDiyFN;AmD7xFI;EACE,WAAA;AnD+xFN;AmD5xFI;EACE,YAAA;EACA,YAAA;AnD8xFN;AmDzxFM;;EACE,YAAA;AnD4xFR;AmDxxFI;EACE,YAAA;AnD0xFN;AmDvxFI;EACE,YAAA;EACA,YAAA;AnDyxFN;AmDtxFI;;EAEE,YAAA;AnDwxFN;AmDpxFI;EACE,YAAA;AnDsxFN;AmDr1FA;;EAoEM,eAAA;EACA,eAAA;AnDqxFN;AmD11FA;EAyEM,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AnDoxFN;AmDlxFM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AnDoxFR;AmD12FA;EA2FM,aAAA;EACA,eAAA;EACA,6BAAA;AnDkxFN;AmD/wFI;;EAGI,6BAAA;AnDgxFR;AmDnxFI;;EAMI,cAAA;AnDixFR;AmD7wFI;;;EAGE,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AnD+wFN;AmD5wFI;EACE,YAAA;EACA,cAAA;EAEA,gEAAA;EAEA,mCAAA;AnD4wFN;AmDzwFI;EACE,kBAAA;AnD2wFN;AmD3tFQ;EACE,UAAA;AnD6tFV;AmDpvFU;EACE,+IAAA;AnDsvFZ;AmDxvFS;EAiBG,eAAA;AnD0uFZ;AmD1vFU;EACE,iJAAA;AnD4vFZ;AmD9vFS;EAiBG,cAAA;AnDgvFZ;AmDhwFU;EACE,iJAAA;AnDkwFZ;AmDpwFS;EAiBG,cAAA;AnDsvFZ;AmDtwFU;EACE,iJAAA;AnDwwFZ;AmD1wFS;EAiBG,cAAA;AnD4vFZ;AmD5wFU;EACE,iJAAA;AnD8wFZ;AmDhxFS;EAiBG,cAAA;AnDkwFZ;AmDlxFU;EACE,+IAAA;AnDoxFZ;AmDtxFS;EAiBG,cAAA;AnDwwFZ;AmDxxFU;EACE,iJAAA;AnD0xFZ;AmD5xFS;EAiBG,cAAA;AnD8wFZ;AmD9xFU;EACE,iJAAA;AnDgyFZ;AmDlyFS;EAiBG,cAAA;AnDoxFZ;AmDpyFU;EACE,iJAAA;AnDsyFZ;AmDxyFS;EAiBG,cAAA;AnD0xFZ;AmD1yFU;EACE,iJAAA;AnD4yFZ;AmD9yFS;EAiBG,cAAA;AnDgyFZ;AmDhzFU;EACE,+IAAA;AnDkzFZ;AmDpzFS;EAiBG,cAAA;AnDsyFZ;AmDtzFU;EACE,iJAAA;AnDwzFZ;AmD1zFS;EAiBG,cAAA;AnD4yFZ;AmD5zFU;EACE,iJAAA;AnD8zFZ;AmDh0FS;EAiBG,cAAA;AnDkzFZ;AmDl0FU;EACE,iJAAA;AnDo0FZ;AmDt0FS;EAiBG,cAAA;AnDwzFZ;AmDx0FU;EACE,iJAAA;AnD00FZ;AmD50FS;EAiBG,cAAA;AnD8zFZ;AmD90FU;EACE,+IAAA;AnDg1FZ;AmDl1FS;EAiBG,cAAA;AnDo0FZ;AmDp1FU;EACE,iJAAA;AnDs1FZ;AmDx1FS;EAiBG,cAAA;AnD00FZ;AmD11FU;EACE,iJAAA;AnD41FZ;AmD91FS;EAiBG,cAAA;AnDg1FZ;AmDh2FU;EACE,iJAAA;AnDk2FZ;AmDp2FS;EAiBG,cAAA;AnDs1FZ;AmDt2FU;EACE,iJAAA;AnDw2FZ;AmD12FS;EAiBG,cAAA;AnD41FZ;AmD52FU;EACE,+IAAA;AnD82FZ;AmDh3FS;EAiBG,cAAA;AnDk2FZ;AmDl3FU;EACE,iJAAA;AnDo3FZ;AmDt3FS;EAiBG,cAAA;AnDw2FZ;AmDx3FU;EACE,iJAAA;AnD03FZ;AmD53FS;EAiBG,cAAA;AnD82FZ;AmD93FU;EACE,gJAAA;AnDg4FZ;AmDl4FS;EAiBG,cAAA;AnDo3FZ;AmDp4FU;EACE,gJAAA;AnDs4FZ;AmDx4FS;EAiBG,cAAA;AnD03FZ;AmD14FU;EACE,8IAAA;AnD44FZ;AmD94FS;EAiBG,cAAA;AnDg4FZ;AmDh5FU;EACE,iJAAA;AnDk5FZ;AmDp5FS;EAiBG,cAAA;AnDs4FZ;AmDt5FU;EACE,iJAAA;AnDw5FZ;AmD15FS;EAiBG,cAAA;AnD44FZ;AmD55FU;EACE,kJAAA;AnD85FZ;AmDh6FS;EAiBG,cAAA;AnDk5FZ;AmDl6FU;EACE,kJAAA;AnDo6FZ;AmDt6FS;EAiBG,cAAA;AnDw5FZ;AmDx6FU;EACE,gJAAA;AnD06FZ;AmD56FS;EAiBG,cAAA;AnD85FZ;AmD96FU;EACE,kJAAA;AnDg7FZ;AmDl7FS;EAiBG,cAAA;AnDo6FZ;AmDp7FU;EACE,kJAAA;AnDs7FZ;AmDx7FS;EAiBG,cAAA;AnD06FZ;AmD17FU;EACE,kJAAA;AnD47FZ;AmD97FS;EAiBG,cAAA;AnDg7FZ;AmDh8FU;EACE,kJAAA;AnDk8FZ;AmDp8FS;EAiBG,cAAA;AnDs7FZ;AmDt8FU;EACE,gJAAA;AnDw8FZ;AmD18FS;EAiBG,cAAA;AnD47FZ;AmD58FU;EACE,kJAAA;AnD88FZ;AmDh9FS;EAiBG,cAAA;AnDk8FZ;AmDl9FU;EACE,kJAAA;AnDo9FZ;AmDt9FS;EAiBG,cAAA;AnDw8FZ;AmDx9FU;EACE,kJAAA;AnD09FZ;AmD59FS;EAiBG,cAAA;AnD88FZ;AmD99FU;EACE,kJAAA;AnDg+FZ;AmDl+FS;EAiBG,cAAA;AnDo9FZ;AmDp+FU;EACE,gJAAA;AnDs+FZ;AmDx+FS;EAiBG,cAAA;AnD09FZ;AmD1+FU;EACE,kJAAA;AnD4+FZ;AmD9+FS;EAiBG,cAAA;AnDg+FZ;AmDh/FU;EACE,kJAAA;AnDk/FZ;AmDp/FS;EAiBG,cAAA;AnDs+FZ;AmDt/FU;EACE,kJAAA;AnDw/FZ;AmD1/FS;EAiBG,cAAA;AnD4+FZ;AmD5/FU;EACE,kJAAA;AnD8/FZ;AmDhgGS;EAiBG,cAAA;AnDk/FZ;AmDlgGU;EACE,gJAAA;AnDogGZ;AmDtgGS;EAiBG,cAAA;AnDw/FZ;AmDxgGU;EACE,kJAAA;AnD0gGZ;AmD5gGS;EAiBG,cAAA;AnD8/FZ;AmD9gGU;EACE,kJAAA;AnDghGZ;AmDlhGS;EAiBG,cAAA;AnDogGZ;AmDphGU;EACE,kJAAA;AnDshGZ;AmDxhGS;EAiBG,cAAA;AnD0gGZ;AmD1hGU;EACE,kJAAA;AnD4hGZ;AmD9hGS;EAiBG,cAAA;AnDghGZ;AmDhiGU;EACE,gJAAA;AnDkiGZ;AmDpiGS;EAiBG,cAAA;AnDshGZ;AmD1jGU;EACE,iJAAA;AnD4jGZ;AmD9jGS;EAiBG,cAAA;AnDgjGZ;AmDhkGU;EACE,iJAAA;AnDkkGZ;AmDpkGS;EAiBG,cAAA;AnDsjGZ;AmDtkGU;EACE,iJAAA;AnDwkGZ;AmD1kGS;EAiBG,cAAA;AnD4jGZ;AmD5kGU;EACE,iJAAA;AnD8kGZ;AmDhlGS;EAiBG,cAAA;AnDkkGZ;AmDllGU;EACE,+IAAA;AnDolGZ;AmDtlGS;EAiBG,cAAA;AnDwkGZ;AmDxlGU;EACE,iJAAA;AnD0lGZ;AmD5lGS;EAiBG,cAAA;AnD8kGZ;AmD9lGU;EACE,iJAAA;AnDgmGZ;AmDlmGS;EAiBG,cAAA;AnDolGZ;AmDpmGU;EACE,iJAAA;AnDsmGZ;AmDxmGS;EAiBG,cAAA;AnD0lGZ;AmD1mGU;EACE,iJAAA;AnD4mGZ;AmD9mGS;EAiBG,cAAA;AnDgmGZ;AmDhnGU;EACE,+IAAA;AnDknGZ;AmDpnGS;EAiBG,cAAA;AnDsmGZ;AmDtnGU;EACE,iJAAA;AnDwnGZ;AmD1nGS;EAiBG,cAAA;AnD4mGZ;AmD5nGU;EACE,iJAAA;AnD8nGZ;AmDhoGS;EAiBG,cAAA;AnDknGZ;AmDloGU;EACE,iJAAA;AnDooGZ;AmDtoGS;EAiBG,cAAA;AnDwnGZ;AmDxoGU;EACE,iJAAA;AnD0oGZ;AmD5oGS;EAiBG,cAAA;AnD8nGZ;AmD9oGU;EACE,+IAAA;AnDgpGZ;AmDlpGS;EAiBG,cAAA;AnDooGZ;AmDppGU;EACE,iJAAA;AnDspGZ;AmDxpGS;EAiBG,cAAA;AnD0oGZ;AmD1pGU;EACE,iJAAA;AnD4pGZ;AmD9pGS;EAiBG,cAAA;AnDgpGZ;AmDhqGU;EACE,iJAAA;AnDkqGZ;AmDpqGS;EAiBG,cAAA;AnDspGZ;AmDtqGU;EACE,iJAAA;AnDwqGZ;AmD1qGS;EAiBG,cAAA;AnD4pGZ;AmD5qGU;EACE,+IAAA;AnD8qGZ;AmDhrGS;EAiBG,cAAA;AnDkqGZ;AmDlrGU;EACE,iJAAA;AnDorGZ;AmDtrGS;EAiBG,cAAA;AnDwqGZ;AmDxrGU;EACE,iJAAA;AnD0rGZ;AmD5rGS;EAiBG,cAAA;AnD8qGZ;AmD9rGU;EACE,iJAAA;AnDgsGZ;AmDlsGS;EAiBG,cAAA;AnDorGZ;AmDpsGU;EACE,iJAAA;AnDssGZ;AmDxsGS;EAiBG,cAAA;AnD0rGZ;AmD1sGU;EACE,+IAAA;AnD4sGZ;AmD9sGS;EAiBG,cAAA;AnDgsGZ;AmDhtGU;EACE,iJAAA;AnDktGZ;AmDptGS;EAiBG,cAAA;AnDssGZ;AmDttGU;EACE,iJAAA;AnDwtGZ;AmD1tGS;EAiBG,cAAA;AnD4sGZ;AmD5tGU;EACE,iJAAA;AnD8tGZ;AmDhuGS;EAiBG,cAAA;AnDktGZ;AmDluGU;EACE,iJAAA;AnDouGZ;AmDtuGS;EAiBG,cAAA;AnDwtGZ;AmDxuGU;EACE,+IAAA;AnD0uGZ;AmD5uGS;EAiBG,cAAA;AnD8tGZ;AmD9uGU;EACE,iJAAA;AnDgvGZ;AmDlvGS;EAiBG,cAAA;AnDouGZ;AmDpvGU;EACE,iJAAA;AnDsvGZ;AmDxvGS;EAiBG,cAAA;AnD0uGZ;AmD1vGU;EACE,iJAAA;AnD4vGZ;AmD9vGS;EAiBG,cAAA;AnDgvGZ;AmDhwGU;EACE,iJAAA;AnDkwGZ;AmDpwGS;EAiBG,cAAA;AnDsvGZ;AmDtwGU;EACE,+IAAA;AnDwwGZ;AmD1wGS;EAiBG,cAAA;AnD4vGZ;AmD5wGU;EACE,iJAAA;AnD8wGZ;AmDhxGS;EAiBG,cAAA;AnDkwGZ;AmDlxGU;EACE,iJAAA;AnDoxGZ;AmDtxGS;EAiBG,cAAA;AnDwwGZ;AmDxxGU;EACE,iJAAA;AnD0xGZ;AmD5xGS;EAiBG,cAAA;AnD8wGZ;AmD9xGU;EACE,iJAAA;AnDgyGZ;AmDlyGS;EAiBG,cAAA;AnDoxGZ;AmDpyGU;EACE,+IAAA;AnDsyGZ;AmDxyGS;EAiBG,cAAA;AnD0xGZ;AmD1yGU;EACE,iJAAA;AnD4yGZ;AmD9yGS;EAiBG,aAAA;AnDgyGZ;AmDhzGU;EACE,iJAAA;AnDkzGZ;AmDpzGS;EAiBG,aAAA;AnDsyGZ;AmDtzGU;EACE,iJAAA;AnDwzGZ;AmD1zGS;EAiBG,aAAA;AnD4yGZ;AmD5zGU;EACE,iJAAA;AnD8zGZ;AmDh0GS;EAiBG,aAAA;AnDkzGZ;AmDl0GU;EACE,+IAAA;AnDo0GZ;AmDt0GS;EAiBG,aAAA;AnDwzGZ;AmDx0GU;EACE,iJAAA;AnD00GZ;AmD50GS;EAiBG,aAAA;AnD8zGZ;AmD90GU;EACE,iJAAA;AnDg1GZ;AmDl1GS;EAiBG,aAAA;AnDo0GZ;AmDp1GU;EACE,gJAAA;AnDs1GZ;AmDx1GS;EAiBG,aAAA;AnD00GZ;AmD11GU;EACE,gJAAA;AnD41GZ;AmD91GS;EAiBG,aAAA;AnDg1GZ;AmDh2GU;EACE,8IAAA;AnDk2GZ;AmDp2GS;EAiBG,aAAA;AnDs1GZ;AmD72GI;EAyDI,kBAAA;EAEA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EAEA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AnDqzGR;AoDxgHA;ElDGI,2BAAA;AFwgHJ;AoD3gHA;ElDQI,0BAAA;EACA,cAAA;AFsgHJ;AoD/gHA;ElDeI,oBAAA;AFmgHJ;AoDlhHA;;;ElDyBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AF8/GJ;AoD1hHA;ElDgCI,gBAAA;EACA,WAAA;AF6/GJ;AoD9hHA;EAII,kBAAA;EACA,gBAAA;EACA,mBAAA;ApD6hHJ;AoDniHA;EAUI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,wBAAA;ApD4hHJ;AqD/iHA;EnDKI,2BAAA;AF6iHJ;AqDljHA;EnDUI,0BAAA;EACA,cAAA;AF2iHJ;AqDtjHA;EnDiBI,oBAAA;AFwiHJ;AqDzjHA;;;EnD2BI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFmiHJ;AqDjkHA;EnDkCI,gBAAA;EACA,WAAA;AFkiHJ;AsDrkHA;EAEI,gBAAA;AtDskHJ;AsDxkHA;EAMI,iBAAA;EACA,kBAAA;AtDqkHJ;AuD5kHA;EACE,2BAAA;EACA,gCAAA;AvD8kHF;AuD3kHA;EACE,cAAA;EACA,kBAAA;AvD6kHF;AuD/kHA;EAKI,gBAAA;EACA,mBAAA;EACA,oBAAA;AvD6kHJ;AuD3kHI;EACE,qBAAA;AvD6kHN;AuDvlHA;EAcM,mBAAA;AvD4kHN;AuD1lHA;EAkBM,eAAA;AvD2kHN;AuD7lHA;EAoBQ,aAAA;EACA,mBAAA;AvD4kHR;AuDjmHA;EAwBU,uBAAA;AvD4kHV;AuDpmHA;EA4BU,OAAA;EACA,iBAAA;AvD2kHV;AuDxmHA;EAmCQ,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AvDwkHR;AuD9mHA;EA0CU,eAAA;EACA,iBAAA;EACA,oBAAA;AvDukHV;AEvkHI;EAAA;IAII,aAAA;EFukHN;AACF;AOvnHE;EACC,SAAA;APynHH;AOtnHE;EACC,kBAAA;APwnHH;AwDloHA;;EjDeG,mBAAA;APunHH;AwDtoHA;EjDmBG,eAAA;EAEA,cAAA;APqnHH;AwD1oHA;EjD0BI,WAAA;EACA,kBAAA;EACA,eAAA;APmnHJ;AOhnHG;EACC,gBAAA;APknHJ;AwDlpHA;EjDsCI,cAAA;EACA,eAAA;EACA,iBAAA;AP+mHJ;AwDvpHA;EjD4CI,WAAA;AP8mHJ;AwD1pHA;EjDiDG,eAAA;EACA,WAAA;AP4mHH;AwD9pHA;EAKI,WAAA;EACA,aAAA;EACA,WAAA;EACA,mDAAA;EACA,sBAAA;AxD4pHJ;AwDrqHA;EAaI,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AxD2pHJ;AwD9qHA;EAsBM,YAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AxD2pHN;AwDprHA;EA8BI,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;AxDypHJ;AwD5rHA;EAsCM,qBAAA;AxDypHN;AyDlsHA;EAGG,YAAA;AzDksHH;AO7rHE;EACC,SAAA;AP+rHH;AO5rHE;EACC,kBAAA;AP8rHH;A0DvsHA;;EnDcG,mBAAA;AP6rHH;A0D3sHA;EnDkBG,eAAA;EAEA,cAAA;AP2rHH;A0D/sHA;EnDyBI,WAAA;EACA,kBAAA;EACA,eAAA;APyrHJ;AOtrHG;EACC,gBAAA;APwrHJ;A0DvtHA;EnDqCI,cAAA;EACA,eAAA;EACA,iBAAA;APqrHJ;A0D5tHA;EnD2CI,WAAA;APorHJ;A0D/tHA;EnDgDG,eAAA;EACA,WAAA;APkrHH;A0DnuHA;ExDGI,2BAAA;AFmuHJ;A0DtuHA;ExDQI,0BAAA;EACA,cAAA;AFiuHJ;A0D1uHA;ExDeI,oBAAA;AF8tHJ;A0D7uHA;;;ExDyBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFytHJ;A0DrvHA;ExDgCI,gBAAA;EACA,WAAA;AFwtHJ;A0DzvHA;;;EAOI,6BAAA;A1DuvHJ;A0D9vHA;EAWI,yBAAA;A1DsvHJ;A0DjwHA;EAcM,8BAAA;EACA,eAAA;A1DsvHN;A0DjvHA;EACE,wCAAA;A1DmvHF;A0DpvHA;EAII,eAAA;EACA,YAAA;EACA,YAAA;A1DmvHJ;A0DzvHA;EAUI,wBAAA;A1DkvHJ;A2DlxHA;EzDKI,2BAAA;AFgxHJ;A2DrxHA;EzDUI,0BAAA;EACA,cAAA;AF8wHJ;A2DzxHA;EzDiBI,oBAAA;AF2wHJ;A2D5xHA;;;EzD2BI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFswHJ;A2DpyHA;EzDkCI,gBAAA;EACA,WAAA;AFqwHJ;AEvvHI;EAAA;IAII,aAAA;EFuvHN;AACF;AOvyHE;EACC,SAAA;APyyHH;AOtyHE;EACC,kBAAA;APwyHH;A4DhzHA;;ErDaG,mBAAA;APuyHH;A4DpzHA;ErDiBG,eAAA;EAEA,cAAA;APqyHH;A4DxzHA;ErDwBI,WAAA;EACA,kBAAA;EACA,eAAA;APmyHJ;AOhyHG;EACC,gBAAA;APkyHJ;A4Dh0HA;ErDoCI,cAAA;EACA,eAAA;EACA,iBAAA;AP+xHJ;A4Dr0HA;ErD0CI,WAAA;AP8xHJ;A4Dx0HA;ErD+CG,eAAA;EACA,WAAA;AP4xHH;A4D50HA;EAKE,aAAA;EACA,WAAA;A5D00HF;A6Dj1HA;E3DGI,2BAAA;AFi1HJ;A6Dp1HA;E3DQI,0BAAA;EACA,cAAA;AF+0HJ;A6Dx1HA;E3DeI,oBAAA;AF40HJ;A6D31HA;;;E3DyBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AFu0HJ;A6Dn2HA;E3DgCI,gBAAA;EACA,WAAA;AFs0HJ;A6Dv2HA;EAGI,iBAAA;EACA,mBAAA;EACA,oBAAA;A7Du2HJ;A6D52HA;EAQI,gBAAA;A7Du2HJ;A6D/2HA;EAYI,cAAA;A7Ds2HJ;A6Dl3HA;EAoBI,gBAAA;EACA,mBAAA;EACA,aAAA;A7Di2HJ;A6D91HM;EACE,iBAAA;A7Dg2HR;A6D13HA;EA8BQ,mBAAA;A7D+1HR;A6D73HA;EAyCM,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A7Du1HN;A6Dv4HA;EAoDQ,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;A7Ds1HR;A6Dh1HA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;A7Dk1HF;A6D/0HA;E7Di1HE,oBAAoB;E6D/0HpB,WAAA;A7Di1HF;A8Dr5HA;EAGE,sDAAA;A9Dq5HF;A8Dx5HA;EAUI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,iEAAA;EAIA,uBAAA;EACA,kBAAA;A9D84HJ;AO95HE;EACC,SAAA;APg6HH;AO75HE;EACC,kBAAA;AP+5HH;A+Dz6HA;;ExDeG,mBAAA;AP85HH;A+D76HA;ExDmBG,eAAA;EAEA,cAAA;AP45HH;A+Dj7HA;ExD0BI,WAAA;EACA,kBAAA;EACA,eAAA;AP05HJ;AOv5HG;EACC,gBAAA;APy5HJ;A+Dz7HA;ExDsCI,cAAA;EACA,eAAA;EACA,iBAAA;APs5HJ;A+D97HA;ExD4CI,WAAA;APq5HJ;A+Dj8HA;ExDiDG,eAAA;EACA,WAAA;APm5HH;A+Dr8HA;E7DII,2BAAA;AFo8HJ;A+Dx8HA;E7DSI,0BAAA;EACA,cAAA;AFk8HJ;A+D58HA;E7DgBI,oBAAA;AF+7HJ;A+D/8HA;;;E7D0BI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AF07HJ;A+Dv9HA;E7DiCI,gBAAA;EACA,WAAA;AFy7HJ;A+D39HA;EAOQ,cAAA;A/Du9HR;A+D99HA;EAYU,kBAAA;EACA,WAAA;A/Dq9HV;A+Dl+HA;EAiBU,kBAAA;EACA,UAAA;EACA,YAAA;E/Do9HR,gCAAgC;AAClC;A+Dx+HA;EA2BI,6BAAA;A/Dg9HJ;A+D98HI;EACE,yBAAA;EACA,eAAA;A/Dg9HN;A+Dl9HI;EAKI,8BAAA;A/Dg9HR;AgEn/HA;;EAGI,cAAA;AhEo/HJ;AgEh/HA;EAEI,gBAAA;AhEi/HJ;AgEn/HA;EAMI,iBAAA;AhEg/HJ;AgEt/HA;EASM,oBAAA;AhEg/HN;AgEz/HA;EAaU,gBAAA;EACA,iBAAA;AhE++HV;AgE7/HA;EAkBU,YAAA;AhE8+HV;AgEhgIA;EAwBM,gBAAA;AhE2+HN;AgEt+HI;EACE,iBAAA;EACA,eAAA;AhEw+HN;AgEvgIA;EAqCI,gDAAA;EACA,UAAA;AhEq+HJ;AgE3gIA;EA0CI,2DAAA;AhEo+HJ;AgE9gIA;EA+CI,0BAAA;AhEk+HJ;AOlhIE;EACC,SAAA;APohIH;AOjhIE;EACC,kBAAA;APmhIH;AiE5hIA;;E1DcG,mBAAA;APkhIH;AiEhiIA;E1DkBG,eAAA;EAEA,cAAA;APghIH;AiEpiIA;E1DyBI,WAAA;EACA,kBAAA;EACA,eAAA;AP8gIJ;AO3gIG;EACC,gBAAA;AP6gIJ;AiE5iIA;E1DqCI,cAAA;EACA,eAAA;EACA,iBAAA;AP0gIJ;AiEjjIA;E1D2CI,WAAA;APygIJ;AiEpjIA;E1DgDG,eAAA;EACA,WAAA;APugIH;AiExjIA;E/DGI,2BAAA;AFwjIJ;AiE3jIA;E/DQI,0BAAA;EACA,cAAA;AFsjIJ;AiE/jIA;E/DeI,oBAAA;AFmjIJ;AiElkIA;;;E/DyBI,eAAA;EACA,SAAA;EACA,yBAAA;EACA,UAAA;AF8iIJ;AiE1kIA;E/DgCI,gBAAA;EACA,WAAA;AF6iIJ;AiE9kIA;EAQI,WAAA;EACA,kBAAA;AjEykIJ;AiEllIA;EAaI,0BAAA;AjEwkIJ;AiErlIA;;;;;;;;EAsBM,aAAA;AjEykIN;AiE/lIA;;;;EA0BM,eAAA;AjE2kIN;AiErmIA;;EAgCI,eAAA;AjEykIJ;AiEzmIA;;EAmCM,iBAAA;EACA,YAAA;EACA,uBAAA;AjE0kIN;AiE/mIA;EA0CI,kBAAA;AjEwkIJ;AiElnIA;;EAgDM,aAAA;AjEskIN;AiEtnIA;;EAsDQ,YAAA;AjEokIR;AiE1nIA;;EA8DM,eAAA;AjEgkIN;AiE9nIA;EAmEI,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,8BAAA;AjE6jIJ;AiEroIA;EA2EM,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,uBAAA;EACA,UAAA;EACA,cAAA;AjE4jIN;AiEzjII;;EAEE,cAAA;EACA,eAAA;AjE2jIN;AiExjII;EACE,8BAAA;AjE0jIN;AiErpIA;EAiGM,eAAA;AjEujIN;AiExpIA;EAuGM,kBAAA;EACA,cAAA;AjEojIN;AiE5pIA;EA6GI,YAAA;AjEkjIJ;AiE/pIA;EAgHM,YAAA;AjEkjIN;AiElqIA;EAmHQ,YAAA;EACA,YAAA;AjEkjIR;AkExqIA;EAEI,YAAA;AlEyqIJ;AkE3qIA;EAMI,gBAAA;AlEwqIJ;AkE9qIA;EAUI,0BAAA;AlEuqIJ;AO3qIE;EACC,SAAA;AP6qIH;AO1qIE;EACC,kBAAA;AP4qIH;AmEvrIA;;E5DgBG,mBAAA;AP2qIH;AmE3rIA;E5DoBG,eAAA;EAEA,cAAA;APyqIH;AmE/rIA;E5D2BI,WAAA;EACA,kBAAA;EACA,eAAA;APuqIJ;AOpqIG;EACC,gBAAA;APsqIJ;AmEvsIA;E5DuCI,cAAA;EACA,eAAA;EACA,iBAAA;APmqIJ;AmE5sIA;E5D6CI,WAAA;APkqIJ;AmE/sIA;E5DkDG,eAAA;EACA,WAAA;APgqIH;AO7sIE;EACC,SAAA;AP+sIH;AO5sIE;EACC,kBAAA;AP8sIH;AoExtIA;;E7DeG,mBAAA;AP6sIH;AoE5tIA;E7DmBG,eAAA;EAEA,cAAA;AP2sIH;AoEhuIA;E7D0BI,WAAA;EACA,kBAAA;EACA,eAAA;APysIJ;AOtsIG;EACC,gBAAA;APwsIJ;AoExuIA;E7DsCI,cAAA;EACA,eAAA;EACA,iBAAA;APqsIJ;AoE7uIA;E7D4CI,WAAA;APosIJ;AoEhvIA;E7DiDG,eAAA;EACA,WAAA;APksIH;AoEpvIA;EAGI,aAAA;EACA,WAAA;ApEovIJ;AOnvIE;EACC,SAAA;APqvIH;AOlvIE;EACC,kBAAA;APovIH;AqE/vIA;;E9DgBG,mBAAA;APmvIH;AqEnwIA;E9DoBG,eAAA;EAEA,cAAA;APivIH;AqEvwIA;E9D2BI,WAAA;EACA,kBAAA;EACA,eAAA;AP+uIJ;AO5uIG;EACC,gBAAA;AP8uIJ;AqE/wIA;E9DuCI,cAAA;EACA,eAAA;EACA,iBAAA;AP2uIJ;AqEpxIA;E9D6CI,WAAA;AP0uIJ;AqEvxIA;E9DkDG,eAAA;EACA,WAAA;APwuIH;AOrxIE;EACC,SAAA;APuxIH;AOpxIE;EACC,kBAAA;APsxIH;AsE/xIA;;E/DcG,mBAAA;APqxIH;AsEnyIA;E/DkBG,eAAA;EAEA,cAAA;APmxIH;AsEvyIA;E/DyBI,WAAA;EACA,kBAAA;EACA,eAAA;APixIJ;AO9wIG;EACC,gBAAA;APgxIJ;AsE/yIA;E/DqCI,cAAA;EACA,eAAA;EACA,iBAAA;AP6wIJ;AsEpzIA;E/D2CI,WAAA;AP4wIJ;AsEvzIA;E/DgDG,eAAA;EACA,WAAA;AP0wIH;AOvzIE;EACC,SAAA;APyzIH;AOtzIE;EACC,kBAAA;APwzIH;AuEl0IA;;EhEeG,mBAAA;APuzIH;AuEt0IA;EhEmBG,eAAA;EAEA,cAAA;APqzIH;AuE10IA;EhE0BI,WAAA;EACA,kBAAA;EACA,eAAA;APmzIJ;AOhzIG;EACC,gBAAA;APkzIJ;AuEl1IA;EhEsCI,cAAA;EACA,eAAA;EACA,iBAAA;AP+yIJ;AuEv1IA;EhE4CI,WAAA;AP8yIJ;AuE11IA;EhEiDG,eAAA;EACA,WAAA;AP4yIH;AuE91IA;EAMI,sDAAA;AvE21IJ;AuEr1II;EAEI,8BAAA;EACA,eAAA;AvEs1IR;AuEr2IA;EAoBI,UAAA;AvEo1IJ;AuEx2IA;EAwBI,yBAAA;AvEm1IJ;AwE92IA;EACE,aAAA;AxEg3IF","sourcesContent":["@import \"{}/imports/client/styles/colors.import.less\";\n// removed as this messes with semantic layout:\n//.green:not(.icon) {\n//  background-color: @greenColor !important;\n//}\n.green-text {\n  color: @greenColor !important;\n}\n\n.hidden {\n  display: none;\n}\n\n.error-text {\n  color: @errorColor;\n\n  ul li {\n    margin-left: 1.2em;\n    list-style-type: initial;\n  }\n}\n\nbody {\n  letter-spacing: 0.015em;\n  -webkit-font-smoothing: antialiased;\n}\n\nem {\n  color: #d4d2d5;\n}\n\nth {\n  font-weight: 400;\n  color: fade(black, 54%);\n}\n\ntd,\nth {\n  padding: 18px;\n}\n\n.section-header {\n  margin-top: 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: bold;\n}\n\n.item-icon {\n  position: relative;\n\n  > i {\n    position: absolute;\n    top: 0;\n  }\n\n  > div,\n  > div.row {\n    margin-left: 35px;\n\n    > label {\n      display: block;\n      font-size: inherit;\n    }\n  }\n}\n",".green-text {\n  color: #94BA2E !important;\n}\n.hidden {\n  display: none;\n}\n.error-text {\n  color: #e53935;\n}\n.error-text ul li {\n  margin-left: 1.2em;\n  list-style-type: initial;\n}\nbody {\n  letter-spacing: 0.015em;\n  -webkit-font-smoothing: antialiased;\n}\nem {\n  color: #d4d2d5;\n}\nth {\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.54);\n}\ntd,\nth {\n  padding: 18px;\n}\n.section-header {\n  margin-top: 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: bold;\n}\n.item-icon {\n  position: relative;\n}\n.item-icon > i {\n  position: absolute;\n  top: 0;\n}\n.item-icon > div,\n.item-icon > div.row {\n  margin-left: 35px;\n}\n.item-icon > div > label,\n.item-icon > div.row > label {\n  display: block;\n  font-size: inherit;\n}\nbody,\n#react-root {\n  overflow: hidden;\n}\n.mainSubWrapper {\n  display: flex;\n}\n.mainSubWrapper > div {\n  flex-grow: 1;\n}\n.mainSubWrapper > aside {\n  flex-shrink: 0;\n}\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n.app > header {\n  display: flex;\n  position: fixed;\n  z-index: 101;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: white;\n  color: #3C4144;\n}\n.app > header a.logo {\n  display: flex;\n  width: 60px;\n  height: 60px;\n  justify-content: center;\n  background: #3B2269;\n}\n.app > header form[role=\"search\"] {\n  flex: 1;\n  margin: 17px 25px 0;\n}\n.app > header form[role=\"search\"] .icon.input i.icon {\n  opacity: 1;\n  color: #788188;\n}\n.app > header form[role=\"search\"] .ui.input input {\n  line-height: normal;\n}\n.app nav.ui.vertical.menu {\n  width: 60px;\n  top: 60px;\n  height: 100%;\n}\n.app nav.ui.vertical.menu .item {\n  padding-left: 0;\n  padding-right: 0;\n  height: 60px;\n  font-size: 20px;\n  text-align: center;\n  transition: opacity 0.3s;\n}\n.app nav.ui.vertical.menu .item:not(.active) {\n  opacity: 0.5;\n}\n.app nav.ui.vertical.menu .item:hover {\n  opacity: 1;\n}\n.app nav.ui.vertical.menu .item > .submenu-icon {\n  font-size: 12px;\n  position: absolute;\n  right: 0;\n  line-height: 40px;\n  top: 15%;\n}\n.app nav.ui.vertical.menu .item.support {\n  position: fixed;\n  bottom: 0;\n  width: 60px;\n  height: 60px;\n  background: rgba(255, 255, 255, 0.07);\n}\n.app nav.ui.vertical.menu .item.dropdown:not(.hover) > .menu {\n  display: none;\n}\n.app nav.ui.vertical.menu .item.dropdown:hover > .menu {\n  display: block;\n}\n.app nav.ui.vertical.menu .item.dropdown > .menu {\n  background: transparent;\n  position: absolute;\n  transition: transform 0.15s 0.7s ease, opacity 0.15s 0.7s ease, -webkit-transform 0.15s 0.7s ease;\n  padding-left: 6px;\n  z-index: 1901;\n}\n.app nav.ui.vertical.menu .dropdown-menu {\n  background: black;\n  padding: 0.833em 1em;\n}\n.app nav.ui.vertical.menu .dropdown-menu--item {\n  font-size: 1rem;\n  margin: 0;\n  height: auto;\n  text-align: initial;\n  padding: 10px 0;\n}\n.app > .contentContainer > div {\n  flex: 1;\n  display: flex;\n  margin: 60px 0 0 60px;\n}\n.app main,\n.app main > div,\n.app aside {\n  height: calc(100vh -  60px);\n}\n.app main > div {\n  max-width: calc(100vw -  60px);\n  flex: 1;\n  width: 100%;\n}\n.app main > div div.padding {\n  padding: 30px;\n}\n.app main > div div.centered {\n  text-align: center;\n  color: red;\n}\n.app main > div div.container {\n  width: auto;\n  padding: 0 30px 30px;\n}\n.app main > div,\n.app aside {\n  overflow: auto;\n}\n.app main > div .content,\n.app aside .content {\n  min-height: calc(100% -  60px + 1px);\n}\n.app main > div .content.ui.segment,\n.app aside .content.ui.segment {\n  margin-bottom: 0;\n}\n.app main > div > footer,\n.app aside > footer {\n  height: 60px;\n}\n.app main > div > footer.ui.segment,\n.app aside > footer.ui.segment {\n  margin-top: 0;\n  box-shadow: none;\n  margin-bottom: 0;\n}\n.app main > div > footer > div:first-child,\n.app aside > footer > div:first-child,\n.app main > div > footer > div:last-child,\n.app aside > footer > div:last-child {\n  flex-basis: 30%;\n  white-space: nowrap;\n}\n.app main {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n.app main .btn-floating.add {\n  position: absolute;\n  right: 40px;\n  top: 20px;\n  background-color: #483074;\n}\n.app main ul.dropdown-content {\n  width: 200px !important;\n}\n.app main ul.dropdown-content a {\n  color: #3FA2F7;\n  font-size: 14px;\n  font-weight: 500;\n}\n.app main ul.dropdown-content a i {\n  position: relative;\n  top: 6px;\n  margin-right: 0.5em;\n  color: #cccccc;\n}\n.app main footer.ui.segment {\n  height: 61px;\n  border-top: 1px solid #F2F4F8;\n  background-color: #f9fafc;\n}\n.app main footer .ui.basic.button,\n.app main footer .ui.basic.button:hover,\n.app main footer .ui.basic.button:focus {\n  box-shadow: none !important;\n}\n.app main > div {\n  height: calc(100vh -  60px);\n}\n.app main > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\n.app main + aside {\n  padding-bottom: 60px;\n}\n.app main > div > footer.ui.segment,\n.app main.ShipmentRequest footer.ui.segment,\n.app main + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\n.app main + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n.app main footer,\n.app aside footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0;\n}\n.app main footer .button,\n.app aside footer .button {\n  margin-left: 10px;\n  line-height: 10px;\n}\n.app main footer .button.basic,\n.app aside footer .button.basic {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\n.app main footer .button.basic:hover,\n.app aside footer .button.basic:hover {\n  color: rgba(0, 0, 0, 0.5) !important;\n  background: transparent !important;\n}\n.app main footer .button.basic:active,\n.app aside footer .button.basic:active {\n  box-shadow: none;\n}\n.app main footer .status,\n.app aside footer .status {\n  text-align: right;\n  margin: 0 10px 0 0;\n  font-size: 12px;\n  color: rgba(60, 65, 68, 0.6);\n}\n.app aside {\n  width: 0;\n  -webkit-font-smoothing: antialiased;\n  background-color: #E9EDF4;\n}\n.app aside.expanded {\n  min-width: 360px;\n  width: 25vw;\n}\n.app aside.minimized {\n  width: 60px;\n  min-width: 0;\n  transition: width 600ms ease-out;\n}\n.app aside h1 {\n  margin-bottom: 0.5rem;\n  font-size: 20px;\n}\n.app aside h4 {\n  margin: 0 0 5px;\n  font-size: 16px;\n}\n.app aside h4 + .sub {\n  font-size: 13px;\n}\n.app aside h5 {\n  margin: 2.85em 0 1.12em;\n  font-size: inherit;\n  opacity: 0.4;\n  font-weight: 600;\n}\n.app aside h5:first-child {\n  margin-top: 0;\n}\n.app aside > .ui.very.padded.segment {\n  padding: 60px;\n}\n.app aside .meta {\n  opacity: 0.5;\n}\n.app aside .item-icon {\n  margin: 2rem 0;\n  line-height: 1.8;\n}\n.app aside .item-icon i {\n  top: 1px;\n}\n.app aside .item-icon div {\n  margin-left: 40px;\n}\n.app aside .item-icon + .item-icon {\n  margin-top: 2.5rem;\n}\n.app aside footer {\n  justify-content: flex-end;\n}\n.app aside footer.ui.segment {\n  background-color: #f4f6fa;\n}\n@media all and (max-height: 799px) {\n  .app main,\n  .app main > .contentContainer,\n  .app aside {\n    overflow: visible;\n    height: auto;\n    min-height: calc(100vh -  60px);\n  }\n  .app > .contentContainer {\n    overflow: auto;\n    height: 100vh;\n  }\n  .app aside > .content > div {\n    min-height: calc(100% -  60px);\n  }\n}\n.pusher > .ui.sidebar {\n  background-color: #E9EDF4;\n}\n.pushable > .ui.sidebar {\n  background-color: #E9EDF4;\n}\n.register.container {\n  display: flex;\n  justify-content: stretch;\n  height: 100%;\n}\n.register.container main {\n  flex: 0 0 auto;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #483074;\n  padding: 60px;\n  color: white;\n}\n@media (min-width: 701px) and (max-width: 850px) {\n  .register.container main {\n    width: 70%;\n  }\n}\n@media (min-width: 851px) and (max-width: 1000px) {\n  .register.container main {\n    width: 60%;\n  }\n}\n@media (min-width: 1001px) and (max-width: 1200px) {\n  .register.container main {\n    width: 50%;\n  }\n}\n@media (min-width: 1201px) {\n  .register.container main {\n    width: 40%;\n  }\n}\n.register.container main > * {\n  flex: 1 0 auto;\n  max-width: 400px;\n}\n.register.container main .ui.image.logo {\n  width: 250px;\n  margin-bottom: 30px;\n  margin-left: -15px;\n}\n.register.container aside {\n  flex: 1 0 auto;\n  background: url(\"/images/bg-1.webp\");\n  background-size: cover;\n  background-position: center;\n}\n.register.container .ui.form .field label {\n  text-transform: uppercase;\n  color: white;\n}\n.register.container .ui.form .field input {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: transparent;\n  color: black;\n}\n.register.container .ui.form .fields label {\n  text-transform: uppercase;\n  color: white;\n}\n.register.container .ui.form .fields .field .checkbox label {\n  text-transform: none;\n}\n.main-fixed-footer > div {\n  height: calc(100vh -  60px);\n}\n.main-fixed-footer > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\n.main-fixed-footer + aside {\n  padding-bottom: 60px;\n}\n.main-fixed-footer > div > footer.ui.segment,\n.main-fixed-footer.ShipmentRequest footer.ui.segment,\n.main-fixed-footer + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\n.main-fixed-footer + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n.main-fixed-footer-and-toolbar > div > div {\n  height: calc(100% -  60px + 60px);\n  min-height: calc(100% -  60px + 60px);\n}\n@media all and (max-height: 799px) {\n  .aside-autohide-footer + aside footer.ui.segment {\n    display: none;\n  }\n}\nmain .form h1.ui.header {\n  color: #788188;\n}\nmain .form .icon-header {\n  display: flex;\n}\nmain .form .icon-header .circle.icon {\n  margin-right: 10px;\n}\nmain .form .icon-header svg {\n  flex: 1;\n}\n.semantic-select .ui.dropdown {\n  height: 48px;\n}\n.ui.dropdown.dropdown .menu > .input {\n  width: auto !important;\n}\n/*\n* Font Face\n*/\n@font-face {\n  font-family: 'simple-line-icons';\n  src: url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0');\n  src: url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0#iefix') format('embedded-opentype'), url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0') format('woff2'), url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0') format('truetype'), url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff?v=2.4.0') format('woff'), url('../node_modules/simple-line-icons/fonts/Simple-Line-Icons.svg?v=2.4.0#simple-line-icons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*\n Use the following code if you want to have a class per icon.\n Instead of a list of all class selectors, you can use the generic [class*=\"icon-\"] selector,\n but it's slower.\n*/\n.icon-user,\n.icon-people,\n.icon-user-female,\n.icon-user-follow,\n.icon-user-following,\n.icon-user-unfollow,\n.icon-login,\n.icon-logout,\n.icon-emotsmile,\n.icon-phone,\n.icon-call-end,\n.icon-call-in,\n.icon-call-out,\n.icon-map,\n.icon-location-pin,\n.icon-direction,\n.icon-directions,\n.icon-compass,\n.icon-layers,\n.icon-menu,\n.icon-list,\n.icon-options-vertical,\n.icon-options,\n.icon-arrow-down,\n.icon-arrow-left,\n.icon-arrow-right,\n.icon-arrow-up,\n.icon-arrow-up-circle,\n.icon-arrow-left-circle,\n.icon-arrow-right-circle,\n.icon-arrow-down-circle,\n.icon-check,\n.icon-clock,\n.icon-plus,\n.icon-minus,\n.icon-close,\n.icon-event,\n.icon-exclamation,\n.icon-organization,\n.icon-trophy,\n.icon-screen-smartphone,\n.icon-screen-desktop,\n.icon-plane,\n.icon-notebook,\n.icon-mustache,\n.icon-mouse,\n.icon-magnet,\n.icon-energy,\n.icon-disc,\n.icon-cursor,\n.icon-cursor-move,\n.icon-crop,\n.icon-chemistry,\n.icon-speedometer,\n.icon-shield,\n.icon-screen-tablet,\n.icon-magic-wand,\n.icon-hourglass,\n.icon-graduation,\n.icon-ghost,\n.icon-game-controller,\n.icon-fire,\n.icon-eyeglass,\n.icon-envelope-open,\n.icon-envelope-letter,\n.icon-bell,\n.icon-badge,\n.icon-anchor,\n.icon-wallet,\n.icon-vector,\n.icon-speech,\n.icon-puzzle,\n.icon-printer,\n.icon-present,\n.icon-playlist,\n.icon-pin,\n.icon-picture,\n.icon-handbag,\n.icon-globe-alt,\n.icon-globe,\n.icon-folder-alt,\n.icon-folder,\n.icon-film,\n.icon-feed,\n.icon-drop,\n.icon-drawer,\n.icon-docs,\n.icon-doc,\n.icon-diamond,\n.icon-cup,\n.icon-calculator,\n.icon-bubbles,\n.icon-briefcase,\n.icon-book-open,\n.icon-basket-loaded,\n.icon-basket,\n.icon-bag,\n.icon-action-undo,\n.icon-action-redo,\n.icon-wrench,\n.icon-umbrella,\n.icon-trash,\n.icon-tag,\n.icon-support,\n.icon-frame,\n.icon-size-fullscreen,\n.icon-size-actual,\n.icon-shuffle,\n.icon-share-alt,\n.icon-share,\n.icon-rocket,\n.icon-question,\n.icon-pie-chart,\n.icon-pencil,\n.icon-note,\n.icon-loop,\n.icon-home,\n.icon-grid,\n.icon-graph,\n.icon-microphone,\n.icon-music-tone-alt,\n.icon-music-tone,\n.icon-earphones-alt,\n.icon-earphones,\n.icon-equalizer,\n.icon-like,\n.icon-dislike,\n.icon-control-start,\n.icon-control-rewind,\n.icon-control-play,\n.icon-control-pause,\n.icon-control-forward,\n.icon-control-end,\n.icon-volume-1,\n.icon-volume-2,\n.icon-volume-off,\n.icon-calendar,\n.icon-bulb,\n.icon-chart,\n.icon-ban,\n.icon-bubble,\n.icon-camrecorder,\n.icon-camera,\n.icon-cloud-download,\n.icon-cloud-upload,\n.icon-envelope,\n.icon-eye,\n.icon-flag,\n.icon-heart,\n.icon-info,\n.icon-key,\n.icon-link,\n.icon-lock,\n.icon-lock-open,\n.icon-magnifier,\n.icon-magnifier-add,\n.icon-magnifier-remove,\n.icon-paper-clip,\n.icon-paper-plane,\n.icon-power,\n.icon-refresh,\n.icon-reload,\n.icon-settings,\n.icon-star,\n.icon-symbol-female,\n.icon-symbol-male,\n.icon-target,\n.icon-credit-card,\n.icon-paypal,\n.icon-social-tumblr,\n.icon-social-twitter,\n.icon-social-facebook,\n.icon-social-instagram,\n.icon-social-linkedin,\n.icon-social-pinterest,\n.icon-social-github,\n.icon-social-google,\n.icon-social-reddit,\n.icon-social-skype,\n.icon-social-dribbble,\n.icon-social-behance,\n.icon-social-foursqare,\n.icon-social-soundcloud,\n.icon-social-spotify,\n.icon-social-stumbleupon,\n.icon-social-youtube,\n.icon-social-dropbox,\n.icon-social-vkontakte,\n.icon-social-steam {\n  font-family: 'simple-line-icons';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-user:before {\n  content: \"\\e005\";\n}\n.icon-people:before {\n  content: \"\\e001\";\n}\n.icon-user-female:before {\n  content: \"\\e000\";\n}\n.icon-user-follow:before {\n  content: \"\\e002\";\n}\n.icon-user-following:before {\n  content: \"\\e003\";\n}\n.icon-user-unfollow:before {\n  content: \"\\e004\";\n}\n.icon-login:before {\n  content: \"\\e066\";\n}\n.icon-logout:before {\n  content: \"\\e065\";\n}\n.icon-emotsmile:before {\n  content: \"\\e021\";\n}\n.icon-phone:before {\n  content: \"\\e600\";\n}\n.icon-call-end:before {\n  content: \"\\e048\";\n}\n.icon-call-in:before {\n  content: \"\\e047\";\n}\n.icon-call-out:before {\n  content: \"\\e046\";\n}\n.icon-map:before {\n  content: \"\\e033\";\n}\n.icon-location-pin:before {\n  content: \"\\e096\";\n}\n.icon-direction:before {\n  content: \"\\e042\";\n}\n.icon-directions:before {\n  content: \"\\e041\";\n}\n.icon-compass:before {\n  content: \"\\e045\";\n}\n.icon-layers:before {\n  content: \"\\e034\";\n}\n.icon-menu:before {\n  content: \"\\e601\";\n}\n.icon-list:before {\n  content: \"\\e067\";\n}\n.icon-options-vertical:before {\n  content: \"\\e602\";\n}\n.icon-options:before {\n  content: \"\\e603\";\n}\n.icon-arrow-down:before {\n  content: \"\\e604\";\n}\n.icon-arrow-left:before {\n  content: \"\\e605\";\n}\n.icon-arrow-right:before {\n  content: \"\\e606\";\n}\n.icon-arrow-up:before {\n  content: \"\\e607\";\n}\n.icon-arrow-up-circle:before {\n  content: \"\\e078\";\n}\n.icon-arrow-left-circle:before {\n  content: \"\\e07a\";\n}\n.icon-arrow-right-circle:before {\n  content: \"\\e079\";\n}\n.icon-arrow-down-circle:before {\n  content: \"\\e07b\";\n}\n.icon-check:before {\n  content: \"\\e080\";\n}\n.icon-clock:before {\n  content: \"\\e081\";\n}\n.icon-plus:before {\n  content: \"\\e095\";\n}\n.icon-minus:before {\n  content: \"\\e615\";\n}\n.icon-close:before {\n  content: \"\\e082\";\n}\n.icon-event:before {\n  content: \"\\e619\";\n}\n.icon-exclamation:before {\n  content: \"\\e617\";\n}\n.icon-organization:before {\n  content: \"\\e616\";\n}\n.icon-trophy:before {\n  content: \"\\e006\";\n}\n.icon-screen-smartphone:before {\n  content: \"\\e010\";\n}\n.icon-screen-desktop:before {\n  content: \"\\e011\";\n}\n.icon-plane:before {\n  content: \"\\e012\";\n}\n.icon-notebook:before {\n  content: \"\\e013\";\n}\n.icon-mustache:before {\n  content: \"\\e014\";\n}\n.icon-mouse:before {\n  content: \"\\e015\";\n}\n.icon-magnet:before {\n  content: \"\\e016\";\n}\n.icon-energy:before {\n  content: \"\\e020\";\n}\n.icon-disc:before {\n  content: \"\\e022\";\n}\n.icon-cursor:before {\n  content: \"\\e06e\";\n}\n.icon-cursor-move:before {\n  content: \"\\e023\";\n}\n.icon-crop:before {\n  content: \"\\e024\";\n}\n.icon-chemistry:before {\n  content: \"\\e026\";\n}\n.icon-speedometer:before {\n  content: \"\\e007\";\n}\n.icon-shield:before {\n  content: \"\\e00e\";\n}\n.icon-screen-tablet:before {\n  content: \"\\e00f\";\n}\n.icon-magic-wand:before {\n  content: \"\\e017\";\n}\n.icon-hourglass:before {\n  content: \"\\e018\";\n}\n.icon-graduation:before {\n  content: \"\\e019\";\n}\n.icon-ghost:before {\n  content: \"\\e01a\";\n}\n.icon-game-controller:before {\n  content: \"\\e01b\";\n}\n.icon-fire:before {\n  content: \"\\e01c\";\n}\n.icon-eyeglass:before {\n  content: \"\\e01d\";\n}\n.icon-envelope-open:before {\n  content: \"\\e01e\";\n}\n.icon-envelope-letter:before {\n  content: \"\\e01f\";\n}\n.icon-bell:before {\n  content: \"\\e027\";\n}\n.icon-badge:before {\n  content: \"\\e028\";\n}\n.icon-anchor:before {\n  content: \"\\e029\";\n}\n.icon-wallet:before {\n  content: \"\\e02a\";\n}\n.icon-vector:before {\n  content: \"\\e02b\";\n}\n.icon-speech:before {\n  content: \"\\e02c\";\n}\n.icon-puzzle:before {\n  content: \"\\e02d\";\n}\n.icon-printer:before {\n  content: \"\\e02e\";\n}\n.icon-present:before {\n  content: \"\\e02f\";\n}\n.icon-playlist:before {\n  content: \"\\e030\";\n}\n.icon-pin:before {\n  content: \"\\e031\";\n}\n.icon-picture:before {\n  content: \"\\e032\";\n}\n.icon-handbag:before {\n  content: \"\\e035\";\n}\n.icon-globe-alt:before {\n  content: \"\\e036\";\n}\n.icon-globe:before {\n  content: \"\\e037\";\n}\n.icon-folder-alt:before {\n  content: \"\\e039\";\n}\n.icon-folder:before {\n  content: \"\\e089\";\n}\n.icon-film:before {\n  content: \"\\e03a\";\n}\n.icon-feed:before {\n  content: \"\\e03b\";\n}\n.icon-drop:before {\n  content: \"\\e03e\";\n}\n.icon-drawer:before {\n  content: \"\\e03f\";\n}\n.icon-docs:before {\n  content: \"\\e040\";\n}\n.icon-doc:before {\n  content: \"\\e085\";\n}\n.icon-diamond:before {\n  content: \"\\e043\";\n}\n.icon-cup:before {\n  content: \"\\e044\";\n}\n.icon-calculator:before {\n  content: \"\\e049\";\n}\n.icon-bubbles:before {\n  content: \"\\e04a\";\n}\n.icon-briefcase:before {\n  content: \"\\e04b\";\n}\n.icon-book-open:before {\n  content: \"\\e04c\";\n}\n.icon-basket-loaded:before {\n  content: \"\\e04d\";\n}\n.icon-basket:before {\n  content: \"\\e04e\";\n}\n.icon-bag:before {\n  content: \"\\e04f\";\n}\n.icon-action-undo:before {\n  content: \"\\e050\";\n}\n.icon-action-redo:before {\n  content: \"\\e051\";\n}\n.icon-wrench:before {\n  content: \"\\e052\";\n}\n.icon-umbrella:before {\n  content: \"\\e053\";\n}\n.icon-trash:before {\n  content: \"\\e054\";\n}\n.icon-tag:before {\n  content: \"\\e055\";\n}\n.icon-support:before {\n  content: \"\\e056\";\n}\n.icon-frame:before {\n  content: \"\\e038\";\n}\n.icon-size-fullscreen:before {\n  content: \"\\e057\";\n}\n.icon-size-actual:before {\n  content: \"\\e058\";\n}\n.icon-shuffle:before {\n  content: \"\\e059\";\n}\n.icon-share-alt:before {\n  content: \"\\e05a\";\n}\n.icon-share:before {\n  content: \"\\e05b\";\n}\n.icon-rocket:before {\n  content: \"\\e05c\";\n}\n.icon-question:before {\n  content: \"\\e05d\";\n}\n.icon-pie-chart:before {\n  content: \"\\e05e\";\n}\n.icon-pencil:before {\n  content: \"\\e05f\";\n}\n.icon-note:before {\n  content: \"\\e060\";\n}\n.icon-loop:before {\n  content: \"\\e064\";\n}\n.icon-home:before {\n  content: \"\\e069\";\n}\n.icon-grid:before {\n  content: \"\\e06a\";\n}\n.icon-graph:before {\n  content: \"\\e06b\";\n}\n.icon-microphone:before {\n  content: \"\\e063\";\n}\n.icon-music-tone-alt:before {\n  content: \"\\e061\";\n}\n.icon-music-tone:before {\n  content: \"\\e062\";\n}\n.icon-earphones-alt:before {\n  content: \"\\e03c\";\n}\n.icon-earphones:before {\n  content: \"\\e03d\";\n}\n.icon-equalizer:before {\n  content: \"\\e06c\";\n}\n.icon-like:before {\n  content: \"\\e068\";\n}\n.icon-dislike:before {\n  content: \"\\e06d\";\n}\n.icon-control-start:before {\n  content: \"\\e06f\";\n}\n.icon-control-rewind:before {\n  content: \"\\e070\";\n}\n.icon-control-play:before {\n  content: \"\\e071\";\n}\n.icon-control-pause:before {\n  content: \"\\e072\";\n}\n.icon-control-forward:before {\n  content: \"\\e073\";\n}\n.icon-control-end:before {\n  content: \"\\e074\";\n}\n.icon-volume-1:before {\n  content: \"\\e09f\";\n}\n.icon-volume-2:before {\n  content: \"\\e0a0\";\n}\n.icon-volume-off:before {\n  content: \"\\e0a1\";\n}\n.icon-calendar:before {\n  content: \"\\e075\";\n}\n.icon-bulb:before {\n  content: \"\\e076\";\n}\n.icon-chart:before {\n  content: \"\\e077\";\n}\n.icon-ban:before {\n  content: \"\\e07c\";\n}\n.icon-bubble:before {\n  content: \"\\e07d\";\n}\n.icon-camrecorder:before {\n  content: \"\\e07e\";\n}\n.icon-camera:before {\n  content: \"\\e07f\";\n}\n.icon-cloud-download:before {\n  content: \"\\e083\";\n}\n.icon-cloud-upload:before {\n  content: \"\\e084\";\n}\n.icon-envelope:before {\n  content: \"\\e086\";\n}\n.icon-eye:before {\n  content: \"\\e087\";\n}\n.icon-flag:before {\n  content: \"\\e088\";\n}\n.icon-heart:before {\n  content: \"\\e08a\";\n}\n.icon-info:before {\n  content: \"\\e08b\";\n}\n.icon-key:before {\n  content: \"\\e08c\";\n}\n.icon-link:before {\n  content: \"\\e08d\";\n}\n.icon-lock:before {\n  content: \"\\e08e\";\n}\n.icon-lock-open:before {\n  content: \"\\e08f\";\n}\n.icon-magnifier:before {\n  content: \"\\e090\";\n}\n.icon-magnifier-add:before {\n  content: \"\\e091\";\n}\n.icon-magnifier-remove:before {\n  content: \"\\e092\";\n}\n.icon-paper-clip:before {\n  content: \"\\e093\";\n}\n.icon-paper-plane:before {\n  content: \"\\e094\";\n}\n.icon-power:before {\n  content: \"\\e097\";\n}\n.icon-refresh:before {\n  content: \"\\e098\";\n}\n.icon-reload:before {\n  content: \"\\e099\";\n}\n.icon-settings:before {\n  content: \"\\e09a\";\n}\n.icon-star:before {\n  content: \"\\e09b\";\n}\n.icon-symbol-female:before {\n  content: \"\\e09c\";\n}\n.icon-symbol-male:before {\n  content: \"\\e09d\";\n}\n.icon-target:before {\n  content: \"\\e09e\";\n}\n.icon-credit-card:before {\n  content: \"\\e025\";\n}\n.icon-paypal:before {\n  content: \"\\e608\";\n}\n.icon-social-tumblr:before {\n  content: \"\\e00a\";\n}\n.icon-social-twitter:before {\n  content: \"\\e009\";\n}\n.icon-social-facebook:before {\n  content: \"\\e00b\";\n}\n.icon-social-instagram:before {\n  content: \"\\e609\";\n}\n.icon-social-linkedin:before {\n  content: \"\\e60a\";\n}\n.icon-social-pinterest:before {\n  content: \"\\e60b\";\n}\n.icon-social-github:before {\n  content: \"\\e60c\";\n}\n.icon-social-google:before {\n  content: \"\\e60d\";\n}\n.icon-social-reddit:before {\n  content: \"\\e60e\";\n}\n.icon-social-skype:before {\n  content: \"\\e60f\";\n}\n.icon-social-dribbble:before {\n  content: \"\\e00d\";\n}\n.icon-social-behance:before {\n  content: \"\\e610\";\n}\n.icon-social-foursqare:before {\n  content: \"\\e611\";\n}\n.icon-social-soundcloud:before {\n  content: \"\\e612\";\n}\n.icon-social-spotify:before {\n  content: \"\\e613\";\n}\n.icon-social-stumbleupon:before {\n  content: \"\\e614\";\n}\n.icon-social-youtube:before {\n  content: \"\\e008\";\n}\n.icon-social-dropbox:before {\n  content: \"\\e00c\";\n}\n.icon-social-vkontakte:before {\n  content: \"\\e618\";\n}\n.icon-social-steam:before {\n  content: \"\\e620\";\n}\n.icon-sections section.basic {\n  margin: 0;\n}\n.icon-sections section.ui.segment {\n  border-radius: 2px;\n}\n.icon-sections section em,\n.icon-sections section .empty {\n  margin: 1em 0 1.5em;\n}\n.icon-sections section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\n.icon-sections section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\n.icon-sections section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\n.icon-sections section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\n.icon-sections section > .list > .item > .content {\n  width: 100%;\n}\n.icon-sections section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\ntable.dataTable {\n  width: 100%;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  border: none;\n}\ntable.dataTable thead th {\n  white-space: nowrap;\n}\ntable.dataTable thead th.sorting_asc,\ntable.dataTable thead th.sorting_desc {\n  color: #6d7173;\n}\ntable.dataTable tbody tr {\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\ntable.dataTable tbody tr:hover {\n  background-color: #f7f8fa;\n}\ntable.dataTable td .ui.circular.label {\n  box-sizing: border-box;\n}\ntable.dataTable.overview th:first-child,\ntable.dataTable.overview td:first-child {\n  padding-left: 30px;\n  padding-right: 30px;\n}\ntable.dataTable.overview th:nth-child(n+2):nth-last-child(n+2),\ntable.dataTable.overview td:nth-child(n+2):nth-last-child(n+2) {\n  padding-right: 30px;\n}\ntable.dataTable.overview th:last-child,\ntable.dataTable.overview td:last-child {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n/* Sorting styles */\n/*\n  thead {\n    .sorting,\n    .sorting_asc,\n    .sorting_desc {\n      &::after {\n        position: relative;\n        top: 1px;\n        left: .6em;\n        content: \"\\f0d7\";\n        opacity: 0;\n        transition: transform .25s,opacity .25s;\n\n        font-family: Icons;\n        display: inline-block;\n        -webkit-font-smoothing: antialiased;\n        backface-visibility: hidden;\n      }\n    }\n\n    .sorting_asc,\n    .sorting_desc {\n      color: rgba( 0, 0, 0, .87 );\n\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    .sorting_desc::after {\n      transform: rotate(180deg);\n    }\n  }*/\ntable.ui.table,\ntabletable.dataTable {\n  /*\n  &.selectable {\n    tbody tr {\n      cursor: pointer;\n    }\n  }*/\n}\ntable.ui.table.nowrap th,\ntable.ui.table.nowrap td,\ntabletable.dataTable.nowrap th,\ntabletable.dataTable.nowrap td {\n  white-space: nowrap;\n}\n.app footer .dataTables_paginate .ui.pagination.menu {\n  background: transparent;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.app footer .dataTables_paginate .ui.pagination.menu .item {\n  font-size: 11px;\n  line-height: 1;\n  color: #3e8acc;\n}\n.app footer .dataTables_paginate .ui.pagination.menu .item.previous,\n.app footer .dataTables_paginate .ui.pagination.menu .item.next {\n  font-size: 13px;\n}\n.app footer .dataTables_paginate .ui.pagination.menu .active.item {\n  background-color: #428bca;\n  color: white;\n}\nspan.details.tooltip {\n  display: inline-block;\n  cursor: pointer;\n}\nspan.details.tooltip:after {\n  min-width: 20em;\n  white-space: pre-line;\n}\nspan.details.tooltip[data-position=\"bottom center\"]:before {\n  margin-left: -8px;\n}\n.s-alert-box {\n  z-index: 9999 !important;\n}\n.message.s-alert-box {\n  position: fixed !important;\n}\n.message.s-alert-box {\n  font: inherit;\n  min-width: 200px;\n  cursor: pointer;\n  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.22) inset, 0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15);\n  float: right;\n  line-height: 1.4285em;\n}\n.s-alert-top-right {\n  margin-right: 5px;\n  margin-top: 10px;\n  z-index: 9998 !important;\n}\n.starRating {\n  width: 89px;\n  float: left;\n}\n.ratingWrapper {\n  width: 130px;\n  padding-left: 10px;\n}\n.starRatingProfile {\n  position: relative;\n}\n.starRatingProfile .ratingWrapper {\n  position: absolute;\n  right: 0;\n  top: -60px;\n}\n.starRatingOverview > div {\n  float: left;\n  width: 50%;\n}\n.app header > a.button {\n  font-size: 16px;\n  margin: 18px 20px;\n  color: #788188;\n}\n.app header.view {\n  height: 60px;\n  padding-left: 25px;\n  padding-right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.app header.view.ui.segment {\n  margin-bottom: 0;\n}\n.app header.view > .close {\n  background: #F2F4F8;\n}\nheader > .item {\n  position: absolute;\n  top: -1px;\n  height: 60px;\n  background: white;\n  z-index: 1;\n}\nheader > .menu .item::before {\n  width: 0 !important;\n}\nheader > .item {\n  left: 60px;\n  width: calc(100% -  60px);\n  padding-left: 25px;\n  font-size: 13px;\n  letter-spacing: -0.0015em;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  transition: opacity 0.4s;\n}\nheader > .item > .main,\nheader > .item > .aside {\n  display: flex;\n}\nheader > .item > .main > div + div,\nheader > .item > .aside > div + div {\n  margin-left: 25px;\n}\nheader > .item > .main .meta,\nheader > .item > .aside .meta {\n  margin-left: \"5px\";\n  color: rgba(60, 65, 68, 0.6);\n}\nheader > .item > .main .meta.right,\nheader > .item > .aside .meta.right {\n  margin-left: auto;\n  margin-right: 25px;\n}\nheader > .item > .main .meta .important,\nheader > .item > .aside .meta .important {\n  color: #3FA2F7;\n}\nheader > .item > .main {\n  flex: 1;\n  padding-bottom: 2px;\n}\nheader > .item > .aside {\n  min-width: 360px;\n  width: 25vw;\n  padding: 0 25px;\n}\nheader > .item + div,\nheader > .item + div + div {\n  z-index: 1;\n}\nheader:hover > .item,\nheader.searching > .item {\n  opacity: 0;\n}\n.app > header .dropdown.notifications.unread {\n  pointer-events: auto;\n}\n.app > header .dropdown.notifications.unread .icon.button {\n  opacity: 0.5;\n}\n.app > header .dropdown.notifications .item.icon.counter {\n  padding: 2px !important;\n  background: white;\n}\n.app > header .dropdown.notifications .menu {\n  max-width: 280px;\n  min-width: 280px !important;\n}\n.app > header .dropdown.notifications .menu > div:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n.app > header .dropdown.notifications .menu > div:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.app > header .dropdown.notifications .menu .notifications {\n  max-height: 50vh;\n  overflow: auto;\n}\n.app > header .dropdown.notifications .item.header {\n  margin: 0;\n  padding: 1.2rem 1.13333333rem 1rem !important;\n  pointer-events: none;\n  background: white;\n  text-align: center;\n  color: #696e71;\n  text-transform: none;\n  letter-spacing: -0.01em;\n  font-size: 14px;\n  border-bottom: 1px solid #dae2e7;\n}\n.app > header .dropdown.notifications .item {\n  padding: 0.9rem 1.2rem !important;\n  background: #e9eff2;\n  cursor: pointer;\n}\n.app > header .dropdown.notifications .item.read {\n  background: #f4f7f9;\n}\n.app > header .dropdown.notifications .item:hover {\n  background: #eff3f5;\n}\n.app > header .dropdown.notifications .item:hover .remove {\n  opacity: 0.5;\n}\n.app > header .dropdown.notifications .item:hover .remove:hover {\n  opacity: 1;\n}\n.app > header .dropdown.notifications .item:hover .remove + .date {\n  opacity: 0;\n}\n.app > header .dropdown.notifications .item .notification {\n  position: relative;\n  white-space: normal;\n  color: rgba(60, 65, 68, 0.55);\n  -webkit-font-smoothing: auto;\n  font-size: 13px;\n}\n.app > header .dropdown.notifications .item .notification strong {\n  color: rgba(60, 65, 68, 0.75);\n}\n.app > header .dropdown.notifications .item .notification .date {\n  display: block;\n  transition: opacity 0.2s;\n  margin-top: 10px;\n}\n.app > header .dropdown.notifications .item .notification .remove {\n  position: absolute;\n  right: 0;\n  z-index: 1;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.app > header .dropdown.notifications .item + .item {\n  border-top: 1px solid #dae2e7;\n}\n.app > header .dropdown.notifications .item.read + .item.read {\n  border-top: 1px solid #e0e8ed;\n}\n.initials-avatar {\n  width: 2em;\n  height: 2em;\n  border-radius: 500rem;\n  background-color: black;\n  display: inline-block;\n}\n.initials-avatar div {\n  color: green;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: inherit;\n  font-weight: inherit;\n}\nbody .input-address {\n  position: relative;\n  /* Display address as text next to input */\n}\nbody .input-address .ui.icon.input > .icon {\n  color: #2185d0;\n  opacity: 1;\n}\nbody .input-address:not(.selected) > .display-text {\n  display: none;\n}\nbody .input-address .display-text {\n  width: 100%;\n  line-height: 35px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\nbody .input-address .options {\n  position: absolute;\n  width: calc(100% -  2 * 0.5em);\n  margin-left: 30px / 2;\n  margin-top: 37px;\n  z-index: 10;\n  /* 'inherited' from Materialize .input-field */\n  border: 1px solid #EBEBEB;\n  border-radius: 4px;\n  background: white;\n  /* Options list */\n  display: none;\n}\nbody .input-address .options.expanded {\n  display: block;\n}\nbody .input-address .options .group label,\nbody .input-address .options .option,\nbody .input-address .options .group .btn-basic {\n  padding: 10px 15px;\n}\nbody .input-address .options .group label {\n  display: block;\n  padding-top: 15px;\n  padding-bottom: 5px;\n  color: #cccccc;\n  font-size: 14px;\n}\nbody .input-address .options .group + .group {\n  border-top: 1px solid #f6f5f8;\n}\nbody .input-address .options .group .create-address,\nbody .input-address .options .group .create-address:hover {\n  box-shadow: none !important;\n}\nbody .input-address .options .option {\n  cursor: pointer;\n}\nbody .input-address .options .option .name {\n  display: inline-block;\n  min-width: 25%;\n}\nbody .input-address .options .option:hover {\n  background: #f6f6f6;\n}\nbody .input-address .options .option.locode .name {\n  display: inline;\n}\nbody .input-address .options .option.locode .code {\n  opacity: 0.3;\n}\nbody .input-address .options .option.locode .code:before {\n  content: \"— \";\n}\n.app form footer {\n  margin-top: 4em;\n}\n.app main .ui.secondary.pointing.menu.tabs {\n  margin-bottom: 0;\n  padding-left: 30px;\n}\n.app main .ui.secondary.pointing.menu.tabs > .header.item,\n.app main .ui.secondary.pointing.menu.tabs .item:first-child {\n  padding-left: 0;\n  margin-left: 0;\n}\n.app main .ui.secondary.pointing.menu.tabs .item {\n  margin-left: 1.7em;\n  margin-right: 1.7em;\n  padding-left: 0.05em;\n  padding-right: 0.05em;\n  height: 75px;\n  font-size: 13px;\n  letter-spacing: 0;\n  color: rgba(60, 65, 68, 0.6);\n  transition: color 0.3s;\n}\n.app main .ui.secondary.pointing.menu.tabs .item:hover {\n  color: rgba(60, 65, 68, 0.8);\n}\n.app main .ui.secondary.pointing.menu.tabs .item.active {\n  color: #2185d0;\n  border-color: transparent;\n}\n#clockdiv {\n  display: inline-block;\n  white-space: nowrap;\n  font-weight: 100;\n  text-align: center;\n  font-size: 30px;\n}\n#clockdiv > div {\n  padding: 10px;\n  border-radius: 3px;\n  display: inline-block;\n}\n#clockdiv div > span {\n  padding: 15px;\n  border-radius: 3px;\n  display: inline-block;\n}\n.smalltext {\n  padding-top: 5px;\n  font-size: 16px;\n}\n.milestones .milestone {\n  cursor: pointer;\n  position: relative;\n  margin-left: 20px;\n  padding-left: 30px;\n  padding-bottom: 3em;\n  border-left: 1px solid #d9d9d9;\n}\n.milestones .milestone i {\n  font-weight: bold;\n  opacity: 0.5;\n  letter-spacing: -0.02em;\n}\n.milestones .milestone > .icon {\n  position: absolute;\n  top: 0;\n  left: -15px;\n  background-color: white;\n  opacity: 1;\n  color: #b3b3b3;\n}\n.milestones .milestone.button,\n.milestones .milestone.button .icon {\n  color: #3FA2F7;\n  cursor: pointer;\n}\n.milestones .milestone:last-of-type {\n  border-left-color: transparent;\n}\n.react-tel-input .form-control {\n  padding-left: 48px !important;\n}\n.stops.horizontal .item {\n  text-align: center;\n  position: relative;\n  width: 90px;\n  vertical-align: top;\n}\n.stops.horizontal .item:not(:last-child):after {\n  position: absolute;\n  content: \"\";\n  right: -30%;\n  top: 0%;\n  width: 50%;\n  height: 16px !important;\n  border-bottom: 1px solid #d9d9d9 !important;\n  visibility: visible !important;\n}\n.field.dateTime .isPlaceholder {\n  opacity: 0.8;\n}\n.field.dateTime .isPlaceholder input {\n  color: #d4d7db;\n}\n.footer_footerbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.register .form .two.column.grid {\n  margin-top: 10px;\n}\n.register .form .two.column.grid .column:last-of-type {\n  text-align: right;\n}\n.register .form small {\n  display: block;\n  margin-top: 2em;\n}\n.register .form small a {\n  color: inherit;\n  text-decoration: underline;\n}\nmain.Portal .banner {\n  color: grey;\n  height: 150px;\n  width: 100%;\n  background: url(/images/repeat_background_horizontal.png);\n  background-color: #eee;\n}\nmain.Portal .logo {\n  float: left;\n  color: grey;\n  height: 150px;\n  width: 250px;\n  background-color: #fff;\n  padding: 25px;\n  position: relative;\n}\nmain.Portal .logo img {\n  width: 200px;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.container-top-padding > div div.container {\n  padding-top: 30px;\n}\n.app main.Settings > div {\n  height: calc(100vh -  60px);\n}\n.app main.Settings > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\n.app main.Settings + aside {\n  padding-bottom: 60px;\n}\n.app main.Settings > div > footer.ui.segment,\n.app main.Settings.ShipmentRequest footer.ui.segment,\n.app main.Settings + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\n.app main.Settings + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n.app main.Settings section.basic {\n  margin: 0;\n}\n.app main.Settings section.ui.segment {\n  border-radius: 2px;\n}\n.app main.Settings section em,\n.app main.Settings section .empty {\n  margin: 1em 0 1.5em;\n}\n.app main.Settings section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\n.app main.Settings section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\n.app main.Settings section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\n.app main.Settings section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\n.app main.Settings section > .list > .item > .content {\n  width: 100%;\n}\n.app main.Settings section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\n.app main.Settings > div div.container {\n  padding-top: 30px;\n}\n.app main.Settings .logo {\n  max-width: 300px;\n}\n.app main.Settings .ui.form.limit {\n  max-width: 1200px;\n}\n.accountUpgrade .segment.leftShadow {\n  box-shadow: inset 10px 0 0 0 #3FA2F7;\n}\nmain.JobsAdmin .ui.container {\n  padding-top: 30px;\n}\nmain.JobsAdmin .progress .bar {\n  transition: width 0.1s;\n}\nmain.JobsAdmin .progress .label {\n  font-size: 8pt;\n}\nmain.JobsAdmin .failures.label[data-tooltip]:after {\n  width: 500px;\n  white-space: normal;\n}\nmain.Dashboard section.basic {\n  margin: 0;\n}\nmain.Dashboard section.ui.segment {\n  border-radius: 2px;\n}\nmain.Dashboard section em,\nmain.Dashboard section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Dashboard section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Dashboard section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Dashboard section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Dashboard section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Dashboard section > .list > .item > .content {\n  width: 100%;\n}\nmain.Dashboard section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Dashboard section.big {\n  height: 472px;\n}\nmain.Dashboard section.big i {\n  font-size: 45px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  color: #3FA2F7;\n}\nmain.Dashboard section .section-container {\n  height: 100%;\n  display: block;\n  position: relative;\n  color: #3C4144;\n}\nmain.Dashboard section .section-content {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\nmain.Dashboard section .section-title {\n  font-size: 45px;\n  margin-bottom: 0;\n  font-weight: normal;\n}\nmain.Dashboard section .section-subtitle {\n  margin-top: 0;\n}\nmain.Dashboard .card i {\n  font-size: 20px;\n  color: #3FA2F7;\n}\nmain.Dashboard .ui.icon.message.profile {\n  background-color: #ffffff;\n  color: #3c4144;\n  margin-top: 0;\n  border-bottom: 2px solid #e0e1e2;\n}\nmain.Dashboard .profileprogress {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\nmain.Dashboard .notopmargin {\n  margin-top: 0;\n}\nmain.Dashboard #limit {\n  max-width: 1400px;\n  overflow: initial;\n}\nmain.Shipments > div {\n  height: calc(100vh -  60px);\n}\nmain.Shipments > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Shipments + aside {\n  padding-bottom: 60px;\n}\nmain.Shipments > div > footer.ui.segment,\nmain.Shipments.ShipmentRequest footer.ui.segment,\nmain.Shipments + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Shipments + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.Shipments > div > div {\n  height: calc(100% -  60px + 60px);\n  min-height: calc(100% -  60px + 60px);\n}\nmain.Shipments tr {\n  cursor: pointer;\n}\nmain.Shipments td {\n  white-space: nowrap;\n}\nmain.Shipments a.tip {\n  display: inline-block;\n  line-height: 1.75em;\n  color: #6d7173;\n  border-bottom: 1px dashed #dadbdc;\n}\nmain.Shipments header .ui.basic.button,\nmain.Shipments header .ui.basic.button:hover,\nmain.Shipments header .ui.basic.button:focus {\n  box-shadow: none !important;\n}\nmain.Shipments header .button {\n  margin-left: 10px;\n  line-height: 10px;\n}\nmain.Shipments header .button.basic {\n  color: rgba(0, 0, 0, 0.4) !important;\n}\nmain.Shipments header .button.basic:hover {\n  color: #3FA2F7 !important;\n  background: transparent !important;\n}\nmain.Shipments header .button.basic:active {\n  box-shadow: none;\n}\nmain.ShipmentsView > div {\n  height: calc(100vh -  60px);\n}\nmain.ShipmentsView > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.ShipmentsView + aside {\n  padding-bottom: 60px;\n}\nmain.ShipmentsView > div > footer.ui.segment,\nmain.ShipmentsView.ShipmentRequest footer.ui.segment,\nmain.ShipmentsView + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.ShipmentsView + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.ShipmentsView header.ui.segment {\n  background: rgba(255, 255, 255, 0.5);\n}\nmain.ShipmentsView header .ui.input {\n  font-size: 13px;\n}\nmain.ShipmentsView .ui.header {\n  margin: 2em 0 1em;\n  line-height: 2em;\n}\nmain.ShipmentsView .ui.header.dividing {\n  margin: 0 0 1.5em;\n}\nmain.ShipmentsView .ui.header.group.shipment {\n  display: none;\n}\nmain.ShipmentsView .add-button {\n  margin: 60px;\n  text-align: center;\n}\nmain.ShipmentsView .filter-input {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1em;\n}\nmain.ShipmentsView .filter-input > .dropdown {\n  height: 34px;\n}\nmain.ShipmentsView .filter-input .dropdown.name {\n  white-space: nowrap;\n}\nmain.ShipmentsView .filter-input .dropdown.disabled {\n  opacity: 1 !important;\n}\nmain.ShipmentsView .filter-input .dropdown.fluid {\n  height: 34px;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-left: 0.25em;\n  background: rgba(255, 255, 255, 0.5) !important;\n}\nmain.ShipmentsView .filter-input .dropdown.fluid:hover {\n  background: white !important;\n}\nmain.ShipmentsView .filter-input .dropdown.fluid .text {\n  line-height: 32px;\n  width: 95%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\nmain.ShipmentsView .filter-input .dropdown.fluid .menu {\n  width: 100%;\n}\nmain.Shipment .mainSubWrapper > aside .statusaside {\n  color: white;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 15px;\n  padding-right: 15px;\n  height: 50px;\n  font-size: 14px;\n  background-color: #3FA2F7;\n  border-radius: 25px;\n  display: inline;\n}\nmain.Shipment .mainSubWrapper > aside .tracklink {\n  color: white;\n  border-radius: 25px;\n  white-space: nowrap;\n}\nmain.Shipment .mainSubWrapper > aside .tracklink a {\n  color: white;\n  text-decoration: none;\n}\nmain.Shipment .mainSubWrapper > aside .stop {\n  position: relative;\n  margin-left: 20px;\n  padding-left: 30px;\n  padding-bottom: 3em;\n  border-left: 1px solid #d9d9d9;\n}\nmain.Shipment .mainSubWrapper > aside .stop > .icon {\n  position: absolute;\n  top: 0;\n  left: -15px;\n  background-color: #E9EDF4;\n  opacity: 1;\n  color: #b3b3b3;\n}\nmain.Shipment .mainSubWrapper > aside .stop .icon {\n  color: #3FA2F7;\n  cursor: pointer;\n}\nmain.Shipment .mainSubWrapper > aside .stop:last-of-type {\n  border-left-color: transparent;\n}\nmain.Shipment .mainSubWrapper > aside .stop .relative {\n  border: 1px solid transparent;\n}\nmain.Shipment .mainSubWrapper > aside .stop .relative.editable:hover {\n  border: 1px solid #EBEBEB;\n}\nmain.Shipment .mainSubWrapper > aside .stop .relative.editable:hover .icon {\n  visibility: visible !important;\n  cursor: pointer;\n}\n* {\n  scroll-margin-top: 48px;\n}\nmain.Shipment > div {\n  height: calc(100vh -  60px);\n}\nmain.Shipment > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Shipment + aside {\n  padding-bottom: 60px;\n}\nmain.Shipment > div > footer.ui.segment,\nmain.Shipment.ShipmentRequest footer.ui.segment,\nmain.Shipment + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Shipment + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.Shipment > div > div {\n  height: auto;\n  overflow: initial;\n}\nmain.Shipment > div div.container {\n  padding-bottom: 90px;\n}\nmain.Shipment aside {\n  position: sticky;\n  top: 0;\n}\nmain.Shipment .map {\n  padding: 0;\n  margin-bottom: 40px;\n}\nmain.Shipment .map > div {\n  height: 300px;\n  width: 100%;\n}\nmain.Shipment .date i,\nmain.Shipment .date label {\n  opacity: 0.5;\n  color: #483074;\n}\nmain.Shipment .partners .ui.cards {\n  width: 100%;\n}\nmain.Shipment .partners .ui.cards > .card {\n  width: calc(33.3% - 14px);\n}\nmain.Shipment .stages {\n  margin-top: 3em;\n}\nmain.Shipment .stages .stage h3 .status {\n  margin-left: 2em;\n  color: #3FA2F7;\n}\nmain.Shipment .stages .stage.draft .column.pickup,\nmain.Shipment .stages .stage.draft .column.delivery,\nmain.Shipment .stages .stage.draft .column.partner .relative {\n  border: 1px solid transparent;\n}\nmain.Shipment .stages .stage.draft .column.pickup.editable:hover,\nmain.Shipment .stages .stage.draft .column.delivery.editable:hover,\nmain.Shipment .stages .stage.draft .column.partner .relative.editable:hover {\n  border: 1px solid #EBEBEB;\n}\nmain.Shipment .stages .stage.draft .column.pickup.editable:hover .icon,\nmain.Shipment .stages .stage.draft .column.delivery.editable:hover .icon,\nmain.Shipment .stages .stage.draft .column.partner .relative.editable:hover .icon {\n  visibility: visible !important;\n  cursor: pointer;\n}\nmain.Shipment .stages .stage form {\n  margin-top: 2em;\n}\nmain.Shipment .stages .stage footer {\n  margin: 0 -40px -30px;\n  padding-left: 40px;\n  background: rgba(63, 162, 247, 0.1);\n  color: #3FA2F7;\n}\nmain.Shipment .stage {\n  box-shadow: inset 10px 0 0 0 #3FA2F7;\n}\nmain.Shipment .stage.error {\n  box-shadow: inset 10px 0 0 0 #e53935;\n}\nmain.Shipment .stage .buttons i.right {\n  opacity: 0.3;\n  cursor: pointer;\n  background: #e9edf4;\n}\nmain.Shipment .stage .buttons i.menu {\n  font-size: 40px;\n  height: 43px;\n}\nmain.Shipment section.basic {\n  margin: 0;\n}\nmain.Shipment section.ui.segment {\n  border-radius: 2px;\n}\nmain.Shipment section em,\nmain.Shipment section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Shipment section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Shipment section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Shipment section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Shipment section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Shipment section > .list > .item > .content {\n  width: 100%;\n}\nmain.Shipment section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Shipment section.documents .ui.list > .item > i.icon {\n  padding-right: 0.5em;\n  color: #3FA2F7;\n}\nmain.Shipment section.carriers .costs tr.declined td {\n  color: rgba(60, 65, 68, 0.3);\n}\nmain.Shipment section.carriers .costs td.response .approved {\n  color: #3FA2F7;\n}\nmain.Shipment section.carriers .costs td.response .declined {\n  color: #e53935;\n}\n.float.top.right {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  z-index: 1;\n  transition: border-color 0.1s ease;\n}\n.scroll-up,\n.shipment-navigation,\n.shipment-conversation {\n  cursor: pointer;\n  outline: none;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  border-radius: 99px;\n  color: rgba(34, 36, 38, 0.15);\n  width: 50px;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 2rem !important;\n  background-color: #E9EDF4;\n  transition-duration: 100ms;\n}\n.scroll-up:hover,\n.shipment-navigation:hover,\n.shipment-conversation:hover {\n  background-color: #3FA2F7;\n  border: 0px;\n  color: white;\n}\n.scroll-up > i,\n.shipment-navigation > i,\n.shipment-conversation > i {\n  margin: 0 !important;\n}\n.navigation-dd {\n  right: 0!important;\n  left: auto !important;\n  border-top-right-radius: 0 !important;\n}\n.navigation-dd button {\n  width: 100%;\n  font-weight: 600 !important;\n}\n.stages .table tr td {\n  border-top: 0px !important;\n}\n.stages .table .fields {\n  margin-bottom: 0 !important;\n}\n.modal.stage-split .input-field {\n  margin-left: 0;\n}\n.form-date-picker-container {\n  display: flex;\n  justify-content: space-between;\n}\n.form-date-picker-container .field {\n  margin-bottom: 0 !important;\n}\n.form-date-picker-container .field .fields {\n  margin-bottom: 0 !important;\n}\n.form-date-picker-container > .field.dateTime {\n  width: calc(100% - 30px);\n}\n.form-date-picker-container > .field.dateTime > .fields {\n  align-items: center;\n}\ntable.costDetail {\n  border-collapse: collapse !important;\n  border-left-width: 0 !important;\n  border-top-width: 0 !important;\n  border-bottom-width: 0 !important;\n  border-right-width: 0 !important;\n}\ntable.costDetail tr td {\n  border-top: 0 !important;\n  white-space: nowrap !important;\n}\ntable.costDetail td.descriptionColumn {\n  max-width: 250px !important;\n  width: 250px !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\ntable.costDetail td.actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\ntable.costDetail td.actions button {\n  visibility: hidden;\n}\ntable.costDetail tr:hover td.actions button {\n  visibility: visible;\n}\ntable.costDetail tr.declined {\n  text-decoration-line: line-through;\n  opacity: 0.5;\n}\n.cost-center-del-icon {\n  display: block !important;\n  margin: auto !important;\n  margin-left: 5px !important;\n}\n.cost-carrier-rating .ratingWrapper {\n  width: auto;\n}\n.cost-carrier-rating .ratingWrapper .starRating {\n  width: auto;\n}\n.insight .stops .item {\n  text-align: center;\n  position: relative;\n  width: 90px;\n  vertical-align: top;\n}\n.insight .stops .item:not(:last-child):after {\n  position: absolute;\n  content: \"\";\n  right: -30%;\n  top: 0%;\n  width: 50%;\n  height: 16px !important;\n  border-bottom: 1px solid #d9d9d9 !important;\n  visibility: visible !important;\n}\n.sidebar .carrier-select {\n  padding: 30px;\n}\n.sidebar .carrier-select section.price-list {\n  cursor: pointer;\n}\n.sidebar .carrier-select .transportprice {\n  color: #3FA2F7;\n}\nmain.NewShipment > div {\n  height: calc(100vh -  60px);\n}\nmain.NewShipment > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.NewShipment + aside {\n  padding-bottom: 60px;\n}\nmain.NewShipment > div > footer.ui.segment,\nmain.NewShipment.ShipmentRequest footer.ui.segment,\nmain.NewShipment + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.NewShipment + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n.packShipment {\n  display: block !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n.ts-shipment-pick__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.ts-shipment-pick__row h3 {\n  margin-bottom: 0;\n}\n.ts-shipment-pick__heading {\n  font-size: 40px;\n}\n.ts-shipment-pick__table.ui.table,\n.ts-shipment-pick__tabletable.dataTable {\n  font-size: 20px;\n}\n.ts-shipment-pick__table.ui.table thead th,\n.ts-shipment-pick__tabletable.dataTable thead th,\n.ts-shipment-pick__tablemain.PriceList .header.row .column {\n  font-size: 18px;\n}\n.ts-shipment-pick__list.list .item {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.ts-shipment-pick__option-header {\n  font-size: 20px;\n}\n.ts-shipment-pick__option-price {\n  display: block;\n  font-size: 16px;\n  margin-top: 10px;\n}\n.ts-shipment-pick__container {\n  padding-top: 30px;\n  padding-left: 30px;\n  padding-right: 30px;\n  max-width: 100%!important;\n  height: auto !important;\n  overflow: hidden !important;\n}\n.ts-shipment-header__loc {\n  display: flex;\n  align-items: center;\n}\n.ts-shipment-header__loc .ui.button {\n  margin-left: 10px;\n}\n.ts-manifest__col-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.ts-manifest__col-row h1 {\n  font-weight: bold;\n  font-size: 30px;\n  margin-bottom: 0;\n  color: #3c4144;\n}\n.ts-manifest__col-row .ui.button {\n  margin-left: 15px;\n}\n.packShipmentManifest .ui.container {\n  padding-top: 30px;\n}\n.ts-manifest-card.ui.blue.card {\n  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #1e97ff, 0 1px 3px 0 #bcbdbd;\n}\n.pick-footer {\n  width: 100% !important;\n}\nmain.ShipmentProject section.basic {\n  margin: 0;\n}\nmain.ShipmentProject section.ui.segment {\n  border-radius: 2px;\n}\nmain.ShipmentProject section em,\nmain.ShipmentProject section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.ShipmentProject section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.ShipmentProject section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.ShipmentProject section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.ShipmentProject section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.ShipmentProject section > .list > .item > .content {\n  width: 100%;\n}\nmain.ShipmentProject section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.ShipmentProject > div > div {\n  display: flex;\n  flex-direction: column;\n}\nmain.ShipmentProject .ui.secondary.pointing.menu.tabs {\n  flex-shrink: 0;\n}\nmain.ShipmentProject .column.location .relative {\n  border: 1px solid transparent;\n}\nmain.ShipmentProject .column.location .relative.editable:hover {\n  border: 1px solid #EBEBEB;\n}\nmain.ShipmentProject .column.location .relative.editable:hover .icon {\n  visibility: visible !important;\n  cursor: pointer;\n}\nmain.Track .row.fromto {\n  background-color: #fff;\n  border-radius: 5px;\n}\nmain.Track .row.fromto .column > div {\n  height: 140px;\n  padding: 20px;\n  text-align: center;\n}\nmain.Track .row.fromto .column h5 {\n  margin-bottom: 0;\n  font-weight: bold;\n}\nmain.Track .row.fromto .column .time {\n  margin-top: 2em;\n}\nmain.Track .row.fromto .column .time i {\n  color: #483074;\n}\nmain.Track .status h5 + div {\n  margin-top: 2em;\n}\nmain.Track .status .truck {\n  margin-bottom: 0.75em;\n  color: #3FA2F7;\n  text-align: left;\n}\nmain.Track .status .track,\nmain.Track .status .track .fill {\n  height: 8px;\n  background-color: #ccc;\n  border-radius: 8px;\n}\nmain.Track .status .track .fill {\n  background-color: #3FA2F7;\n}\nmain.Track .updates h4 {\n  padding-bottom: 1em;\n}\nmain.Track .updates .grid .column {\n  padding-top: 0.5em;\n  padding-bottom: 0;\n  white-space: nowrap;\n}\nbody > .track {\n  background: white;\n  padding: 50px;\n  height: 260px;\n}\n.timeline {\n  width: 100%;\n  text-align: center;\n}\n.statusbox {\n  height: 50px;\n  width: 100%;\n  text-align: center;\n}\n.track > .container {\n  background: white;\n  padding: 50px;\n}\n.track > .container header {\n  padding-bottom: 50px;\n}\n.track > .container header .logo {\n  width: 150px;\n}\n.track > .container header i {\n  color: #ccc;\n  font-size: 30px;\n}\n.track > .container h3 {\n  font-size: 16px;\n  font-weight: bold;\n  color: #2185d0;\n}\n.track > .container h4 {\n  font-size: 16px;\n}\n.track > .container h5 {\n  font-size: inherit;\n}\nmain.shipmentRequest footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  left: 60px;\n  width: calc(100% -  60px);\n  z-index: 1;\n  margin: auto !important;\n}\n.shipment-inbound-outbound_wrapper {\n  overflow-x: scroll;\n  flex-grow: 1;\n}\n.shipment-inbound-outbound_wrapper .loading-container {\n  overflow-y: auto;\n  height: 100%;\n}\n.shipment-inbound-outbound_wrapper::-webkit-scrollbar {\n  display: none;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.uppercase {\n  text-transform: uppercase;\n}\nmain.Import > div {\n  height: calc(100vh -  60px);\n}\nmain.Import > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Import + aside {\n  padding-bottom: 60px;\n}\nmain.Import > div > footer.ui.segment,\nmain.Import.ShipmentRequest footer.ui.segment,\nmain.Import + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Import + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.Import > div {\n  height: calc( 100vh -  60px + 60px);\n  overflow: auto;\n}\nmain.Import .tabs + .container {\n  min-height: 0;\n}\nmain.Import .ui.secondary.pointing.menu.tabs .item.error {\n  color: #e53935;\n}\nmain.Import .ui.search.dropdown .menu {\n  max-height: 55vh;\n}\nmain.Import form.file {\n  height: 100%;\n  padding: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\nmain.Import .samples {\n  color: rgba(60, 65, 68, 0.7);\n  font-size: 11px;\n}\nmain.Import .samples .item {\n  line-height: 1.1em;\n}\nmain.Import .dataTable td:not([colspan]) {\n  position: relative;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\nmain.Import .dataTable td a.info {\n  display: inline-block;\n  max-width: 35vw;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-transform: lowercase;\n  border-bottom: 1px solid;\n}\nmain.Import .dataTable td a.info[details]:hover::after {\n  content: attr(details);\n  position: absolute;\n  top: 45px;\n  left: 30px;\n  width: 30vw;\n  padding: 15px;\n  white-space: normal;\n  background: white;\n  text-transform: none;\n  z-index: 1;\n}\nmain.Import .dataTable td a.error {\n  display: inline-block;\n  max-width: 35vw;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #e53935;\n  text-transform: lowercase;\n  border-bottom: 1px solid;\n}\nmain.Import .dataTable td a.error[details]:hover::after {\n  content: attr(details);\n  position: absolute;\n  top: 45px;\n  left: 30px;\n  width: 30vw;\n  padding: 15px;\n  white-space: normal;\n  background: red;\n  color: white;\n  text-transform: none;\n  z-index: 1;\n}\naside ol.steps {\n  list-style: none;\n  padding: 0 0 0 18px;\n  margin: 0;\n}\naside ol.steps li {\n  position: relative;\n  padding-bottom: 10px;\n  user-select: none;\n}\naside ol.steps li:before {\n  position: absolute;\n  left: -1px / 2;\n  content: \"\";\n  z-index: -1;\n  width: 1px;\n}\naside ol.steps li:first-of-type:before {\n  top: 0;\n  height: 8.5px;\n  display: none;\n}\naside ol.steps li.active:first-of-type:before {\n  top: 0;\n  height: -1.5px;\n}\naside ol.steps li.active:after {\n  top: 26.5px;\n}\naside ol.steps li:before {\n  top: -28.5px;\n  height: 37px;\n}\naside ol.steps li.active:before,\naside ol.steps li.active + li:before {\n  height: 27px;\n}\naside ol.steps li.active + li:before {\n  top: -18.5px;\n}\naside ol.steps li.extra + li:before {\n  top: -47.5px;\n  height: 56px;\n}\naside ol.steps li.extra.active + li:before,\naside ol.steps li.extra + li.active:before {\n  height: 46px;\n}\naside ol.steps li.extra.active + li:before {\n  top: -37.5px;\n}\naside ol.steps li label,\naside ol.steps li span {\n  padding-left: 0;\n  cursor: pointer;\n}\naside ol.steps li label {\n  display: block;\n  font: 14px Roboto;\n  font-weight: 600;\n  color: rgba(60, 65, 68, 0.26);\n}\naside ol.steps li label:before {\n  content: \"\";\n  position: absolute;\n  top: 12.5px;\n  left: 0;\n  width: 0;\n  height: 0;\n  background-color: #483074;\n  border-radius: 0;\n}\naside ol.steps li span {\n  display: none;\n  font-size: 12px;\n  color: rgba(60, 65, 68, 0.54);\n}\naside ol.steps li.active label,\naside ol.steps li.done label {\n  color: rgba(60, 65, 68, 0.87);\n}\naside ol.steps li.active span,\naside ol.steps li.done span {\n  display: block;\n}\naside ol.steps li.done label:before,\naside ol.steps li.active label:before,\naside ol.steps li.active .percentage {\n  top: 0;\n  left: -20px;\n  width: 46px;\n  height: 46px;\n  background-color: #E9EDF4;\n  border-radius: 40px;\n  line-height: 40px;\n  text-align: center;\n  border: 2px solid #E9EDF4;\n}\naside ol.steps li.done label:before {\n  content: \"√\";\n  color: #483074;\n  box-shadow: 0 0 0 9px #3FA2F7, 0 0 0 10px rgba(60, 65, 68, 0.54);\n  box-shadow: inset 0 0 0 3px #483074;\n}\naside ol.steps li.active {\n  position: relative;\n}\naside ol.steps li.active label:before {\n  z-index: 1;\n}\naside ol.steps li.active label.p-100:before {\n  background-image: linear-gradient(90deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-100 .percentage:before {\n  content: \"100%\";\n}\naside ol.steps li.active label.p-99:before {\n  background-image: linear-gradient(86.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-99 .percentage:before {\n  content: \"99%\";\n}\naside ol.steps li.active label.p-98:before {\n  background-image: linear-gradient(82.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-98 .percentage:before {\n  content: \"98%\";\n}\naside ol.steps li.active label.p-97:before {\n  background-image: linear-gradient(79.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-97 .percentage:before {\n  content: \"97%\";\n}\naside ol.steps li.active label.p-96:before {\n  background-image: linear-gradient(75.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-96 .percentage:before {\n  content: \"96%\";\n}\naside ol.steps li.active label.p-95:before {\n  background-image: linear-gradient(72deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-95 .percentage:before {\n  content: \"95%\";\n}\naside ol.steps li.active label.p-94:before {\n  background-image: linear-gradient(68.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-94 .percentage:before {\n  content: \"94%\";\n}\naside ol.steps li.active label.p-93:before {\n  background-image: linear-gradient(64.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-93 .percentage:before {\n  content: \"93%\";\n}\naside ol.steps li.active label.p-92:before {\n  background-image: linear-gradient(61.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-92 .percentage:before {\n  content: \"92%\";\n}\naside ol.steps li.active label.p-91:before {\n  background-image: linear-gradient(57.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-91 .percentage:before {\n  content: \"91%\";\n}\naside ol.steps li.active label.p-90:before {\n  background-image: linear-gradient(54deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-90 .percentage:before {\n  content: \"90%\";\n}\naside ol.steps li.active label.p-89:before {\n  background-image: linear-gradient(50.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-89 .percentage:before {\n  content: \"89%\";\n}\naside ol.steps li.active label.p-88:before {\n  background-image: linear-gradient(46.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-88 .percentage:before {\n  content: \"88%\";\n}\naside ol.steps li.active label.p-87:before {\n  background-image: linear-gradient(43.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-87 .percentage:before {\n  content: \"87%\";\n}\naside ol.steps li.active label.p-86:before {\n  background-image: linear-gradient(39.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-86 .percentage:before {\n  content: \"86%\";\n}\naside ol.steps li.active label.p-85:before {\n  background-image: linear-gradient(36deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-85 .percentage:before {\n  content: \"85%\";\n}\naside ol.steps li.active label.p-84:before {\n  background-image: linear-gradient(32.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-84 .percentage:before {\n  content: \"84%\";\n}\naside ol.steps li.active label.p-83:before {\n  background-image: linear-gradient(28.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-83 .percentage:before {\n  content: \"83%\";\n}\naside ol.steps li.active label.p-82:before {\n  background-image: linear-gradient(25.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-82 .percentage:before {\n  content: \"82%\";\n}\naside ol.steps li.active label.p-81:before {\n  background-image: linear-gradient(21.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-81 .percentage:before {\n  content: \"81%\";\n}\naside ol.steps li.active label.p-80:before {\n  background-image: linear-gradient(18deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-80 .percentage:before {\n  content: \"80%\";\n}\naside ol.steps li.active label.p-79:before {\n  background-image: linear-gradient(14.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-79 .percentage:before {\n  content: \"79%\";\n}\naside ol.steps li.active label.p-78:before {\n  background-image: linear-gradient(10.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-78 .percentage:before {\n  content: \"78%\";\n}\naside ol.steps li.active label.p-77:before {\n  background-image: linear-gradient(7.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-77 .percentage:before {\n  content: \"77%\";\n}\naside ol.steps li.active label.p-76:before {\n  background-image: linear-gradient(3.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-76 .percentage:before {\n  content: \"76%\";\n}\naside ol.steps li.active label.p-75:before {\n  background-image: linear-gradient(0deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-75 .percentage:before {\n  content: \"75%\";\n}\naside ol.steps li.active label.p-74:before {\n  background-image: linear-gradient(-3.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-74 .percentage:before {\n  content: \"74%\";\n}\naside ol.steps li.active label.p-73:before {\n  background-image: linear-gradient(-7.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-73 .percentage:before {\n  content: \"73%\";\n}\naside ol.steps li.active label.p-72:before {\n  background-image: linear-gradient(-10.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-72 .percentage:before {\n  content: \"72%\";\n}\naside ol.steps li.active label.p-71:before {\n  background-image: linear-gradient(-14.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-71 .percentage:before {\n  content: \"71%\";\n}\naside ol.steps li.active label.p-70:before {\n  background-image: linear-gradient(-18deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-70 .percentage:before {\n  content: \"70%\";\n}\naside ol.steps li.active label.p-69:before {\n  background-image: linear-gradient(-21.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-69 .percentage:before {\n  content: \"69%\";\n}\naside ol.steps li.active label.p-68:before {\n  background-image: linear-gradient(-25.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-68 .percentage:before {\n  content: \"68%\";\n}\naside ol.steps li.active label.p-67:before {\n  background-image: linear-gradient(-28.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-67 .percentage:before {\n  content: \"67%\";\n}\naside ol.steps li.active label.p-66:before {\n  background-image: linear-gradient(-32.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-66 .percentage:before {\n  content: \"66%\";\n}\naside ol.steps li.active label.p-65:before {\n  background-image: linear-gradient(-36deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-65 .percentage:before {\n  content: \"65%\";\n}\naside ol.steps li.active label.p-64:before {\n  background-image: linear-gradient(-39.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-64 .percentage:before {\n  content: \"64%\";\n}\naside ol.steps li.active label.p-63:before {\n  background-image: linear-gradient(-43.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-63 .percentage:before {\n  content: \"63%\";\n}\naside ol.steps li.active label.p-62:before {\n  background-image: linear-gradient(-46.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-62 .percentage:before {\n  content: \"62%\";\n}\naside ol.steps li.active label.p-61:before {\n  background-image: linear-gradient(-50.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-61 .percentage:before {\n  content: \"61%\";\n}\naside ol.steps li.active label.p-60:before {\n  background-image: linear-gradient(-54deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-60 .percentage:before {\n  content: \"60%\";\n}\naside ol.steps li.active label.p-59:before {\n  background-image: linear-gradient(-57.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-59 .percentage:before {\n  content: \"59%\";\n}\naside ol.steps li.active label.p-58:before {\n  background-image: linear-gradient(-61.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-58 .percentage:before {\n  content: \"58%\";\n}\naside ol.steps li.active label.p-57:before {\n  background-image: linear-gradient(-64.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-57 .percentage:before {\n  content: \"57%\";\n}\naside ol.steps li.active label.p-56:before {\n  background-image: linear-gradient(-68.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-56 .percentage:before {\n  content: \"56%\";\n}\naside ol.steps li.active label.p-55:before {\n  background-image: linear-gradient(-72deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-55 .percentage:before {\n  content: \"55%\";\n}\naside ol.steps li.active label.p-54:before {\n  background-image: linear-gradient(-75.6deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-54 .percentage:before {\n  content: \"54%\";\n}\naside ol.steps li.active label.p-53:before {\n  background-image: linear-gradient(-79.2deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-53 .percentage:before {\n  content: \"53%\";\n}\naside ol.steps li.active label.p-52:before {\n  background-image: linear-gradient(-82.8deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-52 .percentage:before {\n  content: \"52%\";\n}\naside ol.steps li.active label.p-51:before {\n  background-image: linear-gradient(-86.4deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-51 .percentage:before {\n  content: \"51%\";\n}\naside ol.steps li.active label.p-50:before {\n  background-image: linear-gradient(-90deg, #483074 50%, transparent 50%, transparent), linear-gradient(270deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-50 .percentage:before {\n  content: \"50%\";\n}\naside ol.steps li.active label.p-49:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(266.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-49 .percentage:before {\n  content: \"49%\";\n}\naside ol.steps li.active label.p-48:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(262.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-48 .percentage:before {\n  content: \"48%\";\n}\naside ol.steps li.active label.p-47:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(259.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-47 .percentage:before {\n  content: \"47%\";\n}\naside ol.steps li.active label.p-46:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(255.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-46 .percentage:before {\n  content: \"46%\";\n}\naside ol.steps li.active label.p-45:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(252deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-45 .percentage:before {\n  content: \"45%\";\n}\naside ol.steps li.active label.p-44:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(248.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-44 .percentage:before {\n  content: \"44%\";\n}\naside ol.steps li.active label.p-43:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(244.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-43 .percentage:before {\n  content: \"43%\";\n}\naside ol.steps li.active label.p-42:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(241.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-42 .percentage:before {\n  content: \"42%\";\n}\naside ol.steps li.active label.p-41:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(237.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-41 .percentage:before {\n  content: \"41%\";\n}\naside ol.steps li.active label.p-40:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(234deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-40 .percentage:before {\n  content: \"40%\";\n}\naside ol.steps li.active label.p-39:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(230.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-39 .percentage:before {\n  content: \"39%\";\n}\naside ol.steps li.active label.p-38:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(226.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-38 .percentage:before {\n  content: \"38%\";\n}\naside ol.steps li.active label.p-37:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(223.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-37 .percentage:before {\n  content: \"37%\";\n}\naside ol.steps li.active label.p-36:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(219.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-36 .percentage:before {\n  content: \"36%\";\n}\naside ol.steps li.active label.p-35:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(216deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-35 .percentage:before {\n  content: \"35%\";\n}\naside ol.steps li.active label.p-34:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(212.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-34 .percentage:before {\n  content: \"34%\";\n}\naside ol.steps li.active label.p-33:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(208.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-33 .percentage:before {\n  content: \"33%\";\n}\naside ol.steps li.active label.p-32:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(205.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-32 .percentage:before {\n  content: \"32%\";\n}\naside ol.steps li.active label.p-31:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(201.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-31 .percentage:before {\n  content: \"31%\";\n}\naside ol.steps li.active label.p-30:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(198deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-30 .percentage:before {\n  content: \"30%\";\n}\naside ol.steps li.active label.p-29:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(194.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-29 .percentage:before {\n  content: \"29%\";\n}\naside ol.steps li.active label.p-28:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(190.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-28 .percentage:before {\n  content: \"28%\";\n}\naside ol.steps li.active label.p-27:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(187.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-27 .percentage:before {\n  content: \"27%\";\n}\naside ol.steps li.active label.p-26:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(183.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-26 .percentage:before {\n  content: \"26%\";\n}\naside ol.steps li.active label.p-25:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(180deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-25 .percentage:before {\n  content: \"25%\";\n}\naside ol.steps li.active label.p-24:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(176.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-24 .percentage:before {\n  content: \"24%\";\n}\naside ol.steps li.active label.p-23:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(172.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-23 .percentage:before {\n  content: \"23%\";\n}\naside ol.steps li.active label.p-22:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(169.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-22 .percentage:before {\n  content: \"22%\";\n}\naside ol.steps li.active label.p-21:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(165.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-21 .percentage:before {\n  content: \"21%\";\n}\naside ol.steps li.active label.p-20:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(162deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-20 .percentage:before {\n  content: \"20%\";\n}\naside ol.steps li.active label.p-19:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(158.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-19 .percentage:before {\n  content: \"19%\";\n}\naside ol.steps li.active label.p-18:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(154.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-18 .percentage:before {\n  content: \"18%\";\n}\naside ol.steps li.active label.p-17:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(151.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-17 .percentage:before {\n  content: \"17%\";\n}\naside ol.steps li.active label.p-16:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(147.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-16 .percentage:before {\n  content: \"16%\";\n}\naside ol.steps li.active label.p-15:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(144deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-15 .percentage:before {\n  content: \"15%\";\n}\naside ol.steps li.active label.p-14:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(140.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-14 .percentage:before {\n  content: \"14%\";\n}\naside ol.steps li.active label.p-13:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(136.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-13 .percentage:before {\n  content: \"13%\";\n}\naside ol.steps li.active label.p-12:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(133.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-12 .percentage:before {\n  content: \"12%\";\n}\naside ol.steps li.active label.p-11:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(129.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-11 .percentage:before {\n  content: \"11%\";\n}\naside ol.steps li.active label.p-10:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(126deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-10 .percentage:before {\n  content: \"10%\";\n}\naside ol.steps li.active label.p-9:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(122.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-9 .percentage:before {\n  content: \"9%\";\n}\naside ol.steps li.active label.p-8:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(118.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-8 .percentage:before {\n  content: \"8%\";\n}\naside ol.steps li.active label.p-7:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(115.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-7 .percentage:before {\n  content: \"7%\";\n}\naside ol.steps li.active label.p-6:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(111.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-6 .percentage:before {\n  content: \"6%\";\n}\naside ol.steps li.active label.p-5:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(108deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-5 .percentage:before {\n  content: \"5%\";\n}\naside ol.steps li.active label.p-4:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(104.4deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-4 .percentage:before {\n  content: \"4%\";\n}\naside ol.steps li.active label.p-3:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(100.8deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-3 .percentage:before {\n  content: \"3%\";\n}\naside ol.steps li.active label.p-2:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(97.2deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-2 .percentage:before {\n  content: \"2%\";\n}\naside ol.steps li.active label.p-1:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(93.6deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-1 .percentage:before {\n  content: \"1%\";\n}\naside ol.steps li.active label.p-0:before {\n  background-image: linear-gradient(90deg, #E9EDF4 50%, transparent 50%, transparent), linear-gradient(90deg, #483074 50%, #E9EDF4 50%, #E9EDF4);\n}\naside ol.steps li.active label.p-0 .percentage:before {\n  content: \"0%\";\n}\naside ol.steps li.active .percentage {\n  position: absolute;\n  top: 5px;\n  left: -15px;\n  width: 36px;\n  height: 36px;\n  z-index: 2;\n  background-color: #E9EDF4;\n  color: #3C4144;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 30px;\n}\n.DataImport > div {\n  height: calc(100vh -  60px);\n}\n.DataImport > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\n.DataImport + aside {\n  padding-bottom: 60px;\n}\n.DataImport > div > footer.ui.segment,\n.DataImport.ShipmentRequest footer.ui.segment,\n.DataImport + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\n.DataImport + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n.DataImport .dataTable td:not([colspan]) {\n  position: relative;\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.DataImport .dataTable td a.error {\n  display: inline-block;\n  max-width: 35vw;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: #e53935;\n  text-transform: lowercase;\n  border-bottom: 1px solid;\n}\nmain.Partners > div {\n  height: calc(100vh -  60px);\n}\nmain.Partners > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Partners + aside {\n  padding-bottom: 60px;\n}\nmain.Partners > div > footer.ui.segment,\nmain.Partners.ShipmentRequest footer.ui.segment,\nmain.Partners + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Partners + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.Directory .ui.container {\n  margin-top: 30px;\n}\nmain.Directory .more {\n  margin: 60px auto;\n  text-align: center;\n}\n.directory-card + .attached {\n  margin-top: -1em !important;\n  padding-bottom: 0.1em !important;\n}\n.directory-card {\n  display: block;\n  margin-bottom: 1em;\n}\n.directory-card .basic.table {\n  min-height: 90px;\n  table-layout: fixed;\n  transition: all 0.3s;\n}\n.directory-card .basic.table:hover {\n  border-color: #3FA2F7;\n}\n.directory-card .basic.table .rating {\n  margin-right: 0.8em;\n}\n.directory-card .basic.table td:nth-of-type(2) {\n  cursor: pointer;\n}\n.directory-card .basic.table td:nth-of-type(2) div {\n  display: flex;\n  align-items: center;\n}\n.directory-card .basic.table td:nth-of-type(2) div > .image {\n  margin: 0 1.4em 0 0.3em;\n}\n.directory-card .basic.table td:nth-of-type(2) div > .name {\n  flex: 1;\n  font-weight: bold;\n}\n.directory-card .basic.table td:nth-of-type(3) .description {\n  margin-bottom: 0.3em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.directory-card .basic.table td:nth-of-type(3) .tags .ui.label {\n  font-size: 10px;\n  margin-top: 0.2em;\n  margin-bottom: 0.2em;\n}\n@media all and (max-height: 799px) {\n  main.Partner + aside footer.ui.segment {\n    display: none;\n  }\n}\nmain.Partner section.basic {\n  margin: 0;\n}\nmain.Partner section.ui.segment {\n  border-radius: 2px;\n}\nmain.Partner section em,\nmain.Partner section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Partner section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Partner section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Partner section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Partner section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Partner section > .list > .item > .content {\n  width: 100%;\n}\nmain.Partner section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Partner .banner {\n  color: grey;\n  height: 250px;\n  width: 100%;\n  background: url(/images/repeat_background_horizontal.png);\n  background-color: #eee;\n}\nmain.Partner .logo {\n  float: left;\n  color: grey;\n  height: 250px;\n  width: 250px;\n  background-color: #fff;\n  padding: 25px;\n  position: relative;\n}\nmain.Partner .logo img {\n  width: 200px;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\nmain.Partner ul.distributed {\n  -moz-column-count: 4;\n  -moz-column-gap: 20px;\n  -webkit-column-count: 4;\n  -webkit-column-gap: 20px;\n  column-count: 4;\n  column-gap: 20px;\n}\nmain.Partner ul.distributed li {\n  list-style-type: none;\n}\nmain.Partner section.score .ui.card.score {\n  width: 120px;\n}\nmain.PartnerInvoice section.basic {\n  margin: 0;\n}\nmain.PartnerInvoice section.ui.segment {\n  border-radius: 2px;\n}\nmain.PartnerInvoice section em,\nmain.PartnerInvoice section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.PartnerInvoice section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.PartnerInvoice section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.PartnerInvoice section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.PartnerInvoice section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.PartnerInvoice section > .list > .item > .content {\n  width: 100%;\n}\nmain.PartnerInvoice section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.PartnerInvoice > div {\n  height: calc(100vh -  60px);\n}\nmain.PartnerInvoice > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.PartnerInvoice + aside {\n  padding-bottom: 60px;\n}\nmain.PartnerInvoice > div > footer.ui.segment,\nmain.PartnerInvoice.ShipmentRequest footer.ui.segment,\nmain.PartnerInvoice + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.PartnerInvoice + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.PartnerInvoice .column.seller,\nmain.PartnerInvoice .column.client,\nmain.PartnerInvoice .column.details {\n  border: 1px solid transparent;\n}\nmain.PartnerInvoice .column.editable:hover {\n  border: 1px solid #EBEBEB;\n}\nmain.PartnerInvoice .column.editable:hover .icon {\n  visibility: visible !important;\n  cursor: pointer;\n}\nmain.PartnerInvoice .report {\n  height: calc(100vh -  60px + 60px + 1px);\n}\nmain.PartnerInvoice .report iframe {\n  margin-top: 1px;\n  border: none;\n  height: 100%;\n}\nmain.PartnerInvoice .report #powerbi-container {\n  height: calc(100% - 1px);\n}\nmain.Addresses > div {\n  height: calc(100vh -  60px);\n}\nmain.Addresses > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Addresses + aside {\n  padding-bottom: 60px;\n}\nmain.Addresses > div > footer.ui.segment,\nmain.Addresses.ShipmentRequest footer.ui.segment,\nmain.Addresses + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Addresses + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\n@media all and (max-height: 799px) {\n  main.Address + aside footer.ui.segment {\n    display: none;\n  }\n}\nmain.Address section.basic {\n  margin: 0;\n}\nmain.Address section.ui.segment {\n  border-radius: 2px;\n}\nmain.Address section em,\nmain.Address section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Address section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Address section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Address section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Address section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Address section > .list > .item > .content {\n  width: 100%;\n}\nmain.Address section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Address .map {\n  height: 300px;\n  width: 100%;\n}\nmain.PriceList > div {\n  height: calc(100vh -  60px);\n}\nmain.PriceList > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.PriceList + aside {\n  padding-bottom: 60px;\n}\nmain.PriceList > div > footer.ui.segment,\nmain.PriceList.ShipmentRequest footer.ui.segment,\nmain.PriceList + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.PriceList + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.PriceList #priceListModalContainer {\n  text-align: right;\n  padding-right: 27px;\n  padding-bottom: 15px;\n}\nmain.PriceList .ui.segment {\n  box-shadow: none;\n}\nmain.PriceList .header.row {\n  padding-top: 0;\n}\nmain.PriceList .legend {\n  margin-top: 30px;\n  margin-bottom: 30px;\n  display: flex;\n}\nmain.PriceList .legend > div + div {\n  margin-left: 30px;\n}\nmain.PriceList .legend > div .label {\n  margin-right: 0.5em;\n}\nmain.PriceList .mainSubWrapper > aside img.partnerLogo {\n  width: auto;\n  height: auto;\n  max-height: 85px;\n  max-width: 240px;\n  margin-top: -60px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\nmain.PriceList .mainSubWrapper > aside .ui.list li a {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: inline-block;\n}\nmain.PriceList section > .list > .item > .icon {\n  color: #3fa2f7;\n  font-size: 18px;\n  line-height: 14px;\n}\n.ui.list > .item > .icon + .content.full {\n  /*display: inherit;*/\n  width: 100%;\n}\nmain.PriceList .segment.rates {\n  height: calc(100vh -  60px + 60px + 75px + 30px + 1px);\n}\nmain.PriceList .segment.rates .gridPlaceHolder {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 2 * 45px);\n  height: calc(100vh -  60px + 60px + 75px + 2 * 45px + 30px + 1px);\n  justify-content: center;\n  text-align: center;\n}\nmain.PriceRequest section.basic {\n  margin: 0;\n}\nmain.PriceRequest section.ui.segment {\n  border-radius: 2px;\n}\nmain.PriceRequest section em,\nmain.PriceRequest section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.PriceRequest section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.PriceRequest section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.PriceRequest section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.PriceRequest section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.PriceRequest section > .list > .item > .content {\n  width: 100%;\n}\nmain.PriceRequest section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.PriceRequest > div {\n  height: calc(100vh -  60px);\n}\nmain.PriceRequest > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.PriceRequest + aside {\n  padding-bottom: 60px;\n}\nmain.PriceRequest > div > footer.ui.segment,\nmain.PriceRequest.ShipmentRequest footer.ui.segment,\nmain.PriceRequest + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.PriceRequest + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.PriceRequest .analytics table.detail i {\n  color: #3fa2f7;\n}\nmain.PriceRequest .analytics table.detail span.supsub sup {\n  position: relative;\n  top: -0.5em;\n}\nmain.PriceRequest .analytics table.detail span.supsub sub {\n  position: relative;\n  top: 0.5em;\n  left: -1.5em;\n  /* This will vary with font... */\n}\nmain.PriceRequest .relative {\n  border: 1px solid transparent;\n}\nmain.PriceRequest .relative.editable:hover {\n  border: 1px solid #EBEBEB;\n  cursor: pointer;\n}\nmain.PriceRequest .relative.editable:hover .icon {\n  visibility: visible !important;\n}\nmain.Analysis .cheaper,\n.analysis-shipments-modal .cheaper {\n  color: #3fa2f7;\n}\nmain.Analysis .ui.steps {\n  min-height: 60px;\n}\nmain.Analysis .savings {\n  text-align: right;\n}\nmain.Analysis .savings > div {\n  margin-bottom: 0.5em;\n}\nmain.Analysis .savings > div .action.input > button {\n  min-width: 200px;\n  text-align: right;\n}\nmain.Analysis .savings > div .action.input > input {\n  width: 150px;\n}\nmain.Analysis .savings strong {\n  font-size: 0.8em;\n}\nmain.Analysis .cost.details.tooltip:after {\n  text-align: right;\n  min-width: 17em;\n}\nmain.Analysis .segment.report {\n  height: calc(100vh -  60px + 120px + 30px + 1px);\n  padding: 0;\n}\nmain.Analysis .segment.data {\n  min-height: calc(100vh -  60px + 120px + 30px + 60px + 1px);\n}\nmain.Analysis .reportContainer {\n  height: calc(100% -  75px);\n}\nmain.Tender section.basic {\n  margin: 0;\n}\nmain.Tender section.ui.segment {\n  border-radius: 2px;\n}\nmain.Tender section em,\nmain.Tender section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Tender section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Tender section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Tender section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Tender section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Tender section > .list > .item > .content {\n  width: 100%;\n}\nmain.Tender section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Tender > div {\n  height: calc(100vh -  60px);\n}\nmain.Tender > div > div {\n  height: calc(100% -  60px);\n  overflow: auto;\n}\nmain.Tender + aside {\n  padding-bottom: 60px;\n}\nmain.Tender > div > footer.ui.segment,\nmain.Tender.ShipmentRequest footer.ui.segment,\nmain.Tender + aside > footer.ui.segment {\n  position: fixed;\n  bottom: 0;\n  width: calc(100% -  60px);\n  z-index: 1;\n}\nmain.Tender + aside > footer.ui.segment {\n  min-width: 360px;\n  width: 25vw;\n}\nmain.Tender .item.horizontal {\n  float: left;\n  margin-right: 30px;\n}\nmain.Tender .tabs + .container {\n  height: calc(100% -  75px);\n}\nmain.Tender section .ui.form .documents,\nmain.Tender section .requirement .documents,\nmain.Tender section .milestone .documents,\nmain.Tender .intro .documents,\nmain.Tender section .ui.form .button,\nmain.Tender section .requirement .button,\nmain.Tender section .milestone .button,\nmain.Tender .intro .button {\n  margin: 1em 0;\n}\nmain.Tender section .ui.form .clickable.card,\nmain.Tender section .requirement .clickable.card,\nmain.Tender section .milestone .clickable.card,\nmain.Tender .intro .clickable.card {\n  cursor: pointer;\n}\nmain.Tender .requirement,\nmain.Tender .milestone {\n  cursor: pointer;\n}\nmain.Tender .requirement i,\nmain.Tender .milestone i {\n  font-weight: bold;\n  opacity: 0.5;\n  letter-spacing: -0.02em;\n}\nmain.Tender .requirement {\n  margin-bottom: 3em;\n}\nmain.Tender .requirements button,\nmain.Tender .requirements h4 {\n  margin: 2em 0;\n}\nmain.Tender .requirements .response textarea,\nmain.Tender .requirements .response .dropdown {\n  width: 300px;\n}\nmain.Tender .requirements .ui.form,\nmain.Tender .milestones .ui.form {\n  margin-top: 2em;\n}\nmain.Tender .milestone {\n  position: relative;\n  margin-left: 20px;\n  padding-left: 30px;\n  padding-bottom: 3em;\n  border-left: 1px solid #d9d9d9;\n}\nmain.Tender .milestone > .icon {\n  position: absolute;\n  top: 0;\n  left: -15px;\n  background-color: white;\n  opacity: 1;\n  color: #b3b3b3;\n}\nmain.Tender .milestone.button,\nmain.Tender .milestone.button .icon {\n  color: #3FA2F7;\n  cursor: pointer;\n}\nmain.Tender .milestone:last-of-type {\n  border-left-color: transparent;\n}\nmain.Tender .partners button {\n  margin-top: 2em;\n}\nmain.Tender .profile .review-result {\n  margin-left: 0.5em;\n  color: #b3b3b3;\n}\nmain.Tender .analysis {\n  height: 100%;\n}\nmain.Tender .analysis .powerbi {\n  height: 100%;\n}\nmain.Tender .analysis .powerbi iframe {\n  border: none;\n  height: 100%;\n}\nmain.Reporting > div > div {\n  height: 100%;\n}\nmain.Reporting .ui.tabs.menu {\n  margin-bottom: 0;\n}\nmain.Reporting .reportContainer {\n  height: calc(100% -  75px);\n}\nmain.DataExport section.basic {\n  margin: 0;\n}\nmain.DataExport section.ui.segment {\n  border-radius: 2px;\n}\nmain.DataExport section em,\nmain.DataExport section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.DataExport section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.DataExport section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.DataExport section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.DataExport section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.DataExport section > .list > .item > .content {\n  width: 100%;\n}\nmain.DataExport section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.ToolsOceanDistance section.basic {\n  margin: 0;\n}\nmain.ToolsOceanDistance section.ui.segment {\n  border-radius: 2px;\n}\nmain.ToolsOceanDistance section em,\nmain.ToolsOceanDistance section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.ToolsOceanDistance section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.ToolsOceanDistance section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.ToolsOceanDistance section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.ToolsOceanDistance section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.ToolsOceanDistance section > .list > .item > .content {\n  width: 100%;\n}\nmain.ToolsOceanDistance section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.ToolsOceanDistance .map {\n  height: 300px;\n  width: 100%;\n}\nmain.ToolsRouteInsight section.basic {\n  margin: 0;\n}\nmain.ToolsRouteInsight section.ui.segment {\n  border-radius: 2px;\n}\nmain.ToolsRouteInsight section em,\nmain.ToolsRouteInsight section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.ToolsRouteInsight section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.ToolsRouteInsight section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.ToolsRouteInsight section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.ToolsRouteInsight section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.ToolsRouteInsight section > .list > .item > .content {\n  width: 100%;\n}\nmain.ToolsRouteInsight section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.ToolsPriceLookup section.basic {\n  margin: 0;\n}\nmain.ToolsPriceLookup section.ui.segment {\n  border-radius: 2px;\n}\nmain.ToolsPriceLookup section em,\nmain.ToolsPriceLookup section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.ToolsPriceLookup section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.ToolsPriceLookup section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.ToolsPriceLookup section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.ToolsPriceLookup section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.ToolsPriceLookup section > .list > .item > .content {\n  width: 100%;\n}\nmain.ToolsPriceLookup section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Tenderify section.basic {\n  margin: 0;\n}\nmain.Tenderify section.ui.segment {\n  border-radius: 2px;\n}\nmain.Tenderify section em,\nmain.Tenderify section .empty {\n  margin: 1em 0 1.5em;\n}\nmain.Tenderify section .empty {\n  cursor: pointer;\n  color: #d4d2d5;\n}\nmain.Tenderify section h3.section-header i {\n  color: #ccc;\n  margin-left: 0.5em;\n  cursor: pointer;\n}\nmain.Tenderify section h3.section-header:not(:first-of-type) {\n  margin-top: 45px;\n}\nmain.Tenderify section > .list > .item > .icon {\n  color: #3FA2F7;\n  font-size: 18px;\n  line-height: 14px;\n}\nmain.Tenderify section > .list > .item > .content {\n  width: 100%;\n}\nmain.Tenderify section label .delete.icon {\n  cursor: pointer;\n  color: #ccc;\n}\nmain.Tenderify .segment.stretch {\n  height: calc(100vh -  60px + 60px + 75px + 30px + 1px);\n}\nmain.Tenderify div.relative.editable:hover .icon {\n  visibility: visible !important;\n  cursor: pointer;\n}\nmain.Tenderify td .relative {\n  padding: 0;\n}\nmain.Tenderify td.noTopPadding {\n  padding-top: 0 !important;\n}\n.sidebar .tenderify-bidControl {\n  padding: 30px;\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\n@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/icons.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\nbody,\n#react-root {\n  overflow: hidden;\n}\n\n.mainSubWrapper {\n  display: flex;\n\n  > div {\n    flex-grow: 1\n  }\n\n  > aside {\n    flex-shrink: 0;\n  }\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n\n  > header {\n    display: flex;\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: @headerHeight;\n    background: white;\n    color: @textColor; // Edge gives header color white\n\n    a.logo {\n      display: flex;\n      width: @baseSize;\n      height: @headerHeight;\n      justify-content: center;\n\n      background: @signaturePurpleColor;\n    }\n\n    form[role=\"search\"] {\n      flex: 1;\n      margin: 17px 25px 0;\n\n      .icon.input i.icon {\n        opacity: 1;\n        color: @infoHeaderColor;\n      }\n\n      .ui.input input {\n        line-height: normal;\n      }\n    }\n  }\n\n  nav.ui.vertical.menu {\n    width: @baseSize;\n    top: @baseSize;\n    height: 100%;\n\n    .item {\n      padding-left: 0;\n      padding-right: 0;\n      height: @baseSize;\n      font-size: 20px;\n      text-align: center;\n\n      transition: opacity 0.3s;\n\n      &:not(.active) {\n        opacity: 0.5;\n      }\n\n      &:hover {\n        opacity: 1;\n      }\n\n      > .submenu-icon {\n        font-size: 12px;\n        position: absolute;\n        right: 0;\n        line-height: 40px;\n        top: 15%;\n      }\n    }\n\n    .item.support {\n      position: fixed;\n      bottom: 0;\n      width: @baseSize;\n      height: @baseSize;\n      background: fade(white, 7%);\n    }\n\n    .item.dropdown:not(.hover) > .menu {\n      display: none;\n    }\n\n    .item.dropdown:hover > .menu {\n      display: block;\n    }\n\n    .item.dropdown {\n      > .menu {\n        background: transparent;\n        position: absolute;\n        transition: transform 0.15s 0.7s ease, opacity 0.15s 0.7s ease,\n          -webkit-transform 0.15s 0.7s ease;\n        padding-left: 6px;\n        // this element competes with \"tooltip\", and tooltip has z-index of 1900\n        z-index: 1901;\n      }\n    }\n\n    .dropdown-menu {\n      background: black;\n      padding: 0.833em 1em;\n\n      &--item {\n        font-size: 1rem;\n        margin: 0;\n        height: auto;\n        text-align: initial;\n        padding: 10px 0;\n      }\n    }\n  }\n\n  > .contentContainer > div {\n    flex: 1;\n    display: flex;\n    margin: @baseSize 0 0 @baseSize;\n  }\n\n  main,\n  main > div,\n  aside {\n    height: calc(~\"100vh - \" @headerHeight);\n  }\n\n  main > div {\n    max-width: calc(~\"100vw - \" @baseSize); // menu width\n    flex: 1;\n    width: 100%;\n\n    div.padding {\n      padding: 30px;\n    }\n\n    div.centered {\n      text-align: center;\n      color: red;\n    }\n\n    div.container {\n      width: auto;\n      padding: 0 @basePadding @basePadding;\n    }\n  }\n\n  main > div,\n  aside {\n    overflow: auto;\n\n    .content {\n      min-height: calc(~\"100% - \" @footerHeight + 1px);\n\n      &.ui.segment {\n        margin-bottom: 0; // override to prevent scrollbar\n      }\n    }\n\n    > footer {\n      height: @footerHeight;\n\n      // override\n      &.ui.segment {\n        margin-top: 0;\n        box-shadow: none;\n        margin-bottom: 0;\n      }\n\n      > div:first-child,\n      > div:last-child {\n        flex-basis: 30%;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  main {\n    position: relative;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n\n    .btn-floating.add {\n      position: absolute;\n      right: 40px;\n      top: 20px;\n      background-color: @secondaryColor;\n    }\n\n    ul.dropdown-content {\n      width: 200px !important;\n\n      a {\n        color: @primaryColor;\n        font-size: 14px;\n        font-weight: 500;\n\n        i {\n          position: relative;\n          top: 6px;\n          margin-right: 0.5em;\n          color: #cccccc;\n        }\n      }\n    }\n\n    footer {\n      &.ui.segment {\n        // Add top border on main footer\n        // (otherwise it looks weird when scrolling over white areas)\n        height: @footerHeight + 1px; // to compensate for border\n        border-top: 1px solid @pageBackground;\n\n        background-color: tint(@pageBackground, 50%);\n      }\n\n      .ui.basic.button,\n      .ui.basic.button:hover,\n      .ui.basic.button:focus {\n        // No border around basic buttons. We like it clean!\n        box-shadow: none !important;\n      }\n    }\n\n    // @media all and (min-height: @fixedFooterFrom) {\n    .main-fixed-footer;\n    // }\n  }\n\n  main,\n  aside {\n    footer {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-top: 0;\n\n      .button {\n        margin-left: 10px;\n        // font-size: 11px;\n        line-height: 10px;\n\n        &.basic {\n          color: rgba(0, 0, 0, 0.4) !important;\n\n          &:hover {\n            color: rgba(0, 0, 0, 0.5) !important;\n            background: transparent !important;\n          }\n\n          &:active {\n            box-shadow: none;\n          }\n        }\n      }\n\n      .status {\n        text-align: right;\n        margin: 0 10px 0 0;\n        font-size: 12px;\n        color: fade(@textColor, 60%);\n      }\n    }\n  }\n\n  aside {\n    width: 0;\n    //transition: width 0.5s cubic-bezier( 1, 0, .57, .83 );\n    -webkit-font-smoothing: antialiased;\n    background-color: @asideColor;\n\n    &.expanded {\n      min-width: @asideMinWidth;\n      width: @asideWidth;\n    }\n    &.minimized {\n      width: @asideMinimized;\n      min-width: 0;\n      transition: width 600ms ease-out;\n    }\n\n    h1 {\n      margin-bottom: 0.5rem;\n      font-size: 20px;\n    }\n\n    h4 {\n      margin: 0 0 5px;\n      font-size: 16px;\n\n      + .sub {\n        font-size: 13px;\n      }\n    }\n\n    h5 {\n      margin: 2.85em 0 1.12em;\n      font-size: inherit;\n      opacity: 0.4;\n      font-weight: 600;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    > .ui.very.padded.segment {\n      padding: @baseSize;\n    }\n\n    .meta {\n      opacity: 0.5;\n    }\n\n    .item-icon {\n      margin: 2rem 0;\n      line-height: 1.8;\n\n      i {\n        top: 1px;\n      }\n\n      div {\n        margin-left: 40px;\n      }\n\n      + .item-icon {\n        margin-top: 2.5rem;\n      }\n    }\n\n    footer {\n      justify-content: flex-end;\n\n      &.ui.segment {\n        background-color: tint(@asideColor, 50%);\n      }\n    }\n  }\n\n  // Make the page scroll as a whole on smaller screens, to avoid having awkward\n  // scrollbars everywhere\n  @media all and (max-height: @panelScrollFrom) {\n    main,\n    main > .contentContainer,\n    aside {\n      overflow: visible;\n      height: auto;\n      min-height: calc(~\"100vh - \" @footerHeight);\n    }\n\n    > .contentContainer {\n      overflow: auto;\n      height: 100vh;\n    }\n\n    // Fix weird 1px aside footer offset\n    aside > .content > div {\n      min-height: calc(~\"100% - \" @footerHeight);\n    }\n  }\n}\n\n.pusher > .ui.sidebar {\n  // -webkit-font-smoothing: antialiased;\n  background-color: @asideColor;\n}\n\n.pushable > .ui.sidebar {\n  // -webkit-font-smoothing: antialiased;\n  background-color: @asideColor;\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\n.main-fixed-footer {\n  // Make sure the <main> itself doens't overflow (to prevent double scrollbars\n  // with the app container scroll kicking in)\n  > div {\n    height: calc(~\"100vh - \" @headerHeight);\n  }\n\n  // Main content scroll container\n  > div > div {\n    height: calc(~\"100% - \" @footerHeight);\n    overflow: auto;\n  }\n\n  // Push content upwards to make place for footer\n  // > div > div,\n  + aside {\n    padding-bottom: @footerHeight;\n  }\n  // > div > div > .ui.container {\n  // \tpadding-bottom: @basePadding + @footerHeight;\n  // }\n\n  // Fix footers to bottom\n  > div > footer.ui.segment,\n  &.ShipmentRequest footer.ui.segment,\n  & + aside > footer.ui.segment {\n    position: fixed;\n    bottom: 0;\n    width: calc(~\"100% - \" @baseSize);\n    z-index: 1;\n  }\n\n  + aside > footer.ui.segment {\n    min-width: @asideMinWidth;\n    width: @asideWidth; // 100% is not an option as aside is not relative container\n  }\n}\n\n.main-fixed-footer-and-toolbar {\n  > div > div {\n    height: calc(~\"100% - \" @footerHeight + @baseSize);\n    min-height: calc(~\"100% - \" @footerHeight + @baseSize);\n  }\n}\n\n// Use this when the aside footer is just a placeholder without (important) content\n.aside-autohide-footer {\n  & + aside {\n    @media all and (max-height: ( @fixedFooterFrom - 1px )) {\n      footer.ui.segment {\n        // Hide the footer on smaller screens, as it's only there for decoration\n        // purposes at the moment\n        display: none;\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\n.register.container {\n  display: flex;\n  justify-content: stretch;\n  height: 100%;\n\n  main {\n    flex: 0 0 auto;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: @purple;\n    padding: 2 * @basePadding;\n    color: white;\n\n    @media (min-width: 701px) and (max-width: 850px) {\n      width: 70%;\n    }\n    @media (min-width: 851px) and (max-width: 1000px) {\n      width: 60%;\n    }\n    @media (min-width: 1001px) and (max-width: 1200px) {\n      width: 50%;\n    }\n    @media (min-width: 1201px) {\n      width: 40%;\n    }\n\n    > * {\n      flex: 1 0 auto;\n      max-width: 400px;\n    }\n\n    .ui.image.logo {\n      width: 250px;\n      margin-bottom: 30px;\n      margin-left: -15px;\n    }\n  }\n\n  aside {\n    flex: 1 0 auto;\n    background: url(\"/images/bg-1.webp\");\n    background-size: cover;\n    background-position: center;\n  }\n}\n","@import '{}/imports/client/styles/colors.import.less';\n@import '{}/imports/client/styles/sizes.import.less';\n\n.register.container {\n\t.ui.form .field {\n\t\tlabel {\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: white;\n\t\t}\n\t\tinput {\n\t\t\tbackground: fade( white, 20% );\n\t\t\tborder-color: transparent;\n\t\t\tcolor: black; // changed from white;\n\t\t}\n\t}\n\n\t.ui.form .fields {\n\t\tlabel {\n\t\t\ttext-transform: uppercase;\n\t\t\tcolor: white;\n\t\t}\n\n\t\t.field .checkbox label {\n\t\t\ttext-transform: none;\n\t\t}\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\nmain .form {\n  h1.ui.header {\n    color: @infoHeaderColor;\n  }\n\n  .icon-header {\n    display: flex;\n\n    .circle.icon {\n      margin-right: 10px;\n    }\n    svg {\n      flex: 1;\n    }\n  }\n}\n\n.semantic-select {\n  .ui.dropdown {\n    height: 48px;\n  }\n}\n\n// for in dropdown searches:\n.ui.dropdown.dropdown .menu > .input {\n  width: auto !important;\n}\n","// Default Variables\n@simple-line-font-path: \"../fonts/\"; // default\n@simple-line-font-family: \"simple-line-icons\"; // default\n@simple-line-icon-prefix: icon-; // default\n\n/*\n* Font Face\n*/\n\n@font-face {\n      font-family: '@{simple-line-font-family}';\n      src:  url('@{simple-line-font-path}Simple-Line-Icons.eot?v=2.4.0');\n      src:  url('@{simple-line-font-path}Simple-Line-Icons.eot?v=2.4.0#iefix') format('embedded-opentype'),\n            url('@{simple-line-font-path}Simple-Line-Icons.woff2?v=2.4.0') format('woff2'),\n            url('@{simple-line-font-path}Simple-Line-Icons.ttf?v=2.4.0') format('truetype'),\n            url('@{simple-line-font-path}Simple-Line-Icons.woff?v=2.4.0') format('woff'),\n            url('@{simple-line-font-path}Simple-Line-Icons.svg?v=2.4.0#simple-line-icons') format('svg');\n      font-weight: normal;\n      font-style: normal;\n}\n\n/*\n Use the following code if you want to have a class per icon.\n Instead of a list of all class selectors, you can use the generic [class*=\"icon-\"] selector,\n but it's slower.\n*/\n\n.@{simple-line-icon-prefix}  {\n  &user,\n  &people,\n  &user-female,\n  &user-follow,\n  &user-following,\n  &user-unfollow,\n  &login,\n  &logout,\n  &emotsmile,\n  &phone,\n  &call-end,\n  &call-in,\n  &call-out,\n  &map,\n  &location-pin,\n  &direction,\n  &directions,\n  &compass,\n  &layers,\n  &menu,\n  &list,\n  &options-vertical,\n  &options,\n  &arrow-down,\n  &arrow-left,\n  &arrow-right,\n  &arrow-up,\n  &arrow-up-circle,\n  &arrow-left-circle,\n  &arrow-right-circle,\n  &arrow-down-circle,\n  &check,\n  &clock,\n  &plus,\n  &minus,\n  &close,\n  &event,\n  &exclamation,\n  &organization,\n  &trophy,\n  &screen-smartphone,\n  &screen-desktop,\n  &plane,\n  &notebook,\n  &mustache,\n  &mouse,\n  &magnet,\n  &energy,\n  &disc,\n  &cursor,\n  &cursor-move,\n  &crop,\n  &chemistry,\n  &speedometer,\n  &shield,\n  &screen-tablet,\n  &magic-wand,\n  &hourglass,\n  &graduation,\n  &ghost,\n  &game-controller,\n  &fire,\n  &eyeglass,\n  &envelope-open,\n  &envelope-letter,\n  &bell,\n  &badge,\n  &anchor,\n  &wallet,\n  &vector,\n  &speech,\n  &puzzle,\n  &printer,\n  &present,\n  &playlist,\n  &pin,\n  &picture,\n  &handbag,\n  &globe-alt,\n  &globe,\n  &folder-alt,\n  &folder,\n  &film,\n  &feed,\n  &drop,\n  &drawer,\n  &docs,\n  &doc,\n  &diamond,\n  &cup,\n  &calculator,\n  &bubbles,\n  &briefcase,\n  &book-open,\n  &basket-loaded,\n  &basket,\n  &bag,\n  &action-undo,\n  &action-redo,\n  &wrench,\n  &umbrella,\n  &trash,\n  &tag,\n  &support,\n  &frame,\n  &size-fullscreen,\n  &size-actual,\n  &shuffle,\n  &share-alt,\n  &share,\n  &rocket,\n  &question,\n  &pie-chart,\n  &pencil,\n  &note,\n  &loop,\n  &home,\n  &grid,\n  &graph,\n  &microphone,\n  &music-tone-alt,\n  &music-tone,\n  &earphones-alt,\n  &earphones,\n  &equalizer,\n  &like,\n  &dislike,\n  &control-start,\n  &control-rewind,\n  &control-play,\n  &control-pause,\n  &control-forward,\n  &control-end,\n  &volume-1,\n  &volume-2,\n  &volume-off,\n  &calendar,\n  &bulb,\n  &chart,\n  &ban,\n  &bubble,\n  &camrecorder,\n  &camera,\n  &cloud-download,\n  &cloud-upload,\n  &envelope,\n  &eye,\n  &flag,\n  &heart,\n  &info,\n  &key,\n  &link,\n  &lock,\n  &lock-open,\n  &magnifier,\n  &magnifier-add,\n  &magnifier-remove,\n  &paper-clip,\n  &paper-plane,\n  &power,\n  &refresh,\n  &reload,\n  &settings,\n  &star,\n  &symbol-female,\n  &symbol-male,\n  &target,\n  &credit-card,\n  &paypal,\n  &social-tumblr,\n  &social-twitter,\n  &social-facebook,\n  &social-instagram,\n  &social-linkedin,\n  &social-pinterest,\n  &social-github,\n  &social-google,\n  &social-reddit,\n  &social-skype,\n  &social-dribbble,\n  &social-behance,\n  &social-foursqare,\n  &social-soundcloud,\n  &social-spotify,\n  &social-stumbleupon,\n  &social-youtube,\n  &social-dropbox,\n  &social-vkontakte,\n  &social-steam {\n    font-family: '@{simple-line-font-family}';\n    speak: none;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n}\n\n.@{simple-line-icon-prefix}user:before {\n  content: \"\\e005\";\n}\n\n.@{simple-line-icon-prefix}people:before {\n  content: \"\\e001\";\n}\n\n.@{simple-line-icon-prefix}user-female:before {\n  content: \"\\e000\";\n}\n\n.@{simple-line-icon-prefix}user-follow:before {\n  content: \"\\e002\";\n}\n\n.@{simple-line-icon-prefix}user-following:before {\n  content: \"\\e003\";\n}\n\n.@{simple-line-icon-prefix}user-unfollow:before {\n  content: \"\\e004\";\n}\n\n.@{simple-line-icon-prefix}login:before {\n  content: \"\\e066\";\n}\n\n.@{simple-line-icon-prefix}logout:before {\n  content: \"\\e065\";\n}\n\n.@{simple-line-icon-prefix}emotsmile:before {\n  content: \"\\e021\";\n}\n\n.@{simple-line-icon-prefix}phone:before {\n  content: \"\\e600\";\n}\n\n.@{simple-line-icon-prefix}call-end:before {\n  content: \"\\e048\";\n}\n\n.@{simple-line-icon-prefix}call-in:before {\n  content: \"\\e047\";\n}\n\n.@{simple-line-icon-prefix}call-out:before {\n  content: \"\\e046\";\n}\n\n.@{simple-line-icon-prefix}map:before {\n  content: \"\\e033\";\n}\n\n.@{simple-line-icon-prefix}location-pin:before {\n  content: \"\\e096\";\n}\n\n.@{simple-line-icon-prefix}direction:before {\n  content: \"\\e042\";\n}\n\n.@{simple-line-icon-prefix}directions:before {\n  content: \"\\e041\";\n}\n\n.@{simple-line-icon-prefix}compass:before {\n  content: \"\\e045\";\n}\n\n.@{simple-line-icon-prefix}layers:before {\n  content: \"\\e034\";\n}\n\n.@{simple-line-icon-prefix}menu:before {\n  content: \"\\e601\";\n}\n\n.@{simple-line-icon-prefix}list:before {\n  content: \"\\e067\";\n}\n\n.@{simple-line-icon-prefix}options-vertical:before {\n  content: \"\\e602\";\n}\n\n.@{simple-line-icon-prefix}options:before {\n  content: \"\\e603\";\n}\n\n.@{simple-line-icon-prefix}arrow-down:before {\n  content: \"\\e604\";\n}\n\n.@{simple-line-icon-prefix}arrow-left:before {\n  content: \"\\e605\";\n}\n\n.@{simple-line-icon-prefix}arrow-right:before {\n  content: \"\\e606\";\n}\n\n.@{simple-line-icon-prefix}arrow-up:before {\n  content: \"\\e607\";\n}\n\n.@{simple-line-icon-prefix}arrow-up-circle:before {\n  content: \"\\e078\";\n}\n\n.@{simple-line-icon-prefix}arrow-left-circle:before {\n  content: \"\\e07a\";\n}\n\n.@{simple-line-icon-prefix}arrow-right-circle:before {\n  content: \"\\e079\";\n}\n\n.@{simple-line-icon-prefix}arrow-down-circle:before {\n  content: \"\\e07b\";\n}\n\n.@{simple-line-icon-prefix}check:before {\n  content: \"\\e080\";\n}\n\n.@{simple-line-icon-prefix}clock:before {\n  content: \"\\e081\";\n}\n\n.@{simple-line-icon-prefix}plus:before {\n  content: \"\\e095\";\n}\n\n.@{simple-line-icon-prefix}minus:before {\n  content: \"\\e615\";\n}\n\n.@{simple-line-icon-prefix}close:before {\n  content: \"\\e082\";\n}\n\n.@{simple-line-icon-prefix}event:before {\n  content: \"\\e619\";\n}\n\n.@{simple-line-icon-prefix}exclamation:before {\n  content: \"\\e617\";\n}\n\n.@{simple-line-icon-prefix}organization:before {\n  content: \"\\e616\";\n}\n\n.@{simple-line-icon-prefix}trophy:before {\n  content: \"\\e006\";\n}\n\n.@{simple-line-icon-prefix}screen-smartphone:before {\n  content: \"\\e010\";\n}\n\n.@{simple-line-icon-prefix}screen-desktop:before {\n  content: \"\\e011\";\n}\n\n.@{simple-line-icon-prefix}plane:before {\n  content: \"\\e012\";\n}\n\n.@{simple-line-icon-prefix}notebook:before {\n  content: \"\\e013\";\n}\n\n.@{simple-line-icon-prefix}mustache:before {\n  content: \"\\e014\";\n}\n\n.@{simple-line-icon-prefix}mouse:before {\n  content: \"\\e015\";\n}\n\n.@{simple-line-icon-prefix}magnet:before {\n  content: \"\\e016\";\n}\n\n.@{simple-line-icon-prefix}energy:before {\n  content: \"\\e020\";\n}\n\n.@{simple-line-icon-prefix}disc:before {\n  content: \"\\e022\";\n}\n\n.@{simple-line-icon-prefix}cursor:before {\n  content: \"\\e06e\";\n}\n\n.@{simple-line-icon-prefix}cursor-move:before {\n  content: \"\\e023\";\n}\n\n.@{simple-line-icon-prefix}crop:before {\n  content: \"\\e024\";\n}\n\n.@{simple-line-icon-prefix}chemistry:before {\n  content: \"\\e026\";\n}\n\n.@{simple-line-icon-prefix}speedometer:before {\n  content: \"\\e007\";\n}\n\n.@{simple-line-icon-prefix}shield:before {\n  content: \"\\e00e\";\n}\n\n.@{simple-line-icon-prefix}screen-tablet:before {\n  content: \"\\e00f\";\n}\n\n.@{simple-line-icon-prefix}magic-wand:before {\n  content: \"\\e017\";\n}\n\n.@{simple-line-icon-prefix}hourglass:before {\n  content: \"\\e018\";\n}\n\n.@{simple-line-icon-prefix}graduation:before {\n  content: \"\\e019\";\n}\n\n.@{simple-line-icon-prefix}ghost:before {\n  content: \"\\e01a\";\n}\n\n.@{simple-line-icon-prefix}game-controller:before {\n  content: \"\\e01b\";\n}\n\n.@{simple-line-icon-prefix}fire:before {\n  content: \"\\e01c\";\n}\n\n.@{simple-line-icon-prefix}eyeglass:before {\n  content: \"\\e01d\";\n}\n\n.@{simple-line-icon-prefix}envelope-open:before {\n  content: \"\\e01e\";\n}\n\n.@{simple-line-icon-prefix}envelope-letter:before {\n  content: \"\\e01f\";\n}\n\n.@{simple-line-icon-prefix}bell:before {\n  content: \"\\e027\";\n}\n\n.@{simple-line-icon-prefix}badge:before {\n  content: \"\\e028\";\n}\n\n.@{simple-line-icon-prefix}anchor:before {\n  content: \"\\e029\";\n}\n\n.@{simple-line-icon-prefix}wallet:before {\n  content: \"\\e02a\";\n}\n\n.@{simple-line-icon-prefix}vector:before {\n  content: \"\\e02b\";\n}\n\n.@{simple-line-icon-prefix}speech:before {\n  content: \"\\e02c\";\n}\n\n.@{simple-line-icon-prefix}puzzle:before {\n  content: \"\\e02d\";\n}\n\n.@{simple-line-icon-prefix}printer:before {\n  content: \"\\e02e\";\n}\n\n.@{simple-line-icon-prefix}present:before {\n  content: \"\\e02f\";\n}\n\n.@{simple-line-icon-prefix}playlist:before {\n  content: \"\\e030\";\n}\n\n.@{simple-line-icon-prefix}pin:before {\n  content: \"\\e031\";\n}\n\n.@{simple-line-icon-prefix}picture:before {\n  content: \"\\e032\";\n}\n\n.@{simple-line-icon-prefix}handbag:before {\n  content: \"\\e035\";\n}\n\n.@{simple-line-icon-prefix}globe-alt:before {\n  content: \"\\e036\";\n}\n\n.@{simple-line-icon-prefix}globe:before {\n  content: \"\\e037\";\n}\n\n.@{simple-line-icon-prefix}folder-alt:before {\n  content: \"\\e039\";\n}\n\n.@{simple-line-icon-prefix}folder:before {\n  content: \"\\e089\";\n}\n\n.@{simple-line-icon-prefix}film:before {\n  content: \"\\e03a\";\n}\n\n.@{simple-line-icon-prefix}feed:before {\n  content: \"\\e03b\";\n}\n\n.@{simple-line-icon-prefix}drop:before {\n  content: \"\\e03e\";\n}\n\n.@{simple-line-icon-prefix}drawer:before {\n  content: \"\\e03f\";\n}\n\n.@{simple-line-icon-prefix}docs:before {\n  content: \"\\e040\";\n}\n\n.@{simple-line-icon-prefix}doc:before {\n  content: \"\\e085\";\n}\n\n.@{simple-line-icon-prefix}diamond:before {\n  content: \"\\e043\";\n}\n\n.@{simple-line-icon-prefix}cup:before {\n  content: \"\\e044\";\n}\n\n.@{simple-line-icon-prefix}calculator:before {\n  content: \"\\e049\";\n}\n\n.@{simple-line-icon-prefix}bubbles:before {\n  content: \"\\e04a\";\n}\n\n.@{simple-line-icon-prefix}briefcase:before {\n  content: \"\\e04b\";\n}\n\n.@{simple-line-icon-prefix}book-open:before {\n  content: \"\\e04c\";\n}\n\n.@{simple-line-icon-prefix}basket-loaded:before {\n  content: \"\\e04d\";\n}\n\n.@{simple-line-icon-prefix}basket:before {\n  content: \"\\e04e\";\n}\n\n.@{simple-line-icon-prefix}bag:before {\n  content: \"\\e04f\";\n}\n\n.@{simple-line-icon-prefix}action-undo:before {\n  content: \"\\e050\";\n}\n\n.@{simple-line-icon-prefix}action-redo:before {\n  content: \"\\e051\";\n}\n\n.@{simple-line-icon-prefix}wrench:before {\n  content: \"\\e052\";\n}\n\n.@{simple-line-icon-prefix}umbrella:before {\n  content: \"\\e053\";\n}\n\n.@{simple-line-icon-prefix}trash:before {\n  content: \"\\e054\";\n}\n\n.@{simple-line-icon-prefix}tag:before {\n  content: \"\\e055\";\n}\n\n.@{simple-line-icon-prefix}support:before {\n  content: \"\\e056\";\n}\n\n.@{simple-line-icon-prefix}frame:before {\n  content: \"\\e038\";\n}\n\n.@{simple-line-icon-prefix}size-fullscreen:before {\n  content: \"\\e057\";\n}\n\n.@{simple-line-icon-prefix}size-actual:before {\n  content: \"\\e058\";\n}\n\n.@{simple-line-icon-prefix}shuffle:before {\n  content: \"\\e059\";\n}\n\n.@{simple-line-icon-prefix}share-alt:before {\n  content: \"\\e05a\";\n}\n\n.@{simple-line-icon-prefix}share:before {\n  content: \"\\e05b\";\n}\n\n.@{simple-line-icon-prefix}rocket:before {\n  content: \"\\e05c\";\n}\n\n.@{simple-line-icon-prefix}question:before {\n  content: \"\\e05d\";\n}\n\n.@{simple-line-icon-prefix}pie-chart:before {\n  content: \"\\e05e\";\n}\n\n.@{simple-line-icon-prefix}pencil:before {\n  content: \"\\e05f\";\n}\n\n.@{simple-line-icon-prefix}note:before {\n  content: \"\\e060\";\n}\n\n.@{simple-line-icon-prefix}loop:before {\n  content: \"\\e064\";\n}\n\n.@{simple-line-icon-prefix}home:before {\n  content: \"\\e069\";\n}\n\n.@{simple-line-icon-prefix}grid:before {\n  content: \"\\e06a\";\n}\n\n.@{simple-line-icon-prefix}graph:before {\n  content: \"\\e06b\";\n}\n\n.@{simple-line-icon-prefix}microphone:before {\n  content: \"\\e063\";\n}\n\n.@{simple-line-icon-prefix}music-tone-alt:before {\n  content: \"\\e061\";\n}\n\n.@{simple-line-icon-prefix}music-tone:before {\n  content: \"\\e062\";\n}\n\n.@{simple-line-icon-prefix}earphones-alt:before {\n  content: \"\\e03c\";\n}\n\n.@{simple-line-icon-prefix}earphones:before {\n  content: \"\\e03d\";\n}\n\n.@{simple-line-icon-prefix}equalizer:before {\n  content: \"\\e06c\";\n}\n\n.@{simple-line-icon-prefix}like:before {\n  content: \"\\e068\";\n}\n\n.@{simple-line-icon-prefix}dislike:before {\n  content: \"\\e06d\";\n}\n\n.@{simple-line-icon-prefix}control-start:before {\n  content: \"\\e06f\";\n}\n\n.@{simple-line-icon-prefix}control-rewind:before {\n  content: \"\\e070\";\n}\n\n.@{simple-line-icon-prefix}control-play:before {\n  content: \"\\e071\";\n}\n\n.@{simple-line-icon-prefix}control-pause:before {\n  content: \"\\e072\";\n}\n\n.@{simple-line-icon-prefix}control-forward:before {\n  content: \"\\e073\";\n}\n\n.@{simple-line-icon-prefix}control-end:before {\n  content: \"\\e074\";\n}\n\n.@{simple-line-icon-prefix}volume-1:before {\n  content: \"\\e09f\";\n}\n\n.@{simple-line-icon-prefix}volume-2:before {\n  content: \"\\e0a0\";\n}\n\n.@{simple-line-icon-prefix}volume-off:before {\n  content: \"\\e0a1\";\n}\n\n.@{simple-line-icon-prefix}calendar:before {\n  content: \"\\e075\";\n}\n\n.@{simple-line-icon-prefix}bulb:before {\n  content: \"\\e076\";\n}\n\n.@{simple-line-icon-prefix}chart:before {\n  content: \"\\e077\";\n}\n\n.@{simple-line-icon-prefix}ban:before {\n  content: \"\\e07c\";\n}\n\n.@{simple-line-icon-prefix}bubble:before {\n  content: \"\\e07d\";\n}\n\n.@{simple-line-icon-prefix}camrecorder:before {\n  content: \"\\e07e\";\n}\n\n.@{simple-line-icon-prefix}camera:before {\n  content: \"\\e07f\";\n}\n\n.@{simple-line-icon-prefix}cloud-download:before {\n  content: \"\\e083\";\n}\n\n.@{simple-line-icon-prefix}cloud-upload:before {\n  content: \"\\e084\";\n}\n\n.@{simple-line-icon-prefix}envelope:before {\n  content: \"\\e086\";\n}\n\n.@{simple-line-icon-prefix}eye:before {\n  content: \"\\e087\";\n}\n\n.@{simple-line-icon-prefix}flag:before {\n  content: \"\\e088\";\n}\n\n.@{simple-line-icon-prefix}heart:before {\n  content: \"\\e08a\";\n}\n\n.@{simple-line-icon-prefix}info:before {\n  content: \"\\e08b\";\n}\n\n.@{simple-line-icon-prefix}key:before {\n  content: \"\\e08c\";\n}\n\n.@{simple-line-icon-prefix}link:before {\n  content: \"\\e08d\";\n}\n\n.@{simple-line-icon-prefix}lock:before {\n  content: \"\\e08e\";\n}\n\n.@{simple-line-icon-prefix}lock-open:before {\n  content: \"\\e08f\";\n}\n\n.@{simple-line-icon-prefix}magnifier:before {\n  content: \"\\e090\";\n}\n\n.@{simple-line-icon-prefix}magnifier-add:before {\n  content: \"\\e091\";\n}\n\n.@{simple-line-icon-prefix}magnifier-remove:before {\n  content: \"\\e092\";\n}\n\n.@{simple-line-icon-prefix}paper-clip:before {\n  content: \"\\e093\";\n}\n\n.@{simple-line-icon-prefix}paper-plane:before {\n  content: \"\\e094\";\n}\n\n.@{simple-line-icon-prefix}power:before {\n  content: \"\\e097\";\n}\n\n.@{simple-line-icon-prefix}refresh:before {\n  content: \"\\e098\";\n}\n\n.@{simple-line-icon-prefix}reload:before {\n  content: \"\\e099\";\n}\n\n.@{simple-line-icon-prefix}settings:before {\n  content: \"\\e09a\";\n}\n\n.@{simple-line-icon-prefix}star:before {\n  content: \"\\e09b\";\n}\n\n.@{simple-line-icon-prefix}symbol-female:before {\n  content: \"\\e09c\";\n}\n\n.@{simple-line-icon-prefix}symbol-male:before {\n  content: \"\\e09d\";\n}\n\n.@{simple-line-icon-prefix}target:before {\n  content: \"\\e09e\";\n}\n\n.@{simple-line-icon-prefix}credit-card:before {\n  content: \"\\e025\";\n}\n\n.@{simple-line-icon-prefix}paypal:before {\n  content: \"\\e608\";\n}\n\n.@{simple-line-icon-prefix}social-tumblr:before {\n  content: \"\\e00a\";\n}\n\n.@{simple-line-icon-prefix}social-twitter:before {\n  content: \"\\e009\";\n}\n\n.@{simple-line-icon-prefix}social-facebook:before {\n  content: \"\\e00b\";\n}\n\n.@{simple-line-icon-prefix}social-instagram:before {\n  content: \"\\e609\";\n}\n\n.@{simple-line-icon-prefix}social-linkedin:before {\n  content: \"\\e60a\";\n}\n\n.@{simple-line-icon-prefix}social-pinterest:before {\n  content: \"\\e60b\";\n}\n\n.@{simple-line-icon-prefix}social-github:before {\n  content: \"\\e60c\";\n}\n\n.@{simple-line-icon-prefix}social-google:before {\n  content: \"\\e60d\";\n}\n\n.@{simple-line-icon-prefix}social-reddit:before {\n  content: \"\\e60e\";\n}\n\n.@{simple-line-icon-prefix}social-skype:before {\n  content: \"\\e60f\";\n}\n\n.@{simple-line-icon-prefix}social-dribbble:before {\n  content: \"\\e00d\";\n}\n\n.@{simple-line-icon-prefix}social-behance:before {\n  content: \"\\e610\";\n}\n\n.@{simple-line-icon-prefix}social-foursqare:before {\n  content: \"\\e611\";\n}\n\n.@{simple-line-icon-prefix}social-soundcloud:before {\n  content: \"\\e612\";\n}\n\n.@{simple-line-icon-prefix}social-spotify:before {\n  content: \"\\e613\";\n}\n\n.@{simple-line-icon-prefix}social-stumbleupon:before {\n  content: \"\\e614\";\n}\n\n.@{simple-line-icon-prefix}social-youtube:before {\n  content: \"\\e008\";\n}\n\n.@{simple-line-icon-prefix}social-dropbox:before {\n  content: \"\\e00c\";\n}\n\n.@{simple-line-icon-prefix}social-vkontakte:before {\n  content: \"\\e618\";\n}\n\n.@{simple-line-icon-prefix}social-steam:before {\n  content: \"\\e620\";\n}\n","@import '{}/imports/client/styles/colors.import.less';\n//@import \"{}/client/lib/semantic-ui/site/elements/segment.variables.import.less\";\n\n\n@veryPaddedSegmentPadding: 45px; // get from segment.variables\n\n.icon-sections {\n\tsection {\n\t\t&.basic {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t&.ui.segment {\n\t\t\tborder-radius: 2px;\n\t\t}\n\n\t\tem,\n\t\t.empty {\n\t\t\tmargin: 1em 0 1.5em;\n\t\t}\n\n\t\t.empty {\n\t\t\tcursor: pointer;\n\t\t\t// color: @greenColor;\n\t\t\tcolor: #d4d2d5;\n\t\t}\n\n\t\th3.section-header {\n\t\t\ti {\n\t\t\t\tcolor: #ccc;\n\t\t\t\tmargin-left: .5em;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&:not(:first-of-type) {\n\t\t\t\tmargin-top: @veryPaddedSegmentPadding;\n\t\t\t}\n\t\t}\n\n\t\t> .list > .item {\n\t\t\t> .icon {\n\t\t\t\tcolor: @blue;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 14px;\n\t\t\t}\n\n\t\t\t> .content {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\tlabel .delete.icon {\n\t\t\tcursor: pointer;\n\t\t\tcolor: #ccc;\n\t\t}\n\t}\n}\n","@import '{}/imports/client/styles/colors.import.less';\n@import '{}/imports/client/styles/sizes.import.less';\n//@import \"{}/client/lib/semantic-ui/site/collections/table.variables.import.less\";\n\n@headerColor: tint( @textColor, 25% );\n\ntable.dataTable {\n  &:extend(.ui.table all);\n\n  width: 100%;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  border: none;\n\n  thead {\n    th {\n      white-space: nowrap;\n\n      &.sorting_asc,\n      &.sorting_desc {\n        color: @headerColor;\n      }\n    }\n  }\n  tbody tr {\n    cursor: pointer;\n    transition: background-color .2s;\n\n    &:hover {\n      background-color: tint( @pageBackground, 35% );\n    }\n  }\n  td {\n    .ui.circular.label {\n      box-sizing: border-box;\n    }\n  }\n}\n\ntable.dataTable.overview {\n  th, td {\n    &:first-child {\n      padding-left: @basePadding;\n      padding-right: @basePadding;\n    }\n    &:nth-child(n+2):nth-last-child(n+2) {\n      padding-right: @basePadding;\n    }\n\n    &:last-child {\n      padding-left: @basePadding;\n      padding-right: @basePadding;\n    }\n  }\n}\n\n  /* Sorting styles */\n  /*\n  thead {\n    .sorting,\n    .sorting_asc,\n    .sorting_desc {\n      &::after {\n        position: relative;\n        top: 1px;\n        left: .6em;\n        content: \"\\f0d7\";\n        opacity: 0;\n        transition: transform .25s,opacity .25s;\n\n        font-family: Icons;\n        display: inline-block;\n        -webkit-font-smoothing: antialiased;\n        backface-visibility: hidden;\n      }\n    }\n\n    .sorting_asc,\n    .sorting_desc {\n      color: rgba( 0, 0, 0, .87 );\n\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    .sorting_desc::after {\n      transform: rotate(180deg);\n    }\n  }*/\n\n\ntable.ui.table {\n  &.nowrap {\n    th,\n    td {\n      white-space: nowrap;\n    }\n  }\n  /*\n  &.selectable {\n    tbody tr {\n      cursor: pointer;\n    }\n  }*/\n}\n\n.app footer .dataTables_paginate {\n  .ui.pagination.menu {\n    background: transparent;\n    border: none;\n    box-shadow: inset 0 0 0 1px #ddd; // so the active bg overlaps\n  \n    .item {\n      font-size: 11px;\n      line-height: 1;\n      color: #3e8acc;\n      &.previous,\n      &.next {\n        font-size: 13px;\n      }\n    }\n    .active.item {\n      background-color: #428bca;\n      color: white;\n    }\n  }\n}\n","span.details.tooltip {\n\tdisplay: inline-block;\n\tcursor: pointer;\n\n\t&:after {\n\t\tmin-width: 20em;\n\t\twhite-space: pre-line;\n\t}\n\n\t&[data-position=\"bottom center\"]:before {\n\t\tmargin-left: -8px;\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\n.s-alert-box {\n  z-index: 9999 !important; // dimmer overlay z-index == 1000\n}\n\n.message.s-alert-box {\n  position: fixed !important;\n}\n\n.message.s-alert-box {\n  font: inherit;\n  min-width: 200px;\n  cursor: pointer;\n  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.22) inset,\n    0 2px 4px 0 rgba(34, 36, 38, 0.12), 0 2px 10px 0 rgba(34, 36, 38, 0.15);\n  float: right;\n  line-height: 1.4285em;\n}\n\n.s-alert-top-right {\n  margin-right: 5px;\n  margin-top: 10px;\n  z-index: 9998 !important; \n}\n",".starRating{\n\twidth:89px;\n\tfloat:left;\n}\n.ratingWrapper{\n\twidth:130px;\n\tpadding-left: 10px;\n}\n.starRatingProfile{\n\tposition:relative;\n}\n.starRatingProfile .ratingWrapper{\n\tposition:absolute;\n\tright:0;\n\ttop: -60px;\n}\n.starRatingOverview > div{\n  float: left;\n\twidth: 50%;\n}","@import '{}/imports/client/styles/colors.import.less';\n@import '{}/imports/client/styles/sizes.import.less';\n\n.app header {\n\t> a.button {\n\t\tfont-size: 16px;\n\t\tmargin: 18px 20px;\n\t\tcolor: @infoHeaderColor;\n\t}\n\n\t&.view {\n\t\theight: @baseSize;\n\t\tpadding-left: @headerFooterPadding;\n\t\tpadding-right: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\t&.ui.segment { // overrides\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t> .close {\n\t\t\tbackground: @pageBackground;\n\t\t}\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\nheader > .item {\n  position: absolute;\n  top: -1px;\n  height: @headerHeight;\n  background: white;\n  z-index: 1;\n}\n\nheader > .menu .item::before {\n  // removes line between the menu items\n  width: 0 !important;\n}\n\nheader > .item {\n  left: @baseSize;\n  width: calc(~\"100% - \" @baseSize); // minus logo width\n  padding-left: 25px;\n  font-size: 13px;\n  letter-spacing: -0.0015em;\n  display: flex;\n  align-items: center;\n  pointer-events: none;\n  transition: opacity 0.4s;\n\n  > .main,\n  > .aside {\n    display: flex;\n\n    > div + div {\n      margin-left: @metaMargin;\n    }\n\n    .meta {\n      margin-left: \"5px\";\n      color: fade(@textColor, 60%);\n\n      &.right {\n        margin-left: auto;\n        margin-right: @metaMargin;\n      }\n\n      .important {\n        color: @primaryColor;\n      }\n    }\n  }\n\n  > .main {\n    flex: 1;\n    padding-bottom: 2px; // for optical vertical centering\n  }\n\n  > .aside {\n    min-width: 360px;\n    width: 25vw;\n\n    padding: 0 @metaMargin;\n  }\n\n  // Make sure the buttons (user, notifications) are on top\n  + div,\n  + div + div {\n    z-index: 1;\n  }\n}\n\nheader:hover,\nheader.searching {\n  > .item {\n    opacity: 0;\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\n@menuWidth: 280px;\n\n.app > header {\n  .dropdown.notifications {\n    // height: @headerHeight + 20px;\n    // pointer-events: none;\n\n    // .icon.button {\n    // \tposition: relative;\n    // \ttop: 14px;\n    // \tbackground: transparent;\n    // \topacity: 0;\n\n    // \t.icon {\n    // \t\tfont-size: 18px;\n    // \t\theight: .7em;\n    // \t}\n    // }\n\n    &.unread {\n      pointer-events: auto;\n      .icon.button {\n        opacity: 0.5;\n      }\n    }\n    .item.icon.counter {\n      padding: 2px !important;\n      background: white;\n    }\n\n    .menu {\n      //right: -( @menuWidth / 2 - 24 );\n      //left: auto;\n      max-width: @menuWidth;\n      min-width: @menuWidth !important;\n\n      > div:first-child {\n        border-top-left-radius: 8px;\n        border-top-right-radius: 8px;\n      }\n      > div:last-child {\n        border-bottom-left-radius: 8px;\n        border-bottom-right-radius: 8px;\n      }\n\n      .notifications {\n        max-height: 50vh;\n        overflow: auto;\n      }\n    }\n\n    .item.header {\n      margin: 0;\n      padding: 1.2rem 1.13333333rem 1rem !important;\n      pointer-events: none;\n      background: white;\n      text-align: center;\n      color: #696e71;\n      text-transform: none;\n      letter-spacing: -0.01em;\n      font-size: 14px;\n      border-bottom: 1px solid #dae2e7;\n\n      //   .label {\n      //     margin-right: 0;\n      //     margin-left: 0.5em;\n      //     font-weight: 600;\n      //     font-size: 10px;\n      //     -webkit-font-smoothing: auto;\n      //   }\n    }\n\n    .item {\n      padding: 0.9rem 1.2rem !important;\n      background: #e9eff2;\n      cursor: pointer;\n\n      &.read {\n        background: tint(#e9eff2, 50%);\n      }\n\n      &:hover {\n        background: tint(#e9eff2, 25%);\n\n        .remove {\n          opacity: 0.5;\n\n          &:hover {\n            opacity: 1;\n          }\n        }\n        .remove + .date {\n          opacity: 0;\n        }\n      }\n\n      .notification {\n        position: relative;\n        white-space: normal;\n        color: fade(@textColor, 55%);\n        -webkit-font-smoothing: auto;\n        font-size: 13px;\n\n        strong {\n          color: fade(@textColor, 75%);\n        }\n\n        .date {\n          display: block;\n          transition: opacity 0.2s;\n          margin-top: 10px;\n        }\n\n        .remove {\n          position: absolute;\n          right: 0;\n          z-index: 1;\n          opacity: 0;\n          transition: opacity 0.2s;\n        }\n      }\n\n      & + .item {\n        border-top: 1px solid #dae2e7;\n      }\n      &.read + .item.read {\n        border-top: 1px solid #e0e8ed;\n      }\n    }\n  }\n}\n",".initials-avatar {\n  width: 2em;\n  height: 2em;\n  border-radius: 500rem;\n  background-color: black;\n  display: inline-block;\n\n  div {\n    color: green;\n\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-style: inherit;\n    font-weight: inherit;\n  }\n}","//@import \"/client/lib/semantic-ui/site/collections/form.variables.import.less\";\n@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\n@gutterWidth: 30px; // get from form.variables\n\nbody .input-address {\n  position: relative;\n\n  .ui.icon.input > .icon {\n    color: @darkBlueColor;\n    opacity: 1;\n  }\n\n  /* Display address as text next to input */\n  &:not(.selected) > .display-text {\n    display: none;\n  }\n\n  .display-text {\n    width: 100%;\n    line-height: 35px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .options {\n    position: absolute;\n    width: calc(~\"100% - \" 2 * @inputHorizontalPadding);\n    margin-left: @gutterWidth / 2;\n    margin-top: 37px;\n    z-index: 10;\n\n    /* 'inherited' from Materialize .input-field */\n    border: 1px solid @borderColor;\n    border-radius: 4px;\n    background: white;\n\n    /* Options list */\n    display: none;\n    &.expanded {\n      display: block;\n    }\n\n    .group label,\n    .option,\n    .group .btn-basic {\n      padding: 10px 15px;\n    }\n\n    .group {\n      label {\n        display: block;\n        padding-top: 15px;\n        padding-bottom: 5px;\n        color: #cccccc;\n        font-size: 14px;\n      }\n\n      & + .group {\n        border-top: 1px solid #f6f5f8;\n      }\n\n      .create-address,\n      .create-address:hover {\n        box-shadow: none !important;\n      }\n    }\n\n    .option {\n      cursor: pointer;\n\n      .name {\n        display: inline-block;\n        min-width: 25%;\n      }\n\n      &:hover {\n        background: #f6f6f6;\n      }\n\n      &.locode {\n        .name {\n          display: inline;\n        }\n\n        .code {\n          opacity: 0.3;\n\n          &:before {\n            content: \"— \";\n          }\n        }\n      }\n    }\n  }\n}\n",".app form {\n  footer {\n    margin-top: 4em;\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n\n.app main {\n  .ui.secondary.pointing.menu.tabs {\n    margin-bottom: 0;\n    padding-left: (@baseSize / 2);\n\n    > .header.item,\n    .item:first-child {\n      padding-left: 0;\n      margin-left: 0;\n    }\n\n    .item {\n      margin-left: 1.7em;\n      margin-right: 1.7em;\n      padding-left: 0.05em;\n      padding-right: 0.05em;\n      height: @tabsHeight;\n      font-size: 13px;\n      letter-spacing: 0;\n      color: fade(@textColor, 60%);\n      transition: color 0.3s;\n\n      &:hover {\n        color: fade(@textColor, 80%);\n      }\n\n      &.active {\n        color: @darkBlueColor;\n        border-color: transparent;\n        // font-weight: normal;\n      }\n    }\n  }\n}\n","#clockdiv {\n  display: inline-block;\n  white-space: nowrap;\n  font-weight: 100;\n  text-align: center;\n  font-size: 30px;\n}\n\n#clockdiv > div {\n  padding: 10px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n#clockdiv div > span {\n  padding: 15px;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.smalltext {\n  padding-top: 5px;\n  font-size: 16px;\n}\n",".milestones {\n  .milestone {\n    cursor: pointer;\n\n    i {\n      font-weight: bold;\n      opacity: 0.5;\n      letter-spacing: -0.02em;\n    }\n\n    position: relative;\n    margin-left: 20px;\n    padding-left: 30px;\n    padding-bottom: 3em;\n\n    border-left: 1px solid tint(black, 85%);\n\n    > .icon {\n      position: absolute;\n      top: 0;\n      left: -15px;\n      //font-size: 24px;\n      background-color: white;\n      opacity: 1;\n      color: tint(black, 70%);\n    }\n\n    &.button,\n    &.button .icon {\n      color: @primaryColor;\n      cursor: pointer;\n    }\n\n    &:last-of-type {\n      border-left-color: transparent;\n    }\n  }\n}\n",".react-tel-input .form-control {\n  padding-left: 48px !important;\n}",".stops.horizontal .item {\n  text-align: center;\n  position: relative;\n  width: 90px;\n  vertical-align: top;\n}\n\n.stops.horizontal .item:not(:last-child):after {\n  position: absolute;\n  content: \"\";\n  right: -30%;\n  top: 0%;\n  width: 50%;\n  height: 16px !important;\n  border-bottom: 1px solid tint(black, 85%) !important;\n  visibility: visible !important;\n}\n",".field.dateTime {\n  .isPlaceholder {\n    opacity: 0.8;\n    input {\n      color: #d4d7db;\n    }\n  }\n}\n",".footer_footerbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n",".register {\n\t.form {\n\t\t.two.column.grid {\n\t\t\tmargin-top: 10px;\n\n\t\t\t.column:last-of-type {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\n\t\tsmall {\n\t\t\tdisplay: block;\n\t\t\tmargin-top: 2em;\n\n\t\t\ta {\n\t\t\t\tcolor: inherit;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n}\n","main.Portal {\n  .banner {\n    color: grey;\n    height: 150px;\n    width: 100%;\n    background: url(/images/repeat_background_horizontal.png);\n    background-color: #eee;\n  }\n\n  .logo {\n    float: left;\n    color: grey;\n    height: 150px;\n    width: 250px;\n    background-color: #fff;\n    padding: 25px;\n    position: relative;\n\n    img {\n      width: 200px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n}\n",".container-top-padding {\n\t> div div.container {\n\t\tpadding-top: @basePadding;\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n@import \"{}/imports/client/styles/container.import.less\";\n\n.app main.Settings {\n  .main-fixed-footer;\n  .icon-sections;\n  .container-top-padding;\n  .logo {\n    max-width: 300px;\n  }\n  .ui.form.limit {\n    max-width: 1200px;\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\n.accountUpgrade {\n  .segment.leftShadow {\n    box-shadow: inset 10px 0 0 0 @blue;\n  }\n}\n","@import '{}/imports/client/styles/sizes.import.less';\n\nmain.JobsAdmin {\n\t.ui.container {\n\t\tpadding-top: @basePadding;\n\t}\n\n\t.progress {\n\t\t.bar {\n\t\t\ttransition: width .1s;\n\t\t}\n\t\t.label {\n\t\t\tfont-size: 8pt;\n\t\t}\n\t}\n\n\t.failures.label[data-tooltip] {\n\t\t&:after {\n\t\t\twidth: 500px;\n\t\t\twhite-space: normal;\n\t\t}\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.Dashboard {\n  .icon-sections;\n  section {\n    &.big {\n      height: 472px;\n\n      i {\n        font-size: 45px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        color: @blue;\n      }\n    }\n\n    .section-container {\n      height: 100%;\n      display: block;\n      position: relative;\n      color: @textColor;\n    }\n\n    .section-content {\n      width: 100%;\n      position: absolute;\n      bottom: 0;\n      left: 0;\n    }\n\n    .section-title {\n      font-size: 45px;\n      margin-bottom: 0;\n      font-weight: normal;\n    }\n    .section-subtitle {\n      margin-top: 0;\n    }\n  }\n\n  .card {\n    i {\n      font-size: 20px;\n      color: @blue;\n    }\n  }\n\n  .ui.icon.message.profile {\n    background-color: #ffffff;\n    color: #3c4144;\n    margin-top: 0;\n    border-bottom: 2px solid #e0e1e2;\n  }\n\n  .profileprogress {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .notopmargin {\n    margin-top: 0;\n  }\n\n  #limit {\n    max-width: 1400px;\n    overflow: initial;\n  }\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/colors.import.less\";\n\nmain.Shipments {\n  .main-fixed-footer;\n  .main-fixed-footer-and-toolbar;\n\n  tr {\n    cursor: pointer;\n  }\n\n  td {\n    white-space: nowrap;\n  }\n\n  a.tip {\n    display: inline-block;\n    line-height: 1.75em;\n    color: @headerColor;\n    border-bottom: 1px dashed tint(@headerColor, 75%);\n  }\n\n  header {\n    .ui.basic.button,\n    .ui.basic.button:hover,\n    .ui.basic.button:focus {\n      // No border around basic buttons. We like it clean!\n      box-shadow: none !important;\n    }\n\n    .button {\n      margin-left: 10px;\n      // font-size: 11px;\n      line-height: 10px;\n\n      &.basic {\n        color: rgba(0, 0, 0, 0.4) !important;\n\n        &:hover {\n          color: @primaryColor !important;\n          background: transparent !important;\n        }\n\n        &:active {\n          box-shadow: none;\n        }\n      }\n    }\n  }\n}\n","@import '{}/imports/client/styles/sizes.import.less';\n@import '{}/imports/client/styles/footer.import.less';\n\n\nmain.ShipmentsView {\n\t.main-fixed-footer;\n\n\theader {\n\t\t&.ui.segment {\n\t\t\tbackground: fade( white, 50% );\n\t\t}\n\n\t\t.ui.input {\n\t\t\tfont-size: 13px;\n\t\t}\n\t}\n\n\t.ui.header {\n\t\t// &:extend(.ui.form .field > label all);\n\n\t\tmargin: 2em 0 1em;\n\t\tline-height: 2em;\n\n\t\t&.dividing {\n\t\t\tmargin: 0 0 1.5em;\n\t\t}\n\n\t\t&.group.shipment {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.add-button {\n\t\tmargin: @basePadding * 2;\n\t\ttext-align: center;\n\t}\n\n\t.filter-input {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-bottom: 1em;\n\n\t\t> .dropdown {\n\t\t\theight: 34px;\n\t\t}\n\n\t\t.dropdown.name {\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t\t.dropdown.disabled {\n\t\t\topacity: 1 !important;\n\t\t}\n\n\t\t.dropdown.fluid {\n\t\t\theight: 34px;\n\t\t\tpadding-top: 0;\n\t\t\tpadding-bottom: 0;\n\t\t\tmargin-left: .25em;\n\t\t\tbackground: fade( white, 50% ) !important;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: white !important;\n\t\t\t}\n\n\t\t\t.text {\n\t\t\t\tline-height: 32px;\n\t\t\t\twidth: 95%;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t}\n\n\t\t\t.menu {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\nmain.Shipment .mainSubWrapper > aside {\n  .statusaside {\n    color: white;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 15px;\n    padding-right: 15px;\n    height: 50px;\n    font-size: 14px;\n    background-color: @primaryColor;\n    border-radius: 25px;\n    display: inline;\n  }\n\n  .tracklink {\n    color: white;\n    border-radius: 25px;\n    white-space: nowrap;\n\n    a {\n      color: white;\n      text-decoration: none;\n    }\n  }\n\n  .stop {\n    position: relative;\n    margin-left: 20px;\n    padding-left: 30px;\n    padding-bottom: 3em;\n\n    border-left: 1px solid tint(black, 85%);\n\n    > .icon {\n      position: absolute;\n      top: 0;\n      left: -15px;\n      //font-size: 24px;\n      background-color: @asideColor;\n      opacity: 1;\n      color: tint(black, 70%);\n    }\n\n    .icon {\n      color: @primaryColor;\n      cursor: pointer;\n    }\n\n    &:last-of-type {\n      border-left-color: transparent;\n    }\n\n    .relative {\n      border: 1px solid transparent;\n\n      &.editable:hover {\n        border: 1px solid @borderColor;\n\n        .icon {\n          visibility: visible !important;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\n@sectionVerticalPadding: 30px;\n\n*{\n  scroll-margin-top: 48px\n\n}\n\nmain.Shipment {\n  .main-fixed-footer;\n  // .aside-autohide-footer;\n\n  >div>div {\n    height: auto;\n    overflow: initial;\n  }\n\n  >div div.container {\n    padding-bottom: 90px;\n\n  }\n\n  aside {\n    position: sticky;\n    top: 0;\n  }\n\n  .map {\n    padding: 0;\n    margin-bottom: 40px;\n\n    >div {\n      height: 5 * @baseSize;\n      width: 100%;\n    }\n  }\n\n  .date i,\n  .date label {\n    opacity: 0.5;\n    color: @purpleColor;\n  }\n\n  .partners {\n    .ui.cards {\n      width: 100%;\n\n      >.card {\n        width: calc(~\"33.3% - 14px\");\n      }\n    }\n  }\n\n  .stages {\n    margin-top: 3em;\n\n    .stage {\n      // overflow: hidden;\n\n      h3 .status {\n        margin-left: 2em;\n        color: @blue;\n      }\n\n      &.draft {\n\n        .column.pickup,\n        .column.delivery,\n        .column.partner .relative {\n          border: 1px solid transparent;\n\n          &.editable:hover {\n            border: 1px solid @borderColor;\n\n            .icon {\n              visibility: visible !important;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n\n      form {\n        margin-top: 2em;\n      }\n\n      footer {\n        margin: 0 -40px -30px;\n        padding-left: 40px;\n        background: fade(@blue, 10%);\n        color: @blue;\n      }\n    }\n  }\n\n  .stage {\n    box-shadow: inset 10px 0 0 0 @blue;\n\n    &.error {\n      box-shadow: inset 10px 0 0 0 @errorColor;\n    }\n\n    .buttons {\n      i.right {\n        opacity: 0.3;\n        cursor: pointer;\n        background: #e9edf4;\n      }\n\n      i.menu {\n        font-size: 40px;\n        height: 43px;\n      }\n    }\n  }\n\n  .icon-sections;\n\n  section.documents {\n    .ui.list>.item>i.icon {\n      padding-right: 0.5em;\n      color: @primaryColor;\n    }\n  }\n\n  section.carriers {\n    .costs {\n      tr.declined {\n        td {\n          color: fade(@textColor, 30%);\n        }\n      }\n\n      td.response {\n        .approved {\n          color: @blue;\n        }\n\n        .declined {\n          color: @redColor;\n        }\n      }\n    }\n  }\n}\n\n// TODO [#258]: move style to general page\n\n.float.top.right {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  //width: 4em;\n  //height: 4em;\n  z-index: 1;\n  transition: border-color 0.1s ease;\n}\n\n.scroll-up,\n.shipment-navigation,\n.shipment-conversation {\n\n  cursor:pointer;\n\n  outline: none;\n  border: 1px solid rgba(34,36,38,.15);\n  border-radius: 99px;\n  color: rgba(34,36,38,.15);\n  width: 50px;\n  height: 50px;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  font-size: 2rem !important;\n\n  background-color: @asideColor;\n  transition-duration: 100ms;\n\n  &:hover {\n    background-color: @primaryColor;\n    border: 0px;\n    color: white\n  }\n  >i{\n    margin: 0 !important;\n  }\n}\n\n.navigation-dd{\n  right: 0!important;\n  left: auto !important;\n  border-top-right-radius: 0 !important;\n\n  button{\n    width: 100%;\n    font-weight: 600 !important;\n  }\n}",".stages .table {\n  tr td {\n    border-top: 0px !important;\n  }\n  .fields {\n    margin-bottom: 0 !important;\n  }\n}\n",".modal.stage-split {\n\t.input-field {\n\t\tmargin-left: 0;\n\t}\n}\n",".form-date-picker-container {\n  display: flex;\n  justify-content: space-between;\n  .field {\n    margin-bottom: 0 !important;\n    .fields {\n      margin-bottom: 0 !important;\n    }\n  }\n  > .field {\n    &.dateTime {\n      width: calc(100% - 30px);\n      > .fields {\n        align-items: center;\n      }\n    }\n  }\n}","table.costDetail {\n  border-collapse: collapse !important;\n  border-left-width: 0 !important;\n  border-top-width: 0 !important;\n  border-bottom-width: 0 !important;\n  border-right-width: 0 !important;\n\n  tr td {\n    border-top: 0 !important;\n    white-space: nowrap !important;\n  }\n\n  td.descriptionColumn {\n    max-width: 250px !important;\n    width: 250px !important;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n  }\n\n  td.actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    button {\n      visibility: hidden;\n    }\n  }\n\n  tr:hover {\n    td.actions button {\n      visibility: visible;\n    }\n  }\n\n  tr.declined {\n    text-decoration-line: line-through;\n    opacity: 0.5;\n  }\n}",".cost-center-del-icon {\n  display: block !important;\n  margin: auto !important;\n  margin-left: 5px !important;\n  // font-size: 1.2em !important;\n}\n\n.cost-carrier-rating {\n  .ratingWrapper {\n    width: auto;\n\n    .starRating {\n      width: auto\n    }\n  }\n\n}",".insight {\n  .stops .item {\n    text-align: center;\n    position: relative;\n    width: 90px;\n    vertical-align: top;\n  }\n\n  .stops .item:not(:last-child):after {\n    position: absolute;\n    content: \"\";\n    right: -30%;\n    top: 0%;\n    width: 50%;\n    height: 16px !important;\n    border-bottom: 1px solid tint(black, 85%) !important;\n    visibility: visible !important;\n  }\n}\n","@import '{}/imports/client/styles/colors.import.less';\n@import '{}/imports/client/styles/sizes.import.less';\n\n.sidebar .carrier-select {\n\tpadding: @basePadding;\n\n\tsection.price-list {\n\t\tcursor: pointer;\n\t}\n\n\t.transportprice {\n\t\tcolor: @primaryColor;\n\t}\n}\n","@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.NewShipment {\n  .main-fixed-footer;\n}",".packShipment {\n  display: block !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.ts-shipment-pick__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 20px;\n  padding-bottom: 20px;\n\n  h3 {\n    margin-bottom: 0;\n  }\n}\n\n.ts-shipment-pick__heading {\n  font-size: 40px;\n}\n\n.ts-shipment-pick__table {\n  &.ui.table {\n    font-size: 20px;\n    \n    thead th {\n      font-size: 18px;\n    }\n  }\n}\n\n.ts-shipment-pick__list.list {\n  .item {\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n}\n\n.ts-shipment-pick__option {\n  &-header {\n    font-size: 20px;\n  }\n\n  &-price {\n    display: block;\n    font-size: 16px;\n    margin-top: 10px;\n  }\n}\n\n.ts-shipment-pick__container {\n  padding-top: 30px;\n  padding-left: 30px;\n  padding-right: 30px;\n  max-width: 100%!important;\n  height: auto !important;\n  overflow: hidden !important;\n}\n\n.ts-shipment-header__loc {\n  display: flex;\n  align-items: center;\n\n  .ui.button {\n    margin-left: 10px;\n  }\n}\n\n.ts-manifest__col-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  h1 {\n    font-weight: bold;\n    font-size: 30px;\n    margin-bottom: 0;\n    color: #3c4144;\n  }\n\n  .ui.button {\n    margin-left: 15px;\n  }\n}\n\n.packShipmentManifest {\n  .ui.container {\n    padding-top: 30px;\n  }\n}\n\n.ts-manifest-card {\n  &.ui.blue.card {\n    box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #1e97ff, 0 1px 3px 0 #bcbdbd;\n  }\n}\n\n.pick-footer {\n  width: 100% !important;\n}\n","@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\n@sectionVerticalPadding: 30px;\n\nmain.ShipmentProject {\n  // .main-fixed-footer;\n  .icon-sections;\n\n  > div > div {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .ui.secondary.pointing.menu.tabs {\n    flex-shrink: 0;\n  }\n\n  .column.location .relative {\n    border: 1px solid transparent;\n\n    &.editable:hover {\n      border: 1px solid @borderColor;\n\n      .icon {\n        visibility: visible !important;\n        cursor: pointer;\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\nmain.Track {\n  .row.fromto {\n    background-color: #fff;\n    border-radius: 5px;\n\n    .column {\n      >div {\n        height: 140px;\n        padding: 20px;\n        text-align: center;\n      }\n\n      h5 {\n        margin-bottom: 0;\n        font-weight: bold;\n      }\n\n      .time {\n        margin-top: 2em;\n\n        i {\n          color: @purpleColor;\n        }\n      }\n    }\n  }\n\n  .status {\n    h5+div {\n      margin-top: 2em;\n    }\n\n    .truck {\n      margin-bottom: 0.75em;\n      color: @blue;\n      text-align: left;\n    }\n\n    .track,\n    .track .fill {\n      height: 8px;\n      background-color: #ccc;\n      border-radius: 8px;\n    }\n\n    .track .fill {\n      background-color: @blue;\n    }\n  }\n\n  .updates {\n    h4 {\n      padding-bottom: 1em;\n    }\n\n    .grid .column {\n      padding-top: 0.5em;\n      padding-bottom: 0;\n      white-space: nowrap;\n    }\n  }\n}\n\nbody>.track {\n  background: white;\n  padding: 50px;\n  height: 260px;\n}\n\n.timeline {\n  width: 100%;\n  text-align: center;\n}\n\n.statusbox {\n  height: 50px;\n  width: 100%;\n  text-align: center;\n}","@import \"{}/imports/client/styles/colors.import.less\";\n\n.track > .container {\n  background: white;\n  padding: 50px;\n\n  header {\n    padding-bottom: 50px;\n    .logo {\n      width: 150px;\n    }\n\n    i {\n      color: #ccc;\n      font-size: 30px;\n    }\n  }\n\n  h3 {\n    font-size: 16px;\n    font-weight: bold;\n    color: @darkBlueColor;\n  }\n  h4 {\n    font-size: 16px;\n  }\n  h5 {\n    font-size: inherit;\n  }\n}\n","@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.shipmentRequest {\n  footer.ui.segment {\n    position: fixed;\n    bottom: 0;\n    left: @baseSize;\n    width: calc(~\"100% - \" @baseSize);\n    z-index: 1;\n    margin: auto !important;\n  }\n}\n",".shipment-inbound-outbound_wrapper {\n  overflow-x: scroll;\n  flex-grow: 1;\n\n  .loading-container {\n    overflow-y: auto;\n    height: 100%;\n  }\n}\n\n.shipment-inbound-outbound_wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.Import {\n  .main-fixed-footer;\n\n  > div {\n    height: calc(~\" 100vh - \" @headerHeight + @footerHeight);\n    overflow: auto;\n  }\n\n  .tabs + .container {\n    min-height: 0;\n  }\n\n  .ui.secondary.pointing.menu.tabs .item.error {\n    color: @errorColor;\n  }\n\n  .ui.search.dropdown .menu {\n    max-height: 55vh;\n  }\n\n  form.file {\n    height: 100%;\n    padding: @basePadding;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .samples {\n    color: fade(@textColor, 70%);\n    font-size: 11px;\n\n    .item {\n      line-height: 1.1em;\n    }\n  }\n\n  .dataTable td:not([colspan]) {\n    position: relative;\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .dataTable td a.info {\n    display: inline-block;\n    max-width: 35vw;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-transform: lowercase;\n    border-bottom: 1px solid;\n\n    &[details]:hover {\n      &::after {\n        content: attr(details);\n        position: absolute;\n        top: 45px;\n        left: 30px;\n        width: 30vw;\n        padding: 15px;\n        white-space: normal;\n        background: white;\n        text-transform: none;\n        z-index: 1;\n      }\n    }\n  }\n\n  .dataTable td a.error {\n    display: inline-block;\n    max-width: 35vw;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: @errorColor;\n    text-transform: lowercase;\n    border-bottom: 1px solid;\n\n    &[details]:hover {\n      &::after {\n        content: attr(details);\n        position: absolute;\n        top: 45px;\n        left: 30px;\n        width: 30vw;\n        padding: 15px;\n        white-space: normal;\n        background: red;\n        color: white;\n        text-transform: none;\n        z-index: 1;\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\n@bigPadding: 0;\n@smallPadding: 10px;\n\n@dotSize: 0;\n@dotPadding: 4px;\n@dotBorderPadding: 9px;\n@dotBorderSize: 1px;\n@lineHeight: 25px;\n@normalHeight: @lineHeight + 10px + @smallPadding;\n@extraHeight: 19px;\n\n@dotTop: ((@lineHeight - @dotSize) / 2);\n@dividerHeight: (@normalHeight - @dotTop - @dotSize - @dotPadding);\n@dividerHeightActive: @dividerHeight - @dotBorderPadding - @dotBorderSize;\n\naside ol.steps {\n  list-style: none;\n  padding: @bigPadding 0 0 18px;\n  margin: 0;\n\n  li {\n    position: relative;\n    padding-bottom: @smallPadding;\n    user-select: none;\n\n    &:before {\n      position: absolute;\n      left: (@dotSize - 1px) / 2;\n      content: \"\";\n      z-index: -1;\n      width: 1px;\n    }\n\n    &:first-of-type:before {\n      top: -@bigPadding;\n      height: @bigPadding + @dotTop - @dotPadding;\n\n      display: none;\n    }\n\n    &.active:first-of-type:before {\n      top: -@bigPadding;\n      height: @bigPadding + @dotTop - @dotBorderPadding - @dotBorderSize -\n        @dotPadding;\n    }\n\n    &.active:after {\n      top: @dotTop + @dotSize + @dotBorderPadding + @dotBorderSize + @dotPadding;\n    }\n\n    &:before {\n      top: -@dividerHeight;\n      height: @dividerHeight + (@dotTop - @dotPadding);\n    }\n\n    &.active,\n    &.active + li {\n      &:before {\n        height: @dividerHeightActive + (@dotTop - @dotPadding);\n      }\n    }\n\n    &.active + li:before {\n      top: -@dividerHeightActive;\n    }\n\n    &.extra + li:before {\n      top: -(@dividerHeight + @extraHeight);\n      height: @dividerHeight + @extraHeight + (@dotTop - @dotPadding);\n    }\n\n    &.extra.active + li:before,\n    &.extra + li.active:before {\n      height: @dividerHeight + @extraHeight +\n        (@dotTop - @dotBorderPadding - @dotBorderSize - @dotPadding);\n    }\n\n    &.extra.active + li:before {\n      top: -(@dividerHeight + @extraHeight - @dotBorderPadding - @dotBorderSize);\n    }\n\n    label,\n    span {\n      padding-left: 0;\n      cursor: pointer;\n    }\n\n    label {\n      display: block;\n      font: 14px Roboto;\n      font-weight: 600;\n      color: fade(@textColor, 26%);\n\n      &:before {\n        content: \"\";\n        position: absolute;\n        top: @dotTop;\n        left: 0;\n        width: @dotSize;\n        height: @dotSize;\n        background-color: @secondaryColor;\n        border-radius: @dotSize;\n      }\n    }\n\n    span {\n      display: none;\n      font-size: 12px;\n      color: fade(@textColor, 54%);\n    }\n\n    &.active,\n    &.done {\n      label {\n        color: fade(@textColor, 87%);\n      }\n      span {\n        display: block;\n      }\n    }\n\n    &.done label:before,\n    &.active label:before,\n    &.active .percentage {\n      top: 0;\n      left: -20px;\n      width: 46px;\n      height: 46px;\n      background-color: @chromeColor;\n      border-radius: 40px;\n      line-height: 40px;\n      text-align: center;\n      border: 2px solid @chromeColor; // for masking the percentage gradient edge\n    }\n\n    &.done label:before {\n      content: \"√\";\n      color: @secondaryColor;\n\n      box-shadow: 0 0 0 @dotBorderPadding @primaryColor,\n        0 0 0 (@dotBorderPadding + @dotBorderSize) fade(@textColor, 54%);\n      box-shadow: inset 0 0 0 3px @secondaryColor;\n    }\n\n    &.active {\n      position: relative;\n\n      .percentage-circular( @percent: 0 ) when ( @percent =< 100 ) {\n        .percentage-circular(@percent + 1);\n\n        &.p-@{percent} when ( @percent < 50 ) {\n          &:before {\n            background-image: linear-gradient(\n                90deg,\n                @chromeColor 50%,\n                transparent 50%,\n                transparent\n              ),\n              linear-gradient(\n                90deg + (3.6deg * @percent),\n                @secondaryColor 50%,\n                @chromeColor 50%,\n                @chromeColor\n              );\n          }\n\n          .percentage:before {\n            content: \"@{percent}%\";\n          }\n        }\n        &.p-@{percent} when ( @percent >= 50 ) {\n          &:before {\n            background-image: linear-gradient(\n                (-90deg + (3.6deg * (@percent - 50))),\n                @secondaryColor 50%,\n                transparent 50%,\n                transparent\n              ),\n              linear-gradient(\n                270deg,\n                @secondaryColor 50%,\n                @chromeColor 50%,\n                @chromeColor\n              );\n          }\n\n          .percentage:before {\n            content: \"@{percent}%\";\n          }\n        }\n      }\n\n      label {\n        &:before {\n          z-index: 1;\n        }\n\n        .percentage-circular();\n      }\n\n      .percentage {\n        position: absolute;\n\n        top: 5px;\n        left: -15px;\n        width: 36px;\n        height: 36px;\n\n        z-index: 2;\n        background-color: @chromeColor;\n        color: @textColor;\n        font-weight: bold;\n        font-size: 14px;\n        line-height: 30px;\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n\n.DataImport {\n  .main-fixed-footer;\n\n  .dataTable td:not([colspan]) {\n    position: relative;\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .dataTable td a.error {\n    display: inline-block;\n    max-width: 35vw;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: @errorColor;\n    text-transform: lowercase;\n    border-bottom: 1px solid;\n  }\n}\n","@import '{}/imports/client/styles/footer.import.less';\n\nmain.Partners {\n  .main-fixed-footer;\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n\nmain.Directory {\n  .ui.container {\n    margin-top: @basePadding;\n  }\n\n  .more {\n    margin: @baseSize auto;\n    text-align: center;\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n\n.directory-card + .attached {\n  margin-top: -1em !important;\n  padding-bottom: 0.1em !important;\n}\n\n.directory-card {\n  display: block;\n  margin-bottom: 1em;\n\n  .basic.table {\n    min-height: 90px;\n    table-layout: fixed;\n    transition: all 0.3s;\n\n    &:hover {\n      border-color: @blue;\n    }\n\n    .rating {\n      margin-right: 0.8em;\n    }\n\n    td:nth-of-type(2) {\n      cursor: pointer;\n      div {\n        display: flex;\n        align-items: center;\n\n        > .image {\n          margin: 0 1.4em 0 0.3em;\n        }\n\n        > .name {\n          flex: 1;\n          font-weight: bold;\n        }\n      }\n    }\n    td:nth-of-type(3) {\n      .description {\n        margin-bottom: 0.3em;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n      .tags {\n        .ui.label {\n          font-size: 10px;\n          margin-top: 0.2em;\n          margin-bottom: 0.2em;\n        }\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/footer.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.Partner {\n  .aside-autohide-footer;\n  .icon-sections;\n\n  .banner {\n    color: grey;\n    height: 250px;\n    width: 100%;\n    background: url(/images/repeat_background_horizontal.png);\n    background-color: #eee;\n  }\n\n  .logo {\n    float: left;\n    color: grey;\n    height: 250px;\n    width: 250px;\n    background-color: #fff;\n    padding: 25px;\n    position: relative;\n\n    img {\n      width: 200px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n    }\n  }\n\n  ul.distributed {\n    -moz-column-count: 4;\n    -moz-column-gap: 20px;\n    -webkit-column-count: 4;\n    -webkit-column-gap: 20px;\n    column-count: 4;\n    column-gap: 20px;\n\n    li {\n      list-style-type: none;\n    }\n  }\n}\n","main.Partner {\n\tsection.score {\n\t\t.ui.card.score {\n\t\t\twidth: 120px;\n\t\t}\n\t}\n}\n","@import \"{}/imports/client/styles/sections.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.PartnerInvoice {\n  .icon-sections;\n  .main-fixed-footer;\n\n  .column.seller,\n  .column.client,\n  .column.details {\n    border: 1px solid transparent;\n  }\n\n  .column.editable:hover {\n    border: 1px solid @borderColor;\n\n    .icon {\n      visibility: visible !important;\n      cursor: pointer;\n    }\n  }\n}\n\nmain.PartnerInvoice .report {\n  height: calc(~\"100vh - \" @headerHeight + @footerHeight + 1px);\n\n  iframe {\n    margin-top: 1px;\n    border: none;\n    height: 100%;\n  }\n\n  #powerbi-container {\n    height: calc(~\"100% - 1px\");\n  }\n}\n","@import '{}/imports/client/styles/footer.import.less';\n\nmain.Addresses {\n\t.main-fixed-footer;\n}\n","@import '{}/imports/client/styles/colors.import.less';\n@import '{}/imports/client/styles/sizes.import.less';\n@import '{}/imports/client/styles/footer.import.less';\n@import '{}/imports/client/styles/sections.import.less';\n\nmain.Address {\n\t.aside-autohide-footer;\n\t.icon-sections;\n\n\t.map {\n\t\theight: 5 * @baseSize;\n\t\twidth: 100%;\n\t}\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n//@import \"{}/client/lib/semantic-ui/site/collections/table.variables.import.less\";\n\nmain.PriceList {\n  .main-fixed-footer;\n  #priceListModalContainer {\n    text-align: right;\n    padding-right: 27px;\n    padding-bottom: 15px;\n  }\n  .ui.segment {\n    box-shadow: none;\n  }\n\n  .header.row {\n    padding-top: 0;\n\n    .column {\n      &:extend(.ui.table thead th all);\n    }\n  }\n\n  .legend {\n    margin-top: @basePadding;\n    margin-bottom: @basePadding;\n    display: flex;\n\n    > div {\n      & + div {\n        margin-left: @basePadding;\n      }\n\n      .label {\n        margin-right: 0.5em;\n      }\n    }\n  }\n\n  // .volumes .table td {\n  //   vertical-align: top;\n  // }\n\n  .mainSubWrapper > aside {\n    img.partnerLogo {\n      width: auto;\n      height: auto;\n      max-height: 85px;\n      max-width: 240px;\n      margin-top: -60px;\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .ui.list {\n      li a {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 100%;\n        display: inline-block;\n      }\n    }\n  }\n}\n\nmain.PriceList section > .list > .item > .icon {\n  color: #3fa2f7;\n  font-size: 18px;\n  line-height: 14px;\n}\n\n.ui.list > .item > .icon + .content.full {\n  /*display: inherit;*/\n  width: 100%;\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n\n@colWidths: 80px;\n@colPadding: 9.6px + 4px;\n\nmain.PriceList .segment.rates {\n  @tabsHeight: 75px;\n  @veryPaddedSegmentPadding: 45px;\n  height: calc(\n    ~\"100vh - \" @headerHeight + @footerHeight + @tabsHeight + //2*@veryPaddedSegmentPadding +\n      @basePadding + 1px\n  );\n\n  // placeholder\n  .gridPlaceHolder {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    width: calc(~\"100%\" - 2 * @veryPaddedSegmentPadding);\n    height: calc(\n      ~\"100vh - \" @headerHeight + @footerHeight + @tabsHeight + 2 * @veryPaddedSegmentPadding +\n        @basePadding + 1px\n    );\n    justify-content: center;\n    text-align: center;\n  }\n}\n","@import \"{}/imports/client/styles/sections.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.PriceRequest {\n  .icon-sections;\n  .main-fixed-footer;\n\n  .analytics {\n    table.detail {\n      i {\n        color: #3fa2f7;\n      }\n\n      span.supsub {\n        sup {\n          position: relative;\n          top: -0.5em;\n        }\n\n        sub {\n          position: relative;\n          top: 0.5em;\n          left: -1.5em;\n          /* This will vary with font... */\n        }\n      }\n    }\n  }\n\n  .relative {\n    border: 1px solid transparent;\n\n    &.editable:hover {\n      border: 1px solid @borderColor;\n      cursor: pointer;\n\n      .icon {\n        visibility: visible !important;\n      }\n    }\n  }\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n\nmain.Analysis,\n.analysis-shipments-modal {\n  .cheaper {\n    color: #3fa2f7;\n  }\n}\n\nmain.Analysis {\n  .ui.steps {\n    min-height: @baseSize; // keep size while loading\n  }\n\n  .savings {\n    text-align: right;\n\n    > div {\n      margin-bottom: 0.5em;\n\n      .action.input {\n        > button {\n          min-width: 200px;\n          text-align: right;\n        }\n\n        > input {\n          width: 150px;\n        }\n      }\n    }\n\n    strong {\n      font-size: 0.8em;\n    }\n  }\n\n  .cost.details.tooltip {\n    &:after {\n      text-align: right;\n      min-width: 17em;\n    }\n  }\n\n  .segment.report {\n    @stepsHeight: @baseSize + 2 * @basePadding;\n    height: calc(~\"100vh - \" @headerHeight + @stepsHeight + @basePadding + 1px);\n    padding: 0;\n  }\n  .segment.data {\n    @stepsHeight: @baseSize + 2 * @basePadding;\n    min-height: calc(\n      ~\"100vh - \" @headerHeight + @stepsHeight + @basePadding + @footerHeight + 1px\n    );\n  }\n  .reportContainer {\n    height: calc(~\"100% - \" @tabsHeight);\n  }\n}\n","@import \"{}/imports/client/styles/colors.import.less\";\n@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/footer.import.less\";\n\nmain.Tender {\n  .icon-sections;\n  .main-fixed-footer;\n\n  // > div > div {\n  //   height: calc(~\"100% - \" @tabsHeight);\n  // }\n  .item.horizontal {\n    float: left;\n    margin-right: 30px;\n  }\n\n  .tabs + .container {\n    height: calc(~\"100% - \" @tabsHeight);\n  }\n\n  section .ui.form,\n  section .requirement,\n  section .milestone,\n  .intro {\n    .documents,\n    .button {\n      margin: 1em 0;\n    }\n\n    .clickable.card {\n      cursor: pointer;\n    }\n  }\n\n  .requirement,\n  .milestone {\n    cursor: pointer;\n\n    i {\n      font-weight: bold;\n      opacity: 0.5;\n      letter-spacing: -0.02em;\n    }\n  }\n\n  .requirement {\n    margin-bottom: 3em;\n  }\n\n  .requirements {\n    button,\n    h4 {\n      margin: 2em 0;\n    }\n\n    .response {\n      textarea,\n      .dropdown {\n        width: 300px;\n      }\n    }\n  }\n\n  .requirements,\n  .milestones {\n    .ui.form {\n      margin-top: 2em;\n    }\n  }\n\n  .milestone {\n    position: relative;\n    margin-left: 20px;\n    padding-left: 30px;\n    padding-bottom: 3em;\n\n    border-left: 1px solid tint(black, 85%);\n\n    > .icon {\n      position: absolute;\n      top: 0;\n      left: -15px;\n      //font-size: 24px;\n      background-color: white;\n      opacity: 1;\n      color: tint(black, 70%);\n    }\n\n    &.button,\n    &.button .icon {\n      color: @primaryColor;\n      cursor: pointer;\n    }\n\n    &:last-of-type {\n      border-left-color: transparent;\n    }\n  }\n\n  .partners {\n    button {\n      margin-top: 2em;\n    }\n  }\n\n  .profile {\n    .review-result {\n      margin-left: 0.5em;\n      color: tint(black, 70%);\n    }\n  }\n\n  .analysis {\n    height: 100%;\n\n    .powerbi {\n      height: 100%;\n\n      iframe {\n        border: none;\n        height: 100%;\n      }\n    }\n  }\n}\n","@import '{}/imports/client/styles/sizes.import.less';\n\nmain.Reporting {\n  >div>div {\n    height: 100%;\n  }\n\n  .ui.tabs.menu {\n    margin-bottom: 0;\n  }\n\n  .reportContainer {\n    height: calc(~\"100% - \"@tabsHeight );\n  }\n}","@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.DataExport {\n  .icon-sections;\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.ToolsOceanDistance {\n  .icon-sections;\n  .map {\n    height: 5 * @baseSize;\n    width: 100%;\n  }\n}\n","@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.ToolsRouteInsight {\n  .icon-sections;\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n@import \"{}/imports/client/styles/container.import.less\";\n\nmain.ToolsPriceLookup {\n  .icon-sections;\n}\n","@import \"{}/imports/client/styles/sizes.import.less\";\n@import \"{}/imports/client/styles/sections.import.less\";\n\nmain.Tenderify {\n  .icon-sections;\n\n  .segment.stretch {\n    @tabsHeight: 75px;\n    @veryPaddedSegmentPadding: 45px;\n    height: calc(\n      ~\"100vh - \" @headerHeight + @footerHeight + @tabsHeight + @basePadding + 1px\n    );\n  }\n\n  div.relative {\n    &.editable:hover {\n      .icon {\n        visibility: visible !important;\n        cursor: pointer;\n      }\n    }\n  }\n  td .relative {\n    padding: 0;\n  }\n\n  td.noTopPadding {\n    padding-top: 0 !important;\n  }\n}\n",".sidebar .tenderify-bidControl {\n  padding: @basePadding;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
